import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: string;
  DateTime: string;
  GenericScalar: any;
  JSONString: string;
  Upload: any;
};

/**
 * A locality on earth that is legally a valid destination for the residence
 * or place of business of the entity associated with it.
 */
export type Address = {
  __typename?: 'Address';
  city: Scalars['String'];
  country: Country;
  id: Scalars['String'];
  postcode: Scalars['String'];
  streetAddress: Scalars['String'];
};

export type AddressObject = {
  __typename?: 'AddressObject';
  city: Scalars['String'];
  country?: Maybe<GeographicCountry>;
  postcode: Scalars['String'];
  streetAddress: Scalars['String'];
};

export type AirwallexAuthorization = {
  __typename?: 'AirwallexAuthorization';
  authorizationCode: Scalars['String'];
  clientId: Scalars['String'];
  codeVerifier: Scalars['String'];
};

export type AppointmentType = {
  __typename?: 'AppointmentType';
  /** Type of appointment */
  appointmentType: ConsultationsAppointmentAppointmentTypeChoices;
  bookingLanguage?: Maybe<Scalars['String']>;
  calcomBookingUid?: Maybe<Scalars['String']>;
  canJoin?: Maybe<Scalars['Boolean']>;
  canReschedule?: Maybe<Scalars['Boolean']>;
  /** Consultation enrollment this appointment belongs to */
  consultationEnrollment?: Maybe<UserConsultationEnrollmentType>;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  meetingLink?: Maybe<Scalars['String']>;
  /** Program enrollment (for session appointments) */
  programEnrollment?: Maybe<UserProgramEnrollmentType>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  /** Application status (may differ from Cal.com status) */
  status: ConsultationsAppointmentStatusChoices;
  updatedAt: Scalars['DateTime'];
};

export type AreaCounts = {
  __typename?: 'AreaCounts';
  area: Scalars['String'];
  count: Scalars['Int'];
};

export type Article = {
  __typename?: 'Article';
  category?: Maybe<ArticleCategory>;
  excerpt: Scalars['String'];
  featuredImageUrl?: Maybe<Scalars['String']>;
  headerImageUrl: Scalars['String'];
  isFeatured: Scalars['Boolean'];
  rectangleThumbnailUrl: Scalars['String'];
  relatedArticles: Array<Maybe<Article>>;
  relatedCategories: Array<Maybe<ArticleCategory>>;
  slug: Scalars['String'];
  squareThumbnailUrl: Scalars['String'];
  text: Scalars['String'];
  title: Scalars['String'];
};

export type ArticleCategory = {
  __typename?: 'ArticleCategory';
  articles: Array<Maybe<Article>>;
  coverImageUrl: Scalars['String'];
  description: Scalars['String'];
  imageUrl: Scalars['String'];
  name: Scalars['String'];
  numArticles: Scalars['Int'];
  recommendationImageUrl: Scalars['String'];
  slug: Scalars['String'];
  subtitle: Scalars['String'];
};

export type ArticleOrCategory = {
  __typename?: 'ArticleOrCategory';
  article?: Maybe<Article>;
  category?: Maybe<ArticleCategory>;
};

export type ArticleRecommendation = {
  __typename?: 'ArticleRecommendation';
  /** Article ID or Segment slug */
  idOrSlug: Scalars['String'];
  /** Article or Segment */
  itemType: Scalars['String'];
};

/** Individual question-answer pair within an assessment. */
export type AssessmentReplyType = {
  __typename?: 'AssessmentReplyType';
  /** The answer provided by the user */
  answer: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** The full question text */
  question: Scalars['String'];
  /** Group or category for organizing related questions */
  questionGroup: Scalars['String'];
};

/** Container for assessment replies. */
export type AssessmentType = {
  __typename?: 'AssessmentType';
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  replies?: Maybe<Array<Maybe<AssessmentReplyType>>>;
  updatedAt: Scalars['DateTime'];
};

export type AuthStatus = {
  __typename?: 'AuthStatus';
  application: Scalars['String'];
  clientMutationId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['Int']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  isEmailConfirmed?: Maybe<Scalars['Boolean']>;
  loggedInBy?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  password: Scalars['String'];
  showMemberPromotion?: Maybe<Scalars['Boolean']>;
  username: Scalars['String'];
};

export type AuthStatusInput = {
  application: Scalars['String'];
  clientMutationId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};

export type BankAccountDetailsType = {
  __typename?: 'BankAccountDetailsType';
  accountHolderName: Scalars['String'];
  /** IBAN or account number */
  accountNumber: Scalars['String'];
  /** Type of bank account, e.g. Savings or Current. */
  accountType?: Maybe<CoreBankAccountDetailsAccountTypeChoices>;
  bankName: Scalars['String'];
  country: GeographicCountry;
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  localFields?: Maybe<Scalars['JSONString']>;
  member: Member;
  /** BIC or SWIFT code */
  swiftCode?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

/**
 * A single country-specific bank field definition.
 *
 * Used to drive dynamic form rendering on the front-end so a new country
 * can be added without a front-end deploy.
 */
export type BankFieldSpecType = {
  __typename?: 'BankFieldSpecType';
  helpText?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  name: Scalars['String'];
  required: Scalars['Boolean'];
};

/** The bank-fields schema for a given country. */
export type BankFieldsSchemaType = {
  __typename?: 'BankFieldsSchemaType';
  countryCode: Scalars['String'];
  fields: Array<BankFieldSpecType>;
  swiftRequired: Scalars['Boolean'];
};

export type BookingWindowStatusType = {
  __typename?: 'BookingWindowStatusType';
  endDate?: Maybe<Scalars['Date']>;
  isBookable?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['Date']>;
  windowStatus?: Maybe<Scalars['String']>;
};

export type BudgetProgressBar = {
  __typename?: 'BudgetProgressBar';
  green: DineroType;
  white: DineroType;
  yellow: DineroType;
};

/** A virtual card issued by Pliant. */
export type Card = {
  __typename?: 'Card';
  expiryDate?: Maybe<Scalars['Date']>;
  id: Scalars['Int'];
  maskedCardNumber: Scalars['String'];
  status: Scalars['String'];
  widgetUrl: Scalars['String'];
};

/** Change the member's preferred language. */
export type ChangeLanguage = {
  __typename?: 'ChangeLanguage';
  dictionary?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type ChangePreferences = {
  __typename?: 'ChangePreferences';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

export type CityType = {
  __typename?: 'CityType';
  city: Scalars['String'];
  count: Scalars['Int'];
};

export type ClaimDocumentObject = {
  __typename?: 'ClaimDocumentObject';
  /** Amount awarded by member for this document. */
  awardedAmount?: Maybe<MoneyObject>;
  awardedAmountCurrency?: Maybe<CoreReimbursementClaimDocumentAwardedAmountCurrencyChoices>;
  claim: ReimbursementRequest;
  crawfordDescription?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  description: Scalars['String'];
  docType: Scalars['String'];
  /** Domestic or Foreign Treatment. */
  domesticOrForeign?: Maybe<Scalars['String']>;
  eligibility?: Maybe<Scalars['Boolean']>;
  evidence?: Maybe<Scalars['String']>;
  file: Scalars['String'];
  fileName: Scalars['String'];
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  invoiceAnalysisJob?: Maybe<InvoiceAnalysisJob>;
  invoiceDate?: Maybe<Scalars['Date']>;
  notes?: Maybe<Scalars['String']>;
  paymentDate?: Maybe<Scalars['Date']>;
  paymentMethod?: Maybe<Scalars['String']>;
  provider?: Maybe<Scalars['String']>;
  reasonForDecision?: Maybe<Scalars['String']>;
  /** Amount requested by member for this document. */
  requestedAmount?: Maybe<MoneyObject>;
  requestedAmountCurrency?: Maybe<CoreReimbursementClaimDocumentRequestedAmountCurrencyChoices>;
  treatmentDate?: Maybe<Scalars['Date']>;
  treatmentType?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ClaimDocumentType = {
  __typename?: 'ClaimDocumentType';
  dropdownOrder: Scalars['Int'];
  id: Scalars['ID'];
  reimbursementclaimdocumentSet: Array<ClaimDocumentObject>;
  typeName: Scalars['String'];
};

export type ClinicSpecialty = {
  __typename?: 'ClinicSpecialty';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ClinicSpecialtyCounts = {
  __typename?: 'ClinicSpecialtyCounts';
  count: Scalars['Int'];
  specialty: Scalars['String'];
};

export type ClinicsAdditionalContact = {
  __typename?: 'ClinicsAdditionalContact';
  name: Scalars['String'];
};

/** A company, our customers. */
export type Company = {
  __typename?: 'Company';
  id: Scalars['String'];
  /** Is this company for testing purposes only? */
  isTestCompany: Scalars['Boolean'];
  name: Scalars['String'];
};

/** Complete onboarding questionnaire and store responses as structured Assessment. */
export type CompleteOnboardingQuestionnaire = {
  __typename?: 'CompleteOnboardingQuestionnaire';
  enrollment?: Maybe<UserConsultationEnrollmentType>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * Confirms private email
 *
 * Returns ``success=False`` with the following error codes on failure:
 *
 * - ``token-expired``: Token has expired: we should prompt to get a new one.
 * - ``token-invalid``: Token is invalid: we should provide support (email was
 *   incorrectly breaking / mangling the link or MITM attack.
 * - ``user-not-logged-in``: User is not logged in or the logged is not the
 *   same as the member account with the confirmed private email
 *
 * Return ``success=True`` otherwise and sets private_email_confirmed on the
 * member.
 */
export type ConfirmPrivateEmail = {
  __typename?: 'ConfirmPrivateEmail';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** Consultation with localized content from database. */
export type ConsultationType = {
  __typename?: 'ConsultationType';
  canEnrollInPrograms?: Maybe<Scalars['Boolean']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isEnrolled?: Maybe<Scalars['Boolean']>;
  myEnrollment?: Maybe<UserConsultationEnrollmentType>;
  onboardingButtonText?: Maybe<Scalars['String']>;
  onboardingCalcomEventType?: Maybe<Scalars['String']>;
  onboardingCallCompleted?: Maybe<Scalars['Boolean']>;
  /** Managed in Contentful - If true, user must complete onboarding call before program enrollment */
  onboardingCallRequired: Scalars['Boolean'];
  onboardingDescription?: Maybe<Scalars['String']>;
  onboardingQuestionnaireCompleted?: Maybe<Scalars['Boolean']>;
  /** Managed in Contentful - If true, user must complete onboarding questionnaire before program enrollment */
  onboardingQuestionnaireRequired: Scalars['Boolean'];
  onboardingTitle?: Maybe<Scalars['String']>;
  /** Managed in Contentful */
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type Consultations = {
  __typename?: 'Consultations';
  consultation?: Maybe<ConsultationType>;
  consultations?: Maybe<Array<Maybe<ConsultationType>>>;
  myAppointments?: Maybe<Array<Maybe<AppointmentType>>>;
  myConsultationEnrollments?: Maybe<Array<Maybe<UserConsultationEnrollmentType>>>;
  myProgramEnrollments?: Maybe<Array<Maybe<UserProgramEnrollmentType>>>;
  program?: Maybe<ProgramType>;
  programs?: Maybe<Array<Maybe<ProgramType>>>;
  session?: Maybe<SessionType>;
  sessionBookingParams?: Maybe<SessionBookingParamsType>;
};


export type ConsultationsConsultationArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type ConsultationsMyAppointmentsArgs = {
  appointmentType?: InputMaybe<Scalars['String']>;
};


export type ConsultationsProgramArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type ConsultationsSessionArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type ConsultationsSessionBookingParamsArgs = {
  sessionId: Scalars['Int'];
};

/** An enumeration. */
export enum ConsultationsAppointmentAppointmentTypeChoices {
  /** Consultation Onboarding */
  ConsultationOnboarding = 'CONSULTATION_ONBOARDING',
  /** Program Session */
  ProgramSession = 'PROGRAM_SESSION'
}

/** An enumeration. */
export enum ConsultationsAppointmentStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Rescheduled */
  Rescheduled = 'RESCHEDULED',
  /** Scheduled */
  Scheduled = 'SCHEDULED'
}

/** An enumeration. */
export enum ConsultationsProgramBookingStrategyChoices {
  /** On-Demand Booking */
  OnDemand = 'ON_DEMAND',
  /** Pre-book All Sessions */
  PreBookAll = 'PRE_BOOK_ALL',
  /** Time-Gated Booking */
  TimeGated = 'TIME_GATED'
}

/** An enumeration. */
export enum ConsultationsUserConsultationEnrollmentStatusChoices {
  /** Active */
  Active = 'ACTIVE',
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED'
}

/** An enumeration. */
export enum ConsultationsUserProgramEnrollmentStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Completed */
  Completed = 'COMPLETED',
  /** Enrolled */
  Enrolled = 'ENROLLED',
  /** In Progress */
  InProgress = 'IN_PROGRESS'
}

export type Contract = {
  __typename?: 'Contract';
  aspiringPeriodDescription: Scalars['String'];
  budgetPerMember?: Maybe<DineroType>;
  countryCode: Scalars['String'];
  enableWallets: Scalars['Boolean'];
  hasBudget: Scalars['Boolean'];
  id: Scalars['ID'];
  reimbursementMode?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum CoreApplicationConfigEntryDataTypeChoices {
  /** One or more words */
  Char = 'CHAR',
  /** Date */
  Date = 'DATE',
  /** Time stamp */
  Datetime = 'DATETIME',
  /** Decimal number */
  Decimal = 'DECIMAL',
  /** Integer number */
  Integer = 'INTEGER',
  /** One or more paragraphs */
  Text = 'TEXT'
}

/** An enumeration. */
export enum CoreBankAccountDetailsAccountTypeChoices {
  /** Current Account */
  Current = 'CURRENT',
  /** Savings Account */
  Savings = 'SAVINGS'
}

/** An enumeration. */
export enum CoreReimbursementClaimDocumentAwardedAmountCurrencyChoices {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR'
}

/** An enumeration. */
export enum CoreReimbursementClaimDocumentRequestedAmountCurrencyChoices {
  /** Andorran Peseta */
  Adp = 'ADP',
  /** United Arab Emirates Dirham */
  Aed = 'AED',
  /** Afghan Afghani (1927–2002) */
  Afa = 'AFA',
  /** Afghan Afghani */
  Afn = 'AFN',
  /** Albanian Lek (1946–1965) */
  Alk = 'ALK',
  /** Albanian Lek */
  All = 'ALL',
  /** Armenian Dram */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder */
  Ang = 'ANG',
  /** Angolan Kwanza */
  Aoa = 'AOA',
  /** Angolan Kwanza (1977–1991) */
  Aok = 'AOK',
  /** Angolan New Kwanza (1990–2000) */
  Aon = 'AON',
  /** Angolan Readjusted Kwanza (1995–1999) */
  Aor = 'AOR',
  /** Argentine Austral */
  Ara = 'ARA',
  /** Argentine Peso Ley (1970–1983) */
  Arl = 'ARL',
  /** Argentine Peso (1881–1970) */
  Arm = 'ARM',
  /** Argentine Peso (1983–1985) */
  Arp = 'ARP',
  /** Argentine Peso */
  Ars = 'ARS',
  /** Austrian Schilling */
  Ats = 'ATS',
  /** Australian Dollar */
  Aud = 'AUD',
  /** Aruban Florin */
  Awg = 'AWG',
  /** Azerbaijani Manat (1993–2006) */
  Azm = 'AZM',
  /** Azerbaijani Manat */
  Azn = 'AZN',
  /** Bosnia-Herzegovina Dinar (1992–1994) */
  Bad = 'BAD',
  /** Bosnia-Herzegovina Convertible Mark */
  Bam = 'BAM',
  /** Bosnia-Herzegovina New Dinar (1994–1997) */
  Ban = 'BAN',
  /** Barbadian Dollar */
  Bbd = 'BBD',
  /** Bangladeshi Taka */
  Bdt = 'BDT',
  /** Belgian Franc (convertible) */
  Bec = 'BEC',
  /** Belgian Franc */
  Bef = 'BEF',
  /** Belgian Franc (financial) */
  Bel = 'BEL',
  /** Bulgarian Hard Lev */
  Bgl = 'BGL',
  /** Bulgarian Socialist Lev */
  Bgm = 'BGM',
  /** Bulgarian Lev */
  Bgn = 'BGN',
  /** Bulgarian Lev (1879–1952) */
  Bgo = 'BGO',
  /** Bahraini Dinar */
  Bhd = 'BHD',
  /** Burundian Franc */
  Bif = 'BIF',
  /** Bermudan Dollar */
  Bmd = 'BMD',
  /** Brunei Dollar */
  Bnd = 'BND',
  /** Bolivian Boliviano */
  Bob = 'BOB',
  /** Bolivian Boliviano (1863–1963) */
  Bol = 'BOL',
  /** Bolivian Peso */
  Bop = 'BOP',
  /** Bolivian Mvdol */
  Bov = 'BOV',
  /** Brazilian New Cruzeiro (1967–1986) */
  Brb = 'BRB',
  /** Brazilian Cruzado (1986–1989) */
  Brc = 'BRC',
  /** Brazilian Cruzeiro (1990–1993) */
  Bre = 'BRE',
  /** Brazilian Real */
  Brl = 'BRL',
  /** Brazilian New Cruzado (1989–1990) */
  Brn = 'BRN',
  /** Brazilian Cruzeiro (1993–1994) */
  Brr = 'BRR',
  /** Brazilian Cruzeiro (1942–1967) */
  Brz = 'BRZ',
  /** Bahamian Dollar */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum */
  Btn = 'BTN',
  /** Burmese Kyat */
  Buk = 'BUK',
  /** Botswanan Pula */
  Bwp = 'BWP',
  /** Belarusian Ruble (1994–1999) */
  Byb = 'BYB',
  /** Belarusian Ruble */
  Byn = 'BYN',
  /** Belarusian Ruble (2000–2016) */
  Byr = 'BYR',
  /** Belize Dollar */
  Bzd = 'BZD',
  /** Canadian Dollar */
  Cad = 'CAD',
  /** Congolese Franc */
  Cdf = 'CDF',
  /** WIR Euro */
  Che = 'CHE',
  /** Swiss Franc */
  Chf = 'CHF',
  /** WIR Franc */
  Chw = 'CHW',
  /** Chilean Escudo */
  Cle = 'CLE',
  /** Chilean Unit of Account (UF) */
  Clf = 'CLF',
  /** Chilean Peso */
  Clp = 'CLP',
  /** Chinese Yuan (offshore) */
  Cnh = 'CNH',
  /** Chinese People’s Bank Dollar */
  Cnx = 'CNX',
  /** Chinese Yuan */
  Cny = 'CNY',
  /** Colombian Peso */
  Cop = 'COP',
  /** Colombian Real Value Unit */
  Cou = 'COU',
  /** Costa Rican Colón */
  Crc = 'CRC',
  /** Serbian Dinar (2002–2006) */
  Csd = 'CSD',
  /** Czechoslovak Hard Koruna */
  Csk = 'CSK',
  /** Cuban Convertible Peso */
  Cuc = 'CUC',
  /** Cuban Peso */
  Cup = 'CUP',
  /** Cape Verdean Escudo */
  Cve = 'CVE',
  /** Cypriot Pound */
  Cyp = 'CYP',
  /** Czech Koruna */
  Czk = 'CZK',
  /** East German Mark */
  Ddm = 'DDM',
  /** German Mark */
  Dem = 'DEM',
  /** Djiboutian Franc */
  Djf = 'DJF',
  /** Danish Krone */
  Dkk = 'DKK',
  /** Dominican Peso */
  Dop = 'DOP',
  /** Algerian Dinar */
  Dzd = 'DZD',
  /** Ecuadorian Sucre */
  Ecs = 'ECS',
  /** Ecuadorian Unit of Constant Value */
  Ecv = 'ECV',
  /** Estonian Kroon */
  Eek = 'EEK',
  /** Egyptian Pound */
  Egp = 'EGP',
  /** Eritrean Nakfa */
  Ern = 'ERN',
  /** Spanish Peseta (A account) */
  Esa = 'ESA',
  /** Spanish Peseta (convertible account) */
  Esb = 'ESB',
  /** Spanish Peseta */
  Esp = 'ESP',
  /** Ethiopian Birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Finnish Markka */
  Fim = 'FIM',
  /** Fijian Dollar */
  Fjd = 'FJD',
  /** Falkland Islands Pound */
  Fkp = 'FKP',
  /** French Franc */
  Frf = 'FRF',
  /** British Pound */
  Gbp = 'GBP',
  /** Georgian Kupon Larit */
  Gek = 'GEK',
  /** Georgian Lari */
  Gel = 'GEL',
  /** Ghanaian Cedi (1979–2007) */
  Ghc = 'GHC',
  /** Ghanaian Cedi */
  Ghs = 'GHS',
  /** Gibraltar Pound */
  Gip = 'GIP',
  /** Gambian Dalasi */
  Gmd = 'GMD',
  /** Guinean Franc */
  Gnf = 'GNF',
  /** Guinean Syli */
  Gns = 'GNS',
  /** Equatorial Guinean Ekwele */
  Gqe = 'GQE',
  /** Greek Drachma */
  Grd = 'GRD',
  /** Guatemalan Quetzal */
  Gtq = 'GTQ',
  /** Portuguese Guinea Escudo */
  Gwe = 'GWE',
  /** Guinea-Bissau Peso */
  Gwp = 'GWP',
  /** Guyanaese Dollar */
  Gyd = 'GYD',
  /** Hong Kong Dollar */
  Hkd = 'HKD',
  /** Honduran Lempira */
  Hnl = 'HNL',
  /** Croatian Dinar */
  Hrd = 'HRD',
  /** Croatian Kuna */
  Hrk = 'HRK',
  /** Haitian Gourde */
  Htg = 'HTG',
  /** Hungarian Forint */
  Huf = 'HUF',
  /** Indonesian Rupiah */
  Idr = 'IDR',
  /** Irish Pound */
  Iep = 'IEP',
  /** Israeli Pound */
  Ilp = 'ILP',
  /** Israeli Shekel (1980–1985) */
  Ilr = 'ILR',
  /** Israeli New Shekel */
  Ils = 'ILS',
  /** IMP */
  Imp = 'IMP',
  /** Indian Rupee */
  Inr = 'INR',
  /** Iraqi Dinar */
  Iqd = 'IQD',
  /** Iranian Rial */
  Irr = 'IRR',
  /** Icelandic Króna (1918–1981) */
  Isj = 'ISJ',
  /** Icelandic Króna */
  Isk = 'ISK',
  /** Italian Lira */
  Itl = 'ITL',
  /** Jamaican Dollar */
  Jmd = 'JMD',
  /** Jordanian Dinar */
  Jod = 'JOD',
  /** Japanese Yen */
  Jpy = 'JPY',
  /** Kenyan Shilling */
  Kes = 'KES',
  /** Kyrgystani Som */
  Kgs = 'KGS',
  /** Cambodian Riel */
  Khr = 'KHR',
  /** Comorian Franc */
  Kmf = 'KMF',
  /** North Korean Won */
  Kpw = 'KPW',
  /** South Korean Hwan (1953–1962) */
  Krh = 'KRH',
  /** South Korean Won (1945–1953) */
  Kro = 'KRO',
  /** South Korean Won */
  Krw = 'KRW',
  /** Kuwaiti Dinar */
  Kwd = 'KWD',
  /** Cayman Islands Dollar */
  Kyd = 'KYD',
  /** Kazakhstani Tenge */
  Kzt = 'KZT',
  /** Laotian Kip */
  Lak = 'LAK',
  /** Lebanese Pound */
  Lbp = 'LBP',
  /** Sri Lankan Rupee */
  Lkr = 'LKR',
  /** Liberian Dollar */
  Lrd = 'LRD',
  /** Lesotho Loti */
  Lsl = 'LSL',
  /** Lithuanian Litas */
  Ltl = 'LTL',
  /** Lithuanian Talonas */
  Ltt = 'LTT',
  /** Luxembourgian Convertible Franc */
  Luc = 'LUC',
  /** Luxembourgian Franc */
  Luf = 'LUF',
  /** Luxembourg Financial Franc */
  Lul = 'LUL',
  /** Latvian Lats */
  Lvl = 'LVL',
  /** Latvian Ruble */
  Lvr = 'LVR',
  /** Libyan Dinar */
  Lyd = 'LYD',
  /** Moroccan Dirham */
  Mad = 'MAD',
  /** Moroccan Franc */
  Maf = 'MAF',
  /** Monegasque Franc */
  Mcf = 'MCF',
  /** Moldovan Cupon */
  Mdc = 'MDC',
  /** Moldovan Leu */
  Mdl = 'MDL',
  /** Malagasy Ariary */
  Mga = 'MGA',
  /** Malagasy Franc */
  Mgf = 'MGF',
  /** Macedonian Denar */
  Mkd = 'MKD',
  /** Macedonian Denar (1992–1993) */
  Mkn = 'MKN',
  /** Malian Franc */
  Mlf = 'MLF',
  /** Myanmar Kyat */
  Mmk = 'MMK',
  /** Mongolian Tugrik */
  Mnt = 'MNT',
  /** Macanese Pataca */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (1973–2017) */
  Mro = 'MRO',
  /** Mauritanian Ouguiya */
  Mru = 'MRU',
  /** Maltese Lira */
  Mtl = 'MTL',
  /** Maltese Pound */
  Mtp = 'MTP',
  /** Mauritian Rupee */
  Mur = 'MUR',
  /** Maldivian Rupee (1947–1981) */
  Mvp = 'MVP',
  /** Maldivian Rufiyaa */
  Mvr = 'MVR',
  /** Malawian Kwacha */
  Mwk = 'MWK',
  /** Mexican Peso */
  Mxn = 'MXN',
  /** Mexican Silver Peso (1861–1992) */
  Mxp = 'MXP',
  /** Mexican Investment Unit */
  Mxv = 'MXV',
  /** Malaysian Ringgit */
  Myr = 'MYR',
  /** Mozambican Escudo */
  Mze = 'MZE',
  /** Mozambican Metical (1980–2006) */
  Mzm = 'MZM',
  /** Mozambican Metical */
  Mzn = 'MZN',
  /** Namibian Dollar */
  Nad = 'NAD',
  /** Nigerian Naira */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (1988–1991) */
  Nic = 'NIC',
  /** Nicaraguan Córdoba */
  Nio = 'NIO',
  /** Dutch Guilder */
  Nlg = 'NLG',
  /** Norwegian Krone */
  Nok = 'NOK',
  /** Nepalese Rupee */
  Npr = 'NPR',
  /** New Zealand Dollar */
  Nzd = 'NZD',
  /** Omani Rial */
  Omr = 'OMR',
  /** Panamanian Balboa */
  Pab = 'PAB',
  /** Peruvian Inti */
  Pei = 'PEI',
  /** Peruvian Sol */
  Pen = 'PEN',
  /** Peruvian Sol (1863–1965) */
  Pes = 'PES',
  /** Papua New Guinean Kina */
  Pgk = 'PGK',
  /** Philippine Peso */
  Php = 'PHP',
  /** Pakistani Rupee */
  Pkr = 'PKR',
  /** Polish Zloty */
  Pln = 'PLN',
  /** Polish Zloty (1950–1995) */
  Plz = 'PLZ',
  /** Portuguese Escudo */
  Pte = 'PTE',
  /** Paraguayan Guarani */
  Pyg = 'PYG',
  /** Qatari Riyal */
  Qar = 'QAR',
  /** Rhodesian Dollar */
  Rhd = 'RHD',
  /** Romanian Leu (1952–2006) */
  Rol = 'ROL',
  /** Romanian Leu */
  Ron = 'RON',
  /** Serbian Dinar */
  Rsd = 'RSD',
  /** Russian Ruble */
  Rub = 'RUB',
  /** Russian Ruble (1991–1998) */
  Rur = 'RUR',
  /** Rwandan Franc */
  Rwf = 'RWF',
  /** Saudi Riyal */
  Sar = 'SAR',
  /** Solomon Islands Dollar */
  Sbd = 'SBD',
  /** Seychellois Rupee */
  Scr = 'SCR',
  /** Sudanese Dinar (1992–2007) */
  Sdd = 'SDD',
  /** Sudanese Pound */
  Sdg = 'SDG',
  /** Sudanese Pound (1957–1998) */
  Sdp = 'SDP',
  /** Swedish Krona */
  Sek = 'SEK',
  /** Singapore Dollar */
  Sgd = 'SGD',
  /** St. Helena Pound */
  Shp = 'SHP',
  /** Slovenian Tolar */
  Sit = 'SIT',
  /** Slovak Koruna */
  Skk = 'SKK',
  /** Sierra Leonean Leone */
  Sle = 'SLE',
  /** Sierra Leonean Leone (1964—2022) */
  Sll = 'SLL',
  /** Somali Shilling */
  Sos = 'SOS',
  /** Surinamese Dollar */
  Srd = 'SRD',
  /** Surinamese Guilder */
  Srg = 'SRG',
  /** South Sudanese Pound */
  Ssp = 'SSP',
  /** São Tomé & Príncipe Dobra (1977–2017) */
  Std = 'STD',
  /** São Tomé & Príncipe Dobra */
  Stn = 'STN',
  /** Soviet Rouble */
  Sur = 'SUR',
  /** Salvadoran Colón */
  Svc = 'SVC',
  /** Syrian Pound */
  Syp = 'SYP',
  /** Swazi Lilangeni */
  Szl = 'SZL',
  /** Thai Baht */
  Thb = 'THB',
  /** Tajikistani Ruble */
  Tjr = 'TJR',
  /** Tajikistani Somoni */
  Tjs = 'TJS',
  /** Turkmenistani Manat (1993–2009) */
  Tmm = 'TMM',
  /** Turkmenistani Manat */
  Tmt = 'TMT',
  /** Tunisian Dinar */
  Tnd = 'TND',
  /** Tongan Paʻanga */
  Top = 'TOP',
  /** Timorese Escudo */
  Tpe = 'TPE',
  /** Turkish Lira (1922–2005) */
  Trl = 'TRL',
  /** Turkish Lira */
  Try = 'TRY',
  /** Trinidad & Tobago Dollar */
  Ttd = 'TTD',
  /** TVD */
  Tvd = 'TVD',
  /** New Taiwan Dollar */
  Twd = 'TWD',
  /** Tanzanian Shilling */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia */
  Uah = 'UAH',
  /** Ukrainian Karbovanets */
  Uak = 'UAK',
  /** Ugandan Shilling (1966–1987) */
  Ugs = 'UGS',
  /** Ugandan Shilling */
  Ugx = 'UGX',
  /** US Dollar */
  Usd = 'USD',
  /** US Dollar (Next day) */
  Usn = 'USN',
  /** US Dollar (Same day) */
  Uss = 'USS',
  /** Uruguayan Peso (Indexed Units) */
  Uyi = 'UYI',
  /** Uruguayan Peso (1975–1993) */
  Uyp = 'UYP',
  /** Uruguayan Peso */
  Uyu = 'UYU',
  /** Uruguayan Nominal Wage Index Unit */
  Uyw = 'UYW',
  /** Uzbekistani Som */
  Uzs = 'UZS',
  /** Venezuelan Bolívar (1871–2008) */
  Veb = 'VEB',
  /** Bolívar Soberano */
  Ved = 'VED',
  /** Venezuelan Bolívar (2008–2018) */
  Vef = 'VEF',
  /** Venezuelan Bolívar */
  Ves = 'VES',
  /** Vietnamese Dong */
  Vnd = 'VND',
  /** Vietnamese Dong (1978–1985) */
  Vnn = 'VNN',
  /** Vanuatu Vatu */
  Vuv = 'VUV',
  /** Samoan Tala */
  Wst = 'WST',
  /** Central African CFA Franc */
  Xaf = 'XAF',
  /** Silver */
  Xag = 'XAG',
  /** Gold */
  Xau = 'XAU',
  /** European Composite Unit */
  Xba = 'XBA',
  /** European Monetary Unit */
  Xbb = 'XBB',
  /** European Unit of Account (XBC) */
  Xbc = 'XBC',
  /** European Unit of Account (XBD) */
  Xbd = 'XBD',
  /** East Caribbean Dollar */
  Xcd = 'XCD',
  /** Special Drawing Rights */
  Xdr = 'XDR',
  /** European Currency Unit */
  Xeu = 'XEU',
  /** French Gold Franc */
  Xfo = 'XFO',
  /** French UIC-Franc */
  Xfu = 'XFU',
  /** West African CFA Franc */
  Xof = 'XOF',
  /** Palladium */
  Xpd = 'XPD',
  /** CFP Franc */
  Xpf = 'XPF',
  /** Platinum */
  Xpt = 'XPT',
  /** RINET Funds */
  Xre = 'XRE',
  /** Sucre */
  Xsu = 'XSU',
  /** Testing Currency Code */
  Xts = 'XTS',
  /** ADB Unit of Account */
  Xua = 'XUA',
  /** Yemeni Dinar */
  Ydd = 'YDD',
  /** Yemeni Rial */
  Yer = 'YER',
  /** Yugoslavian Hard Dinar (1966–1990) */
  Yud = 'YUD',
  /** Yugoslavian New Dinar (1994–2002) */
  Yum = 'YUM',
  /** Yugoslavian Convertible Dinar (1990–1992) */
  Yun = 'YUN',
  /** Yugoslavian Reformed Dinar (1992–1993) */
  Yur = 'YUR',
  /** South African Rand (financial) */
  Zal = 'ZAL',
  /** South African Rand */
  Zar = 'ZAR',
  /** Zambian Kwacha (1968–2012) */
  Zmk = 'ZMK',
  /** Zambian Kwacha */
  Zmw = 'ZMW',
  /** Zairean New Zaire (1993–1998) */
  Zrn = 'ZRN',
  /** Zairean Zaire (1971–1993) */
  Zrz = 'ZRZ',
  /** Zimbabwean Dollar (1980–2008) */
  Zwd = 'ZWD',
  /** Zimbabwean Dollar (2009–2024) */
  Zwl = 'ZWL',
  /** ZWN */
  Zwn = 'ZWN',
  /** Zimbabwean Dollar (2008) */
  Zwr = 'ZWR'
}

export type Country = {
  __typename?: 'Country';
  /** ISO 3166-1 three character country code */
  alpha3?: Maybe<Scalars['String']>;
  /** ISO 3166-1 two character country code */
  code?: Maybe<Scalars['String']>;
  /** International Olympic Committee country code */
  iocCode?: Maybe<Scalars['String']>;
  /** Country name */
  name?: Maybe<Scalars['String']>;
  /** ISO 3166-1 numeric country code */
  numeric?: Maybe<Scalars['Int']>;
};

/** A country in the context of coverage. */
export type CountryInCoverage = {
  __typename?: 'CountryInCoverage';
  /** The ISO 3166-1 two-letter code of the country. */
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  treatments: Array<Maybe<TreatmentInCoverage>>;
};

/** A country on the Navigator map that can be clicked on. */
export type CountryInNavigator = {
  __typename?: 'CountryInNavigator';
  /** The ISO 3166-1 two-letter code of the country. */
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  provinces: Array<Maybe<Scalars['String']>>;
};

/** Country of Employment for a given member. */
export type CountryOfEmployment = {
  __typename?: 'CountryOfEmployment';
  country: Country;
  id: Scalars['String'];
};

export type CountryType = {
  __typename?: 'CountryType';
  /** ISO 3166-1 three character country code */
  alpha3?: Maybe<Scalars['String']>;
  /** ISO 3166-1 two character country code */
  code?: Maybe<Scalars['String']>;
  /** International Olympic Committee country code */
  iocCode?: Maybe<Scalars['String']>;
  /** Country name */
  name?: Maybe<Scalars['String']>;
  /** ISO 3166-1 numeric country code */
  numeric?: Maybe<Scalars['Int']>;
  /** Province name */
  province?: Maybe<Scalars['String']>;
};

/** The query fields in the coverage namespace. */
export type Coverage = {
  __typename?: 'Coverage';
  countries: Array<Maybe<CountryInCoverage>>;
  settings: Array<Maybe<SettingInCoverage>>;
};


/** The query fields in the coverage namespace. */
export type CoverageCountriesArgs = {
  countryCode?: InputMaybe<Scalars['String']>;
};

export type CreateAccount = {
  __typename?: 'CreateAccount';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

export type CreateAirwallexBeneficiary = {
  __typename?: 'CreateAirwallexBeneficiary';
  beneficiaryId?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/**
 * Create or update a reimbursement claim as part of the new claims flow.
 * When id is omitted a new claim is created; when id is supplied the existing
 * open claim is updated and its documents are fully replaced.
 */
export type CreateReimbursementClaim = {
  __typename?: 'CreateReimbursementClaim';
  claimId?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  reimbursementRequest?: Maybe<ReimbursementRequest>;
  success: Scalars['Boolean'];
};

/** A currency. */
export type CurrencyObject = {
  __typename?: 'CurrencyObject';
  /** The ISO 4217 three-letter code of the currency. */
  code: Scalars['String'];
  name: Scalars['String'];
};

/**
 * Implementation of the custom Help button
 *
 * Routes emails to a support email address
 */
export type CustomSupportRequest = {
  __typename?: 'CustomSupportRequest';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** Money as currency + amount in integer value of currency sub unit. */
export type DineroType = {
  __typename?: 'DineroType';
  amount: Scalars['Int'];
  currency: Scalars['String'];
};

/** Cancel a member's active program enrollment. */
export type DropOutOfProgram = {
  __typename?: 'DropOutOfProgram';
  enrollment?: Maybe<UserProgramEnrollmentType>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/**
 * DEPRECATED: Consultation enrollments are now created automatically.
 * This mutation remains for backward compatibility but just calls ensure_for_user.
 */
export type EnrollInConsultation = {
  __typename?: 'EnrollInConsultation';
  enrollment?: Maybe<UserConsultationEnrollmentType>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

/** Enroll user in a program. */
export type EnrollInProgram = {
  __typename?: 'EnrollInProgram';
  enrollment?: Maybe<UserProgramEnrollmentType>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type FaqEntry = {
  __typename?: 'FaqEntry';
  answer: Scalars['String'];
  question: Scalars['String'];
};

export type FaqSection = {
  __typename?: 'FaqSection';
  entries: Array<Maybe<FaqEntry>>;
  title: Scalars['String'];
};

export type FertilityClinicPage = {
  __typename?: 'FertilityClinicPage';
  objects?: Maybe<Array<Maybe<FertilityClinicType>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type FertilityClinicSocialMedia = {
  __typename?: 'FertilityClinicSocialMedia';
  handle: Scalars['String'];
  service: Scalars['String'];
};

/** A clinic that is providing fertility services. */
export type FertilityClinicType = {
  __typename?: 'FertilityClinicType';
  additionalContactInfo?: Maybe<Scalars['String']>;
  address: Scalars['String'];
  area: Scalars['String'];
  city: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  gradeRating?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isPartnerClinic: Scalars['Boolean'];
  localAddress: Scalars['String'];
  localName: Scalars['String'];
  medalRating: Scalars['Boolean'];
  name: Scalars['String'];
  partnerClinicDiscountText?: Maybe<Scalars['String']>;
  partnershipBenefits: Array<Maybe<PartnershipBenefit>>;
  phone?: Maybe<Scalars['String']>;
  postalCode: Scalars['String'];
  socialMedia: Array<Maybe<FertilityClinicSocialMedia>>;
  specialties: Array<Maybe<ClinicSpecialty>>;
  starRating?: Maybe<Scalars['Int']>;
  treatments: Array<Maybe<FertilityTreatment>>;
  website: Scalars['String'];
};

export type FertilityTreatment = {
  __typename?: 'FertilityTreatment';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type FertilityTreatmentCounts = {
  __typename?: 'FertilityTreatmentCounts';
  count: Scalars['Int'];
  treatment: Scalars['String'];
};

export type GenericObject = {
  __typename?: 'GenericObject';
  id: Scalars['Int'];
  name: Scalars['String'];
};

/** A country on the world map. */
export type GeographicCountry = {
  __typename?: 'GeographicCountry';
  /** The ISO 3166-1 two-letter code of the country. */
  code: Scalars['String'];
  /** The official currency of the country. */
  currency?: Maybe<CurrencyObject>;
  name: Scalars['String'];
};

export type InvoiceAnalysisJob = {
  __typename?: 'InvoiceAnalysisJob';
  error?: Maybe<Scalars['String']>;
  feedback?: Maybe<InvoiceAnalysisJobResult>;
  isHidden?: Maybe<Scalars['Boolean']>;
  processingTimeSeconds?: Maybe<Scalars['Int']>;
  result?: Maybe<InvoiceAnalysisJobResult>;
  score?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
};

export type InvoiceAnalysisJobResult = {
  __typename?: 'InvoiceAnalysisJobResult';
  items?: Maybe<Array<Maybe<InvoiceLineItem>>>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  amount?: Maybe<MoneyObject>;
  confidence?: Maybe<Scalars['Int']>;
  fromAi?: Maybe<Scalars['Boolean']>;
  isEligible?: Maybe<Scalars['Boolean']>;
  isValidated?: Maybe<Scalars['Boolean']>;
  item?: Maybe<Scalars['String']>;
  originalCurrencyAdjustedAmount?: Maybe<MoneyObject>;
  originalCurrencyAmount?: Maybe<MoneyObject>;
  originalItem?: Maybe<Scalars['String']>;
  subtreatment?: Maybe<GenericObject>;
  treatmentName?: Maybe<Scalars['String']>;
};

/** A human language's code and name (in the language). */
export type Language = {
  __typename?: 'Language';
  code: Scalars['ID'];
  name: Scalars['String'];
};

export type MainAreaCounts = {
  __typename?: 'MainAreaCounts';
  area: Scalars['String'];
  count: Scalars['Int'];
  subareas: Array<AreaCounts>;
};

export type MarketplaceOffer = {
  __typename?: 'MarketplaceOffer';
  description: Scalars['String'];
  discount: Scalars['String'];
  discountCode: Scalars['String'];
  discountCodeByline: Scalars['String'];
  imageUrl: Scalars['String'];
  infoForAspiringMembers: Scalars['String'];
  infoForMembers: Scalars['String'];
  infoForPartners: Scalars['String'];
  isReimbursable: Scalars['Boolean'];
  partnerName: Scalars['String'];
  slug: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
  whatIsIncluded: Scalars['String'];
};

/** Employees of our customers: Members */
export type Member = {
  __typename?: 'Member';
  /** Whether the privacy statement has been accepted. */
  acceptedPrivacyStatement?: Maybe<Scalars['Date']>;
  /** Whether the terms and conditions have been accepted. */
  acceptedTermsConditions?: Maybe<Scalars['Date']>;
  activeMemberJourney: Scalars['String'];
  availableProductLines?: Maybe<Array<Maybe<Scalars['String']>>>;
  bankAccountDetails?: Maybe<BankAccountDetailsType>;
  birthAssignedSex: Scalars['String'];
  birthDate?: Maybe<Scalars['Date']>;
  budgetProgressBar?: Maybe<BudgetProgressBar>;
  carryoverBudget?: Maybe<DineroType>;
  city: Scalars['String'];
  contract: Contract;
  contractType?: Maybe<Scalars['String']>;
  countryOfEmployment: CountryOfEmployment;
  currentBudget?: Maybe<DineroType>;
  eligibilityStart?: Maybe<Scalars['Date']>;
  employmentEnd?: Maybe<Scalars['Date']>;
  familyFormingJourney: Scalars['String'];
  familyFormingOption: Scalars['String'];
  fertilityApproaches: Array<Scalars['String']>;
  fertilityApproachesSkipped: Scalars['Boolean'];
  fertilityTopics: Array<Scalars['String']>;
  fertilityTopicsOther: Scalars['String'];
  fertilityTopicsSkipped: Scalars['Boolean'];
  genderIdentity: Scalars['String'];
  /** Did the member have at least one consultation? */
  hadFirstConsultation: Scalars['Boolean'];
  hasLowerInitialBudget: Scalars['Boolean'];
  hasOpenClaims: Scalars['Boolean'];
  hasReimbursementRequests: Scalars['Boolean'];
  hasStartedLegacyOnboarding: Scalars['Boolean'];
  /** Whether to highlight the language selector. */
  highlightLanguages: Scalars['Boolean'];
  homepageArticles: Array<Maybe<ArticleRecommendation>>;
  id: Scalars['String'];
  identityDocumentFileName?: Maybe<Scalars['String']>;
  identityDocumentType?: Maybe<Scalars['String']>;
  identityDocumentUrl?: Maybe<Scalars['String']>;
  incidentId: Scalars['String'];
  isAspiring: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  isMedicallyNecessaryRelevant?: Maybe<Scalars['Boolean']>;
  isSsoLogin: Scalars['Boolean'];
  isSubscriptionMember: Scalars['Boolean'];
  language: Scalars['String'];
  memberStatus: Scalars['String'];
  menopauseJourney?: Maybe<MemberMenopauseJourney>;
  nationality?: Maybe<Country>;
  /** A yet to be confirmed new private email. */
  newPrivateEmail: Scalars['String'];
  partnerConsentStatus?: Maybe<Scalars['String']>;
  partnerDetails?: Maybe<PartnerDetailsObject>;
  /** The member's private phone number — needed for the wallets feature. */
  phoneNumber: Scalars['String'];
  preferredGivenName: Scalars['String'];
  preferredSurname: Scalars['String'];
  pregnancyPostpartumJourney?: Maybe<PregnancyPostpartumJourney>;
  previouslySelectedJourneys: Array<Scalars['String']>;
  privateAddress?: Maybe<Address>;
  privateEmail?: Maybe<Scalars['String']>;
  privateEmailChangePending?: Maybe<Scalars['Boolean']>;
  /** Whether the private email has been confirmed. */
  privateEmailConfirmed: Scalars['Boolean'];
  pronouns: Scalars['String'];
  provinceOfResidency?: Maybe<Scalars['String']>;
  relationshipDynamic: Scalars['String'];
  showNewClaimsFlowNotification: Scalars['Boolean'];
  showPartnerConsentNotification?: Maybe<Scalars['Boolean']>;
  showRedesignNotification: Scalars['Boolean'];
  subscriptions: Array<MemberSubscription>;
  timezone: Timezone;
  wallet?: Maybe<Wallet>;
};

export type MemberMenopauseJourney = {
  __typename?: 'MemberMenopauseJourney';
  lastMenstrualPeriod: Scalars['String'];
  menopauseSymptoms: Array<Maybe<Scalars['String']>>;
  menstrualPeriodStatus: Scalars['String'];
  otherSymptomsDescription: Scalars['String'];
};

export type MemberSubscription = {
  __typename?: 'MemberSubscription';
  endDate?: Maybe<Scalars['Date']>;
  startDate: Scalars['Date'];
};

export type Menopause = {
  __typename?: 'Menopause';
  clinicAreas?: Maybe<Array<AreaCounts>>;
  clinicCities?: Maybe<Array<CityType>>;
  clinicCountries: Array<CountryType>;
  countries: Array<CountryType>;
  menopauseClinics?: Maybe<MenopauseClinicPage>;
  menopauseInCountry?: Maybe<MenopauseNavigatorInCountry>;
};


export type MenopauseClinicAreasArgs = {
  country: Scalars['String'];
};


export type MenopauseClinicCitiesArgs = {
  area?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
};


export type MenopauseMenopauseClinicsArgs = {
  area?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type MenopauseMenopauseInCountryArgs = {
  countryCode: Scalars['String'];
  province?: InputMaybe<Scalars['String']>;
};

export type MenopauseClinicPage = {
  __typename?: 'MenopauseClinicPage';
  objects?: Maybe<Array<Maybe<MenopauseClinicType>>>;
  pageInfo?: Maybe<PaginationInfo>;
};

export type MenopauseClinicType = {
  __typename?: 'MenopauseClinicType';
  address: Scalars['String'];
  area: Scalars['String'];
  city: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  phone: Scalars['String'];
  postalCode: Scalars['String'];
  website: Scalars['String'];
};

export type MenopauseNavigatorInCountry = {
  __typename?: 'MenopauseNavigatorInCountry';
  clinicsAvailable: Scalars['Boolean'];
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  coverageForHrt: Scalars['String'];
  province: Scalars['String'];
};

/**
 * A document that is missing but required for validation of the request
 *
 * The claims manager sent a request for more information and the Member has
 * to provide this in order for the claim to move forward.
 *
 * If the Member provides the document, then this is added to the request as a
 * ``ReimbursementRequestDocument`` and soft deleted.
 *
 * If the Member cannot provide the document, they must provide a reason. The
 * missing document then stays active but with the reason. So to implement a
 * ``needsUpdate`` flag, one could check if ``notProvidedReason`` is ``null``.
 */
export type MissingDocumentRequest = {
  __typename?: 'MissingDocumentRequest';
  /** Type of document requested. */
  documentType: Scalars['String'];
  /** Explanation provided by the claims manager */
  explanation?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  /** Reason given by the member why they cannot provide the document. */
  notProvidedReason?: Maybe<Scalars['String']>;
};

/** An amount of a currency. */
export type MoneyObject = {
  __typename?: 'MoneyObject';
  amount: Scalars['Float'];
  currency: CurrencyObject;
  formatted: Scalars['String'];
};

export type Mutation = {
  __typename?: 'Mutation';
  activateWallet?: Maybe<MutationResult>;
  /**
   * Add a partner detail for a member.
   * This mutation creates a partner details object and associates it with the
   * member's account.
   *
   * The mutation requires the following arguments:
   * - ``member_street_address``: Member's address (required)
   * - ``member_postcode``: Member's postal code (required)
   * - ``member_city``: Member's city (required)
   * - ``member_country``: Member's country (required)
   * - ``partner_first_name``: Partner's first name (required)
   * - ``partner_last_name``: Partner's last name (required)
   * - ``partner_date_of_birth``: Partner's date of birth (required)
   * - ``partner_email``: Partner's email (required)
   * - ``same_household``: Boolean indicating if the partner lives in the same
   *   household as the member (required)
   * - ``partner_street_address``: Partner's address (optional)
   * - ``partner_postcode``: Partner's postal code (optional)
   * - ``partner_city``: Partner's city (optional)
   * - ``partner_country``: Partner's country (optional)
   * - ``same_employer``: Boolean indicating if the partner works for the same
   *   employer as the member (required)
   * - ``partner_employee_number``: Partner's employee number (optional)
   * - ``id_document``: Partner's identity document (required in production and demo)
   * - ``doc_type``: Type of document for partner id.
   *
   * The mutation returns a success flag and an error code if the mutation
   * fails. The error code can be one of the following:
   * - ``VALIDATION_ERRORS``: Validation errors occurred while processing the
   *   mutation.
   * - ``PARTNER_DETAILS_ALREADY_EXISTS``: Partner details already exist for
   *     the member.
   * - ``NO_DOCUMENTS_RECEIVED``: No documents were received in production or demo.
   * - ``UNKNOWN_ERROR``: An unknown error occurred while processing the
   *     mutation.
   * - ``SMTPException``: An error occurred while sending the email.
   * - ``EMAIL_NOT_SENT``: An error occurred while sending the email.
   */
  addPartner?: Maybe<MutationResult>;
  addTransactionUploads?: Maybe<MutationResult>;
  addTreatmentPlan?: Maybe<MutationResult>;
  /** Change the member's preferred language. */
  changeLanguage?: Maybe<ChangeLanguage>;
  changeNationality?: Maybe<MutationResult>;
  changePassword?: Maybe<StatusMessage>;
  changePhoneNumber?: Maybe<MutationResult>;
  changePreferences?: Maybe<ChangePreferences>;
  /** Complete onboarding questionnaire and store responses as structured Assessment. */
  completeOnboardingQuestionnaire?: Maybe<CompleteOnboardingQuestionnaire>;
  /**
   * Confirms private email
   *
   * Returns ``success=False`` with the following error codes on failure:
   *
   * - ``token-expired``: Token has expired: we should prompt to get a new one.
   * - ``token-invalid``: Token is invalid: we should provide support (email was
   *   incorrectly breaking / mangling the link or MITM attack.
   * - ``user-not-logged-in``: User is not logged in or the logged is not the
   *   same as the member account with the confirmed private email
   *
   * Return ``success=True`` otherwise and sets private_email_confirmed on the
   * member.
   */
  confirmPrivateEmail?: Maybe<ConfirmPrivateEmail>;
  confirmUserEmail?: Maybe<StatusMessage>;
  createAccount?: Maybe<CreateAccount>;
  createAirwallexBeneficiary?: Maybe<CreateAirwallexBeneficiary>;
  /**
   * Create or update a reimbursement claim as part of the new claims flow.
   * When id is omitted a new claim is created; when id is supplied the existing
   * open claim is updated and its documents are fully replaced.
   */
  createReimbursementClaim?: Maybe<CreateReimbursementClaim>;
  /**
   * Implementation of the custom Help button
   *
   * Routes emails to a support email address
   */
  customSupportRequest?: Maybe<CustomSupportRequest>;
  /**
   * Disable notification for member about new claims flow.
   * Set show_new_claims_flow_notification to False.
   */
  disableNewClaimsFlowNotification?: Maybe<MutationResult>;
  /**
   * Disable the partner consent notification for a member.
   * Set show_partner_consent_notification to False.
   */
  disablePartnerConsentNotification?: Maybe<MutationResult>;
  /**
   * Disable notification for member about redesign of Member portal.
   * Set show_redesign_notification to False.
   */
  disableRedesignNotification?: Maybe<MutationResult>;
  /** Cancel a member's active program enrollment. */
  dropOutOfProgram?: Maybe<DropOutOfProgram>;
  /**
   * DEPRECATED: Consultation enrollments are now created automatically.
   * This mutation remains for backward compatibility but just calls ensure_for_user.
   */
  enrollInConsultation?: Maybe<EnrollInConsultation>;
  /** Enroll user in a program. */
  enrollInProgram?: Maybe<EnrollInProgram>;
  freezeWallet?: Maybe<MutationResult>;
  login?: Maybe<AuthStatus>;
  logout?: Maybe<StatusMessage>;
  /**
   * Register an account on the Member Portal.
   *
   * Create an account for which:
   *
   * - The email address comes from the value encoded in the registration token.
   * - The company, employee ID, country of employment, employment start and end dates
   *   come from the potential member record matching the registration token.
   * - The password, names, and language come from the user input.
   *
   * Log the newly created user in.
   *
   * This mutation is part of the new (no-consent) registration flow.
   */
  register?: Maybe<MutationResult>;
  renewCard?: Maybe<MutationResult>;
  requestPasswordReset?: Maybe<StatusMessage>;
  requestUserEmailConfirmation?: Maybe<StatusMessage>;
  resendPartnerConsentEmail?: Maybe<ResendPartnerConsentEmail>;
  /**
   * Resend the private email confirmation
   *
   * NOTE:
   *    Only use for resends, not during onboarding process!
   *
   * Returns ``success=False`` with the following error codes on failure:
   *
   * - ``user-not-logged-in``: The user is not logged in or the logged in user is
   *   not a member account (Apryl staff or HR manager)
   * - ``private-email-not-set``: The private email address is not filled out, so
   *   no confirmation can be resent.
   */
  resendPrivateEmailConfirmation?: Maybe<ResendPrivateEmailConfirmation>;
  resetPassword?: Maybe<StatusMessage>;
  /**
   * Retry the payout of a claim whose latest Airwallex payout has failed.
   *
   * Returns success=False with the following error codes on failure:
   *
   * - service-unavailable: Airwallex payouts are disabled.
   * - claim-not-found: The claim does not exist or does not belong to the member.
   * - payout-not-retryable: The claim status is not payout failed, or its
   *   latest payout has not failed.
   * - validation-errors: The member has no Airwallex beneficiary to pay out to.
   */
  retryClaimPayout?: Maybe<RetryClaimPayout>;
  /**
   * Send an email with a link enabling the receiver to register an account.
   *
   * If the SHA-512 of the given email address is found in the potential members table,
   * send an email to the address with a signed-token link enabling the user to register
   * on the Member Portal.
   *
   * If the SHA-512 of the given email address is not found in the database, do nothing.
   *
   * If the alternative_auth string is provided, use this instead of the email's hash to
   * locate a potential member record — which, importantly, must have the email_hash set
   * to an empty string. The alternative auth approach only exists for a single customer,
   * WWT, because they cannot hash their email addresses.
   *
   * This mutation is part of the new (no-consent) registration flow.
   */
  sendConfirmRegistrationEmail?: Maybe<MutationResult>;
  /** Set whether a session is skipped during booking flow. */
  setSessionSkipped?: Maybe<SetSessionSkipped>;
  /** Setup menopause profile for a member. */
  setupMenopauseProfile?: Maybe<MutationResult>;
  /** Setup pregnancy postpartum profile for a member. */
  setupPregnancyPostpartumProfile?: Maybe<MutationResult>;
  setupProfile?: Maybe<SetupProfile>;
  /**
   * Sign up the member with the provided password.
   *
   * Validate if the email address is indeed associated with a member account that has
   * not been setup yet. If so, validate if the password meets password security
   * standards and set the password for the user account. Then send out an email address
   * confirmation email.
   *
   * Arguments
   * ---------
   * - ``email``: Required. Email of the account that is being signed up.
   * - ``password``: Required. Password chosen by the user.
   * - ``language``: Optional.
   *
   * Error strings and error codes
   * -----------------------------
   * - 400 Bad input:
   *     - ``invalid-language-code``: Invalid language code.
   * - 403 Forbidden:
   *     - ``no-such-email``: Either we do not have have this email account, or the
   *       account has already been configured, or the member is not yet employed or not
   *       employed any more.
   */
  signupMember?: Maybe<StatusMessage>;
  /** Skip onboarding questionnaire - permanent action per consultation. */
  skipOnboardingQuestionnaire?: Maybe<SkipOnboardingQuestionnaire>;
  submitFreshdeskTicket?: Maybe<SubmitFreshdeskTicket>;
  submitFreshdeskTicketAnonymously?: Maybe<SubmitFreshdeskTicketAnonymously>;
  /**
   * Implementation of the Help button
   *
   * Routes emails to a well-known email address based on incoming subject
   */
  supportRequest?: Maybe<SupportRequest>;
  /** Record that the logged-in member downloaded a referral letter for the given country. */
  trackReferralLetterDownload?: Maybe<TrackReferralLetterDownload>;
  unfreezeWallet?: Maybe<MutationResult>;
  updateAirwallexBeneficiary?: Maybe<UpdateAirwallexBeneficiary>;
  /** Update member journey for a member, ending the current journey if needed. */
  updateMemberJourney?: Maybe<MutationResult>;
  /**
   * Persist or update the member's payment information for reimbursement.
   *
   * Validates country-specific bank fields via the registry-driven
   * BankAccountDetails.clean()
   */
  updatePaymentInformation?: Maybe<MutationResult>;
  updatePersonalInformation?: Maybe<UpdatePersonalInformation>;
  /**
   * Check whether the given registration token is valid.
   *
   * The registration token is a signed token sent as the ?token query param of the link
   * emailed to the user as the first step of the new registration flow.
   *
   * This mutation is part of the new (no-consent) registration flow.
   */
  verifyRegistrationToken?: Maybe<MutationResult>;
};


export type MutationActivateWalletArgs = {
  id: Scalars['Int'];
};


export type MutationAddPartnerArgs = {
  docType?: InputMaybe<Scalars['String']>;
  idDocument?: InputMaybe<Scalars['Upload']>;
  memberCity: Scalars['String'];
  memberCountry: Scalars['String'];
  memberPostcode: Scalars['String'];
  memberStreetAddress: Scalars['String'];
  partnerCity?: InputMaybe<Scalars['String']>;
  partnerCountry?: InputMaybe<Scalars['String']>;
  partnerDateOfBirth: Scalars['Date'];
  partnerEmail: Scalars['String'];
  partnerEmployeeNumber?: InputMaybe<Scalars['String']>;
  partnerFirstName: Scalars['String'];
  partnerLastName: Scalars['String'];
  partnerPostcode?: InputMaybe<Scalars['String']>;
  partnerStreetAddress?: InputMaybe<Scalars['String']>;
  sameEmployer: Scalars['Boolean'];
  sameHousehold: Scalars['Boolean'];
};


export type MutationAddTransactionUploadsArgs = {
  files: Array<InputMaybe<Scalars['Upload']>>;
  isMedicallyNecessaryTreatment?: InputMaybe<Scalars['Boolean']>;
  transaction: Scalars['Int'];
};


export type MutationAddTreatmentPlanArgs = {
  file: Scalars['Upload'];
  wallet: Scalars['Int'];
};


export type MutationChangeLanguageArgs = {
  language: Scalars['String'];
};


export type MutationChangeNationalityArgs = {
  nationality: Scalars['String'];
};


export type MutationChangePasswordArgs = {
  newPassword: Scalars['String'];
  oldPassword: Scalars['String'];
};


export type MutationChangePhoneNumberArgs = {
  phoneNumber: Scalars['String'];
};


export type MutationChangePreferencesArgs = {
  language?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type MutationCompleteOnboardingQuestionnaireArgs = {
  consultationId: Scalars['ID'];
  responses: Scalars['JSONString'];
};


export type MutationConfirmPrivateEmailArgs = {
  token: Scalars['String'];
};


export type MutationConfirmUserEmailArgs = {
  token: Scalars['String'];
};


export type MutationCreateAccountArgs = {
  acceptPrivacyStatement?: InputMaybe<Scalars['Boolean']>;
  acceptTermsConditions?: InputMaybe<Scalars['Boolean']>;
  birthDate?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  memberJourney?: InputMaybe<Scalars['String']>;
  preferredGivenName?: InputMaybe<Scalars['String']>;
  preferredSurname?: InputMaybe<Scalars['String']>;
  privateEmail?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAirwallexBeneficiaryArgs = {
  payload: Scalars['GenericScalar'];
};


export type MutationCreateReimbursementClaimArgs = {
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  accountType?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  claimant: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  documents: Array<InputMaybe<RequestReimbursementPayload>>;
  existingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  id?: InputMaybe<Scalars['ID']>;
  idDoc?: InputMaybe<Scalars['Upload']>;
  isMedicallyNecessaryTreatment?: InputMaybe<Scalars['Boolean']>;
  localFields?: InputMaybe<Scalars['JSONString']>;
  swiftCode?: InputMaybe<Scalars['String']>;
  treatment: Scalars['ID'];
  treatmentAdditionalInfo?: InputMaybe<Scalars['String']>;
  treatmentCadence?: InputMaybe<Scalars['Int']>;
};


export type MutationCustomSupportRequestArgs = {
  body: Scalars['String'];
  copySelf?: InputMaybe<Scalars['Boolean']>;
  privateEmail: Scalars['String'];
};


export type MutationDropOutOfProgramArgs = {
  programEnrollmentId: Scalars['ID'];
};


export type MutationEnrollInConsultationArgs = {
  consultationContext?: InputMaybe<Scalars['JSONString']>;
  consultationId: Scalars['ID'];
};


export type MutationEnrollInProgramArgs = {
  disclaimerAcknowledged?: InputMaybe<Scalars['Boolean']>;
  programId: Scalars['ID'];
};


export type MutationFreezeWalletArgs = {
  id: Scalars['Int'];
};


export type MutationLoginArgs = {
  input: AuthStatusInput;
};


export type MutationRegisterArgs = {
  firstName: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};


export type MutationRenewCardArgs = {
  card?: InputMaybe<Scalars['Int']>;
  wallet: Scalars['Int'];
};


export type MutationRequestPasswordResetArgs = {
  input: RequestPasswordResetInput;
};


export type MutationRequestUserEmailConfirmationArgs = {
  email: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  newPassword: Scalars['String'];
  token: Scalars['String'];
  uid: Scalars['String'];
};


export type MutationRetryClaimPayoutArgs = {
  claimId: Scalars['ID'];
};


export type MutationSendConfirmRegistrationEmailArgs = {
  alternativeAuth?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
};


export type MutationSetSessionSkippedArgs = {
  programEnrollmentId: Scalars['ID'];
  sessionId: Scalars['ID'];
  skipped: Scalars['Boolean'];
};


export type MutationSetupMenopauseProfileArgs = {
  lastMenstrualPeriod?: InputMaybe<Scalars['String']>;
  menopauseSymptoms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  menstrualPeriodStatus?: InputMaybe<Scalars['String']>;
  otherSymptomsDescription?: InputMaybe<Scalars['String']>;
};


export type MutationSetupPregnancyPostpartumProfileArgs = {
  deliveryDate?: InputMaybe<Scalars['Date']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  pregnancyPostpartumStatus?: InputMaybe<Scalars['String']>;
};


export type MutationSetupProfileArgs = {
  birthAssignedSex?: InputMaybe<Scalars['String']>;
  familyFormingJourney?: InputMaybe<Scalars['String']>;
  familyFormingOption?: InputMaybe<Scalars['String']>;
  fertilityApproaches?: InputMaybe<Array<Scalars['String']>>;
  fertilityApproachesSkipped?: InputMaybe<Scalars['Boolean']>;
  fertilityTopics?: InputMaybe<Array<Scalars['String']>>;
  fertilityTopicsOther?: InputMaybe<Scalars['String']>;
  fertilityTopicsSkipped?: InputMaybe<Scalars['Boolean']>;
  genderIdentity?: InputMaybe<Scalars['String']>;
  parentingModels?: InputMaybe<Array<Scalars['String']>>;
  relationshipDynamic?: InputMaybe<Scalars['String']>;
};


export type MutationSignupMemberArgs = {
  email: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
};


export type MutationSkipOnboardingQuestionnaireArgs = {
  consultationId: Scalars['ID'];
};


export type MutationSubmitFreshdeskTicketArgs = {
  body: Scalars['String'];
  subject: Scalars['String'];
};


export type MutationSubmitFreshdeskTicketAnonymouslyArgs = {
  body: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
};


export type MutationSupportRequestArgs = {
  body: Scalars['String'];
  copySelf?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
};


export type MutationTrackReferralLetterDownloadArgs = {
  country: Scalars['String'];
};


export type MutationUnfreezeWalletArgs = {
  id: Scalars['Int'];
};


export type MutationUpdateAirwallexBeneficiaryArgs = {
  beneficiaryId: Scalars['String'];
  payload: Scalars['GenericScalar'];
};


export type MutationUpdateMemberJourneyArgs = {
  endCurrentJourney?: InputMaybe<Scalars['Boolean']>;
  memberJourney: Scalars['String'];
};


export type MutationUpdatePaymentInformationArgs = {
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: Scalars['String'];
  bankName: Scalars['String'];
  country: Scalars['String'];
  localFields?: InputMaybe<Scalars['JSONString']>;
  swiftCode?: InputMaybe<Scalars['String']>;
};


export type MutationUpdatePersonalInformationArgs = {
  acceptPrivacyStatement?: InputMaybe<Scalars['Boolean']>;
  acceptTermsConditions?: InputMaybe<Scalars['Boolean']>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostcode?: InputMaybe<Scalars['String']>;
  addressStreetAddress?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  idDoc?: InputMaybe<Scalars['Upload']>;
  memberJourney?: InputMaybe<Scalars['String']>;
  preferredGivenName?: InputMaybe<Scalars['String']>;
  preferredSurname?: InputMaybe<Scalars['String']>;
  privateEmail?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyRegistrationTokenArgs = {
  token: Scalars['String'];
};

export type MutationResult = {
  __typename?: 'MutationResult';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** The query fields in the navigator namespace. */
export type Navigator = {
  __typename?: 'Navigator';
  coveredCountries: Array<Maybe<CountryInNavigator>>;
  treatmentInCountry?: Maybe<TreatmentInCountryInNavigator>;
  treatments: Array<Maybe<TreatmentInNavigator>>;
};


/** The query fields in the navigator namespace. */
export type NavigatorTreatmentInCountryArgs = {
  countryCode: Scalars['String'];
  province?: InputMaybe<Scalars['String']>;
  treatmentId: Scalars['Int'];
};

/** Consultation onboarding progress. */
export type OnboardingStatusType = {
  __typename?: 'OnboardingStatusType';
  onboardingCallCompleted?: Maybe<Scalars['Boolean']>;
  onboardingCallRequired?: Maybe<Scalars['Boolean']>;
  onboardingQuestionnaireCompleted?: Maybe<Scalars['Boolean']>;
  onboardingQuestionnaireRequired?: Maybe<Scalars['Boolean']>;
  onboardingQuestionnaireSkipped?: Maybe<Scalars['Boolean']>;
};

/** The value and label for an <option> in a <select>. */
export type Option = {
  __typename?: 'Option';
  label: Scalars['String'];
  value: Scalars['String'];
};

export type PageOfArticles = {
  __typename?: 'PageOfArticles';
  articles: Array<Maybe<Article>>;
  count: Scalars['Int'];
  numPages: Scalars['Int'];
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  hasNext: Scalars['Boolean'];
  hasPrevious: Scalars['Boolean'];
  nextPage?: Maybe<Scalars['Int']>;
  numPages: Scalars['Int'];
  previousPage?: Maybe<Scalars['Int']>;
  total: Scalars['Int'];
};

export type PartnerDetailsObject = {
  __typename?: 'PartnerDetailsObject';
  address?: Maybe<AddressObject>;
  birthDate?: Maybe<Scalars['Date']>;
  docType: Scalars['String'];
  email: Scalars['String'];
  employeeNumber?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  identityDocumentUrl?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  sameEmployer: Scalars['Boolean'];
  sameHousehold: Scalars['Boolean'];
};

export type PartnershipBenefit = {
  __typename?: 'PartnershipBenefit';
  id: Scalars['ID'];
  name: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/**
 * Result of a check for a password reset token check
 *
 * Verifies if the provided token is valid for the account with provided uid.
 *
 * Error codes:
 * - field-not-provided: Either token or uid is not passed to the query
 * - token-expired: The token has expired
 * - token-invalid: The token is invalid (mangled, broken off or password has
 *                  already been changed).
 */
export type PasswordResetTokenValidationResult = {
  __typename?: 'PasswordResetTokenValidationResult';
  errorCode?: Maybe<Scalars['String']>;
  isValid: Scalars['Boolean'];
};

export type PayoutFailure = {
  __typename?: 'PayoutFailure';
  failureAction: PayoutFailureAction;
  failureDescription: Scalars['String'];
};

/** Action the member must take to resolve a failed payout. */
export enum PayoutFailureAction {
  ContactYourBank = 'CONTACT_YOUR_BANK',
  NoMemberActionRequired = 'NO_MEMBER_ACTION_REQUIRED',
  UpdateBankAccountDetails = 'UPDATE_BANK_ACCOUNT_DETAILS'
}

export type PregnancyPostpartum = {
  __typename?: 'PregnancyPostpartum';
  countries: Array<CountryType>;
  pregnancyPostpartumInCountry?: Maybe<PregnancyPostpartumNavigatorInCountry>;
};


export type PregnancyPostpartumPregnancyPostpartumInCountryArgs = {
  countryCode: Scalars['String'];
  province?: InputMaybe<Scalars['String']>;
};

export type PregnancyPostpartumJourney = {
  __typename?: 'PregnancyPostpartumJourney';
  deliveryDate?: Maybe<Scalars['Date']>;
  dueDate?: Maybe<Scalars['Date']>;
  pregnancyPostpartumStatus?: Maybe<Scalars['String']>;
};

export type PregnancyPostpartumNavigatorInCountry = {
  __typename?: 'PregnancyPostpartumNavigatorInCountry';
  jobSecurity: Scalars['String'];
  maternityLeaveDuration: Scalars['String'];
  maternityLeavePayee: Scalars['String'];
  parentalLeaveDuration: Scalars['String'];
  paternityLeaveDuration: Scalars['String'];
  paternityLeavePayee: Scalars['String'];
};

export type ProductConfig = {
  __typename?: 'ProductConfig';
  dataType: CoreApplicationConfigEntryDataTypeChoices;
  id: Scalars['ID'];
  slug: Scalars['String'];
  /** Trailing and leading space will be trimmed if the data type is not Text. Dates and timestamp should use ISO-8601 format. */
  value: Scalars['String'];
};

/** Program with localized content from database. */
export type ProgramType = {
  __typename?: 'ProgramType';
  /** Managed in Contentful */
  bookingStrategy: ConsultationsProgramBookingStrategyChoices;
  consultation?: Maybe<ConsultationType>;
  description?: Maybe<Scalars['String']>;
  /** Managed in Contentful - If false, hides the Learn more button */
  enableLearnMoreContent: Scalars['Boolean'];
  id: Scalars['ID'];
  isEnrolled?: Maybe<Scalars['Boolean']>;
  previewDescription?: Maybe<Scalars['String']>;
  /** Managed in Contentful - If false, allows direct booking without enrollment */
  requireEnrollment: Scalars['Boolean'];
  sessions?: Maybe<Array<Maybe<SessionType>>>;
  /** Managed in Contentful */
  slug: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

/**
 * A set of pronouns to indicate how a person wishes to be addressed
 *
 * Unset is not a value that should be displayed as a choice. It's the
 * indicator for a new member that has not yet completed onboarding.
 */
export type Pronoun = {
  __typename?: 'Pronoun';
  /** Display label */
  label: Scalars['String'];
  /** Stored value */
  value: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  airwallexAuthorization: AirwallexAuthorization;
  airwallexBeneficiary?: Maybe<Scalars['GenericScalar']>;
  airwallexBeneficiaryId?: Maybe<Scalars['String']>;
  /** Short-lived URL for responding to an Airwallex transaction RFI. */
  airwallexRfiHostedUrl?: Maybe<Scalars['String']>;
  allCountries: Array<Maybe<GeographicCountry>>;
  articleCategories: Array<Maybe<ArticleCategory>>;
  articles: Array<Maybe<Article>>;
  availableCountries: Array<Country>;
  /** Country-specific bank fields the member must provide for claim reimbursement, used to drive dynamic form rendering. */
  bankFieldsSchema: BankFieldsSchemaType;
  claimDocumentTypes?: Maybe<Array<Maybe<ClaimDocumentType>>>;
  claimTreatments: Array<Maybe<Treatment>>;
  clinicAreas?: Maybe<Array<MainAreaCounts>>;
  clinicCities?: Maybe<Array<CityType>>;
  clinicCountries: Array<CountryType>;
  clinics?: Maybe<FertilityClinicPage>;
  clinicsAdditionalInfoField?: Maybe<ClinicsAdditionalContact>;
  consultations: Consultations;
  coverage: Coverage;
  dictionary: Scalars['String'];
  faqSections: Array<Maybe<FaqSection>>;
  languages: Array<Maybe<Language>>;
  marketplaceOffers: Array<Maybe<MarketplaceOffer>>;
  me?: Maybe<User>;
  menopause: Menopause;
  navigator: Navigator;
  /** Details of an open reimbursement request */
  openClaim?: Maybe<ReimbursementRequest>;
  partnershipBenefits?: Maybe<Array<Maybe<PartnershipBenefit>>>;
  pregnancyPostpartum: PregnancyPostpartum;
  productConfig: Array<ProductConfig>;
  /** List of used pronouns in the product */
  pronouns: Array<Pronoun>;
  ratingSpec?: Maybe<RatingSpecification>;
  recommendedArticles: Array<Maybe<ArticleOrCategory>>;
  /** Paginated list of reimbursement requests */
  reimbursementHistory: ReimbursementHistoryPage;
  /** Details of a reimbursement request */
  reimbursementRequest?: Maybe<ReimbursementRequest>;
  searchArticles: PageOfArticles;
  specialties?: Maybe<Array<Maybe<ClinicSpecialtyCounts>>>;
  timezones?: Maybe<Array<Maybe<TimezoneMapping>>>;
  treatments: Array<FertilityTreatmentCounts>;
  /** Validate a token and determine the why it is not correct. */
  validatePasswordToken?: Maybe<PasswordResetTokenValidationResult>;
};


export type QueryAirwallexAuthorizationArgs = {
  scopes: Array<InputMaybe<Scalars['String']>>;
};


export type QueryAirwallexRfiHostedUrlArgs = {
  rfiId: Scalars['ID'];
};


export type QueryArticleCategoriesArgs = {
  preview?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryArticlesArgs = {
  preview?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryBankFieldsSchemaArgs = {
  countryCode: Scalars['String'];
};


export type QueryClinicAreasArgs = {
  country: Scalars['String'];
  specialty?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClinicCitiesArgs = {
  area?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  specialty?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClinicsArgs = {
  area?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  isPartnerClinic?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  partnershipBenefit?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryClinicsAdditionalInfoFieldArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryDictionaryArgs = {
  preview?: InputMaybe<Scalars['String']>;
};


export type QueryFaqSectionsArgs = {
  preview?: InputMaybe<Scalars['String']>;
};


export type QueryMarketplaceOffersArgs = {
  preview?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryRatingSpecArgs = {
  country?: InputMaybe<Scalars['String']>;
};


export type QueryReimbursementHistoryArgs = {
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
};


export type QueryReimbursementRequestArgs = {
  claimId?: InputMaybe<Scalars['ID']>;
};


export type QuerySearchArticlesArgs = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
};


export type QuerySpecialtiesArgs = {
  area?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryTreatmentsArgs = {
  area?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  specialty?: InputMaybe<Scalars['String']>;
};


export type QueryValidatePasswordTokenArgs = {
  token: Scalars['String'];
  uid: Scalars['String'];
};

export type RatingSpecification = {
  __typename?: 'RatingSpecification';
  link?: Maybe<Scalars['String']>;
  maxStars?: Maybe<Scalars['Int']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type ReimbursementClaimDocument = {
  __typename?: 'ReimbursementClaimDocument';
  description: Scalars['String'];
  documentType: Scalars['String'];
  /** Name of the file */
  fileName: Scalars['String'];
  /** URL of the file */
  fileUrl: Scalars['String'];
  id: Scalars['ID'];
  updatedAtDate: Scalars['DateTime'];
};

export type ReimbursementHistoryPage = {
  __typename?: 'ReimbursementHistoryPage';
  objects: Array<ReimbursementRequest>;
  pageInfo?: Maybe<PaginationInfo>;
};

/** A reimbursement request */
export type ReimbursementRequest = {
  __typename?: 'ReimbursementRequest';
  /** Latest Airwallex RFI that has not been closed. */
  activeRfi?: Maybe<RequestForInformationObject>;
  /** Amount that was awarded to the Member for this request. If it is null, Apryl has not yet processed the claim and so it is'Pending'. If it is zero, the claim has been or will be rejected. */
  awardedAmount?: Maybe<DineroType>;
  bankDetails?: Maybe<BankAccountDetailsType>;
  /** List of documents associated with the request that have been uploaded by the Member. */
  claimDocuments: Array<ReimbursementClaimDocument>;
  claimant: Scalars['String'];
  /** List of documents associated with the request. */
  documents: Array<ReimbursementRequestDocument>;
  /** Number of documents uploaded. */
  files: Scalars['Int'];
  id: Scalars['ID'];
  /** Whether the member can currently add more documents to this claim — i.e. the claim is open and the holding window has not yet elapsed. */
  isEditable: Scalars['Boolean'];
  memberIdDocName?: Maybe<Scalars['String']>;
  memberIdDocType?: Maybe<Scalars['String']>;
  memberIdDocUrl?: Maybe<Scalars['String']>;
  /** Failure of the latest payout, if it failed, and the action required from the member. */
  payoutFailure?: Maybe<PayoutFailure>;
  /** Date at which the claim was received by Apryl */
  receivedAt: Scalars['Date'];
  /** Claim status visible to member */
  reconciliationStatus?: Maybe<Scalars['String']>;
  /** Seconds left in the holding window during which the member may attach additional documents to this claim. */
  remainingEditableSeconds: Scalars['Int'];
  /** Amount that was requested by the Member. If it is null, Apryl has not yet entered this information into the Backoffice and so is 'Pending'. */
  requestedAmount?: Maybe<DineroType>;
  /** List of missing documents that are required to move the process forward. */
  requestedDocuments: Array<MissingDocumentRequest>;
  stage: Scalars['Int'];
  status: Scalars['String'];
  submissionDate?: Maybe<Scalars['Date']>;
  /** Timestamp at which claim is closed and is dispatched to Crawford. */
  submissionDeadline?: Maybe<Scalars['DateTime']>;
  treatmentAdditionalInfo?: Maybe<Scalars['String']>;
  treatmentCadence?: Maybe<Scalars['Int']>;
  treatmentName?: Maybe<Scalars['String']>;
};

/**
 * Document associated with a reimbursement request
 *
 * To be enriched by the claims manager as they validate the request.
 */
export type ReimbursementRequestDocument = {
  __typename?: 'ReimbursementRequestDocument';
  documentType: Scalars['String'];
  filename: Scalars['String'];
  id: Scalars['String'];
  /** If it is an invoice, this should list the amount of the invoice. If it is null, it is either not an invoice or the amount has not yet been determined and so is 'Pending'. */
  invoiceAmount?: Maybe<DineroType>;
  /** Invoice number or similar reference, the submitter recognizes. */
  reference: Scalars['String'];
};

export type RequestForInformationObject = {
  __typename?: 'RequestForInformationObject';
  /** Airwallex account unique identifier. */
  accountId: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  status: Scalars['String'];
};

export type RequestPasswordResetInput = {
  application?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
};

export type RequestReimbursementPayload = {
  description: Scalars['String'];
  docType: Scalars['String'];
  file: Scalars['Upload'];
};

export type ResendPartnerConsentEmail = {
  __typename?: 'ResendPartnerConsentEmail';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/**
 * Resend the private email confirmation
 *
 * NOTE:
 *    Only use for resends, not during onboarding process!
 *
 * Returns ``success=False`` with the following error codes on failure:
 *
 * - ``user-not-logged-in``: The user is not logged in or the logged in user is
 *   not a member account (Apryl staff or HR manager)
 * - ``private-email-not-set``: The private email address is not filled out, so
 *   no confirmation can be resent.
 */
export type ResendPrivateEmailConfirmation = {
  __typename?: 'ResendPrivateEmailConfirmation';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/**
 * Retry the payout of a claim whose latest Airwallex payout has failed.
 *
 * Returns success=False with the following error codes on failure:
 *
 * - service-unavailable: Airwallex payouts are disabled.
 * - claim-not-found: The claim does not exist or does not belong to the member.
 * - payout-not-retryable: The claim status is not payout failed, or its
 *   latest payout has not failed.
 * - validation-errors: The member has no Airwallex beneficiary to pay out to.
 */
export type RetryClaimPayout = {
  __typename?: 'RetryClaimPayout';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** Parameters to pass to Cal.com embed for session booking */
export type SessionBookingParamsType = {
  __typename?: 'SessionBookingParamsType';
  language?: Maybe<Scalars['String']>;
  languageLocked?: Maybe<Scalars['Boolean']>;
  metadata?: Maybe<Scalars['JSONString']>;
  routedTeamMemberIds?: Maybe<Array<Maybe<Scalars['Int']>>>;
};

/** Session booking status for a user's program enrollment. */
export type SessionStatusType = {
  __typename?: 'SessionStatusType';
  appointment?: Maybe<AppointmentType>;
  session?: Maybe<SessionType>;
  status?: Maybe<Scalars['String']>;
};

export type SessionType = {
  __typename?: 'SessionType';
  bookingDescription?: Maybe<Scalars['String']>;
  bookingWindow?: Maybe<BookingWindowStatusType>;
  calcomEventType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  program: ProgramType;
  /** Managed in Contentful - If true, allows multiple bookings for this session */
  repeatable: Scalars['Boolean'];
  /** Managed in Contentful - If false, session is optional */
  required: Scalars['Boolean'];
  sessionDetail?: Maybe<Scalars['String']>;
  /** Managed in Contentful - Order in which sessions should be taken (1-based) */
  sessionNumber: Scalars['Int'];
  subtitle?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

/** Set whether a session is skipped during booking flow. */
export type SetSessionSkipped = {
  __typename?: 'SetSessionSkipped';
  message?: Maybe<Scalars['String']>;
  sessionStatus?: Maybe<SessionStatusType>;
  success?: Maybe<Scalars['Boolean']>;
};

/** A general setting in the context of coverage. */
export type SettingInCoverage = {
  __typename?: 'SettingInCoverage';
  displayName: Scalars['String'];
  slug: Scalars['String'];
  value: Scalars['Boolean'];
};

export type SetupProfile = {
  __typename?: 'SetupProfile';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  member?: Maybe<Member>;
  success: Scalars['Boolean'];
};

/** Skip onboarding questionnaire - permanent action per consultation. */
export type SkipOnboardingQuestionnaire = {
  __typename?: 'SkipOnboardingQuestionnaire';
  enrollment?: Maybe<UserConsultationEnrollmentType>;
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type StatusMessage = {
  __typename?: 'StatusMessage';
  code: Scalars['Int'];
  errors?: Maybe<Array<Maybe<Scalars['String']>>>;
  message?: Maybe<Scalars['String']>;
};

export type SubmitFreshdeskTicket = {
  __typename?: 'SubmitFreshdeskTicket';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

export type SubmitFreshdeskTicketAnonymously = {
  __typename?: 'SubmitFreshdeskTicketAnonymously';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** A subtreatment in the context of coverage. */
export type SubtreatmentInCoverage = {
  __typename?: 'SubtreatmentInCoverage';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  isLegal: Scalars['Boolean'];
};

/**
 * Implementation of the Help button
 *
 * Routes emails to a well-known email address based on incoming subject
 */
export type SupportRequest = {
  __typename?: 'SupportRequest';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** An enumeration. */
export enum Timezone {
  /** Africa/Abidjan */
  AfricaAbidjan = 'AFRICA_ABIDJAN',
  /** Africa/Accra */
  AfricaAccra = 'AFRICA_ACCRA',
  /** Africa/Addis_Ababa */
  AfricaAddisAbaba = 'AFRICA_ADDIS_ABABA',
  /** Africa/Algiers */
  AfricaAlgiers = 'AFRICA_ALGIERS',
  /** Africa/Asmara */
  AfricaAsmara = 'AFRICA_ASMARA',
  /** Africa/Asmera */
  AfricaAsmera = 'AFRICA_ASMERA',
  /** Africa/Bamako */
  AfricaBamako = 'AFRICA_BAMAKO',
  /** Africa/Bangui */
  AfricaBangui = 'AFRICA_BANGUI',
  /** Africa/Banjul */
  AfricaBanjul = 'AFRICA_BANJUL',
  /** Africa/Bissau */
  AfricaBissau = 'AFRICA_BISSAU',
  /** Africa/Blantyre */
  AfricaBlantyre = 'AFRICA_BLANTYRE',
  /** Africa/Brazzaville */
  AfricaBrazzaville = 'AFRICA_BRAZZAVILLE',
  /** Africa/Bujumbura */
  AfricaBujumbura = 'AFRICA_BUJUMBURA',
  /** Africa/Cairo */
  AfricaCairo = 'AFRICA_CAIRO',
  /** Africa/Casablanca */
  AfricaCasablanca = 'AFRICA_CASABLANCA',
  /** Africa/Ceuta */
  AfricaCeuta = 'AFRICA_CEUTA',
  /** Africa/Conakry */
  AfricaConakry = 'AFRICA_CONAKRY',
  /** Africa/Dakar */
  AfricaDakar = 'AFRICA_DAKAR',
  /** Africa/Dar_es_Salaam */
  AfricaDarEsSalaam = 'AFRICA_DAR_ES_SALAAM',
  /** Africa/Djibouti */
  AfricaDjibouti = 'AFRICA_DJIBOUTI',
  /** Africa/Douala */
  AfricaDouala = 'AFRICA_DOUALA',
  /** Africa/El_Aaiun */
  AfricaElAaiun = 'AFRICA_EL_AAIUN',
  /** Africa/Freetown */
  AfricaFreetown = 'AFRICA_FREETOWN',
  /** Africa/Gaborone */
  AfricaGaborone = 'AFRICA_GABORONE',
  /** Africa/Harare */
  AfricaHarare = 'AFRICA_HARARE',
  /** Africa/Johannesburg */
  AfricaJohannesburg = 'AFRICA_JOHANNESBURG',
  /** Africa/Juba */
  AfricaJuba = 'AFRICA_JUBA',
  /** Africa/Kampala */
  AfricaKampala = 'AFRICA_KAMPALA',
  /** Africa/Khartoum */
  AfricaKhartoum = 'AFRICA_KHARTOUM',
  /** Africa/Kigali */
  AfricaKigali = 'AFRICA_KIGALI',
  /** Africa/Kinshasa */
  AfricaKinshasa = 'AFRICA_KINSHASA',
  /** Africa/Lagos */
  AfricaLagos = 'AFRICA_LAGOS',
  /** Africa/Libreville */
  AfricaLibreville = 'AFRICA_LIBREVILLE',
  /** Africa/Lome */
  AfricaLome = 'AFRICA_LOME',
  /** Africa/Luanda */
  AfricaLuanda = 'AFRICA_LUANDA',
  /** Africa/Lubumbashi */
  AfricaLubumbashi = 'AFRICA_LUBUMBASHI',
  /** Africa/Lusaka */
  AfricaLusaka = 'AFRICA_LUSAKA',
  /** Africa/Malabo */
  AfricaMalabo = 'AFRICA_MALABO',
  /** Africa/Maputo */
  AfricaMaputo = 'AFRICA_MAPUTO',
  /** Africa/Maseru */
  AfricaMaseru = 'AFRICA_MASERU',
  /** Africa/Mbabane */
  AfricaMbabane = 'AFRICA_MBABANE',
  /** Africa/Mogadishu */
  AfricaMogadishu = 'AFRICA_MOGADISHU',
  /** Africa/Monrovia */
  AfricaMonrovia = 'AFRICA_MONROVIA',
  /** Africa/Nairobi */
  AfricaNairobi = 'AFRICA_NAIROBI',
  /** Africa/Ndjamena */
  AfricaNdjamena = 'AFRICA_NDJAMENA',
  /** Africa/Niamey */
  AfricaNiamey = 'AFRICA_NIAMEY',
  /** Africa/Nouakchott */
  AfricaNouakchott = 'AFRICA_NOUAKCHOTT',
  /** Africa/Ouagadougou */
  AfricaOuagadougou = 'AFRICA_OUAGADOUGOU',
  /** Africa/Porto-Novo */
  AfricaPortoNovo = 'AFRICA_PORTO_NOVO',
  /** Africa/Sao_Tome */
  AfricaSaoTome = 'AFRICA_SAO_TOME',
  /** Africa/Timbuktu */
  AfricaTimbuktu = 'AFRICA_TIMBUKTU',
  /** Africa/Tripoli */
  AfricaTripoli = 'AFRICA_TRIPOLI',
  /** Africa/Tunis */
  AfricaTunis = 'AFRICA_TUNIS',
  /** Africa/Windhoek */
  AfricaWindhoek = 'AFRICA_WINDHOEK',
  /** America/Adak */
  AmericaAdak = 'AMERICA_ADAK',
  /** America/Anchorage */
  AmericaAnchorage = 'AMERICA_ANCHORAGE',
  /** America/Anguilla */
  AmericaAnguilla = 'AMERICA_ANGUILLA',
  /** America/Antigua */
  AmericaAntigua = 'AMERICA_ANTIGUA',
  /** America/Araguaina */
  AmericaAraguaina = 'AMERICA_ARAGUAINA',
  /** America/Argentina/Buenos_Aires */
  AmericaArgentinaBuenosAires = 'AMERICA_ARGENTINA_BUENOS_AIRES',
  /** America/Argentina/Catamarca */
  AmericaArgentinaCatamarca = 'AMERICA_ARGENTINA_CATAMARCA',
  /** America/Argentina/ComodRivadavia */
  AmericaArgentinaComodrivadavia = 'AMERICA_ARGENTINA_COMODRIVADAVIA',
  /** America/Argentina/Cordoba */
  AmericaArgentinaCordoba = 'AMERICA_ARGENTINA_CORDOBA',
  /** America/Argentina/Jujuy */
  AmericaArgentinaJujuy = 'AMERICA_ARGENTINA_JUJUY',
  /** America/Argentina/La_Rioja */
  AmericaArgentinaLaRioja = 'AMERICA_ARGENTINA_LA_RIOJA',
  /** America/Argentina/Mendoza */
  AmericaArgentinaMendoza = 'AMERICA_ARGENTINA_MENDOZA',
  /** America/Argentina/Rio_Gallegos */
  AmericaArgentinaRioGallegos = 'AMERICA_ARGENTINA_RIO_GALLEGOS',
  /** America/Argentina/Salta */
  AmericaArgentinaSalta = 'AMERICA_ARGENTINA_SALTA',
  /** America/Argentina/San_Juan */
  AmericaArgentinaSanJuan = 'AMERICA_ARGENTINA_SAN_JUAN',
  /** America/Argentina/San_Luis */
  AmericaArgentinaSanLuis = 'AMERICA_ARGENTINA_SAN_LUIS',
  /** America/Argentina/Tucuman */
  AmericaArgentinaTucuman = 'AMERICA_ARGENTINA_TUCUMAN',
  /** America/Argentina/Ushuaia */
  AmericaArgentinaUshuaia = 'AMERICA_ARGENTINA_USHUAIA',
  /** America/Aruba */
  AmericaAruba = 'AMERICA_ARUBA',
  /** America/Asuncion */
  AmericaAsuncion = 'AMERICA_ASUNCION',
  /** America/Atikokan */
  AmericaAtikokan = 'AMERICA_ATIKOKAN',
  /** America/Atka */
  AmericaAtka = 'AMERICA_ATKA',
  /** America/Bahia */
  AmericaBahia = 'AMERICA_BAHIA',
  /** America/Bahia_Banderas */
  AmericaBahiaBanderas = 'AMERICA_BAHIA_BANDERAS',
  /** America/Barbados */
  AmericaBarbados = 'AMERICA_BARBADOS',
  /** America/Belem */
  AmericaBelem = 'AMERICA_BELEM',
  /** America/Belize */
  AmericaBelize = 'AMERICA_BELIZE',
  /** America/Blanc-Sablon */
  AmericaBlancSablon = 'AMERICA_BLANC_SABLON',
  /** America/Boa_Vista */
  AmericaBoaVista = 'AMERICA_BOA_VISTA',
  /** America/Bogota */
  AmericaBogota = 'AMERICA_BOGOTA',
  /** America/Boise */
  AmericaBoise = 'AMERICA_BOISE',
  /** America/Buenos_Aires */
  AmericaBuenosAires = 'AMERICA_BUENOS_AIRES',
  /** America/Cambridge_Bay */
  AmericaCambridgeBay = 'AMERICA_CAMBRIDGE_BAY',
  /** America/Campo_Grande */
  AmericaCampoGrande = 'AMERICA_CAMPO_GRANDE',
  /** America/Cancun */
  AmericaCancun = 'AMERICA_CANCUN',
  /** America/Caracas */
  AmericaCaracas = 'AMERICA_CARACAS',
  /** America/Catamarca */
  AmericaCatamarca = 'AMERICA_CATAMARCA',
  /** America/Cayenne */
  AmericaCayenne = 'AMERICA_CAYENNE',
  /** America/Cayman */
  AmericaCayman = 'AMERICA_CAYMAN',
  /** America/Chicago */
  AmericaChicago = 'AMERICA_CHICAGO',
  /** America/Chihuahua */
  AmericaChihuahua = 'AMERICA_CHIHUAHUA',
  /** America/Ciudad_Juarez */
  AmericaCiudadJuarez = 'AMERICA_CIUDAD_JUAREZ',
  /** America/Coral_Harbour */
  AmericaCoralHarbour = 'AMERICA_CORAL_HARBOUR',
  /** America/Cordoba */
  AmericaCordoba = 'AMERICA_CORDOBA',
  /** America/Costa_Rica */
  AmericaCostaRica = 'AMERICA_COSTA_RICA',
  /** America/Coyhaique */
  AmericaCoyhaique = 'AMERICA_COYHAIQUE',
  /** America/Creston */
  AmericaCreston = 'AMERICA_CRESTON',
  /** America/Cuiaba */
  AmericaCuiaba = 'AMERICA_CUIABA',
  /** America/Curacao */
  AmericaCuracao = 'AMERICA_CURACAO',
  /** America/Danmarkshavn */
  AmericaDanmarkshavn = 'AMERICA_DANMARKSHAVN',
  /** America/Dawson */
  AmericaDawson = 'AMERICA_DAWSON',
  /** America/Dawson_Creek */
  AmericaDawsonCreek = 'AMERICA_DAWSON_CREEK',
  /** America/Denver */
  AmericaDenver = 'AMERICA_DENVER',
  /** America/Detroit */
  AmericaDetroit = 'AMERICA_DETROIT',
  /** America/Dominica */
  AmericaDominica = 'AMERICA_DOMINICA',
  /** America/Edmonton */
  AmericaEdmonton = 'AMERICA_EDMONTON',
  /** America/Eirunepe */
  AmericaEirunepe = 'AMERICA_EIRUNEPE',
  /** America/El_Salvador */
  AmericaElSalvador = 'AMERICA_EL_SALVADOR',
  /** America/Ensenada */
  AmericaEnsenada = 'AMERICA_ENSENADA',
  /** America/Fortaleza */
  AmericaFortaleza = 'AMERICA_FORTALEZA',
  /** America/Fort_Nelson */
  AmericaFortNelson = 'AMERICA_FORT_NELSON',
  /** America/Fort_Wayne */
  AmericaFortWayne = 'AMERICA_FORT_WAYNE',
  /** America/Glace_Bay */
  AmericaGlaceBay = 'AMERICA_GLACE_BAY',
  /** America/Godthab */
  AmericaGodthab = 'AMERICA_GODTHAB',
  /** America/Goose_Bay */
  AmericaGooseBay = 'AMERICA_GOOSE_BAY',
  /** America/Grand_Turk */
  AmericaGrandTurk = 'AMERICA_GRAND_TURK',
  /** America/Grenada */
  AmericaGrenada = 'AMERICA_GRENADA',
  /** America/Guadeloupe */
  AmericaGuadeloupe = 'AMERICA_GUADELOUPE',
  /** America/Guatemala */
  AmericaGuatemala = 'AMERICA_GUATEMALA',
  /** America/Guayaquil */
  AmericaGuayaquil = 'AMERICA_GUAYAQUIL',
  /** America/Guyana */
  AmericaGuyana = 'AMERICA_GUYANA',
  /** America/Halifax */
  AmericaHalifax = 'AMERICA_HALIFAX',
  /** America/Havana */
  AmericaHavana = 'AMERICA_HAVANA',
  /** America/Hermosillo */
  AmericaHermosillo = 'AMERICA_HERMOSILLO',
  /** America/Indianapolis */
  AmericaIndianapolis = 'AMERICA_INDIANAPOLIS',
  /** America/Indiana/Indianapolis */
  AmericaIndianaIndianapolis = 'AMERICA_INDIANA_INDIANAPOLIS',
  /** America/Indiana/Knox */
  AmericaIndianaKnox = 'AMERICA_INDIANA_KNOX',
  /** America/Indiana/Marengo */
  AmericaIndianaMarengo = 'AMERICA_INDIANA_MARENGO',
  /** America/Indiana/Petersburg */
  AmericaIndianaPetersburg = 'AMERICA_INDIANA_PETERSBURG',
  /** America/Indiana/Tell_City */
  AmericaIndianaTellCity = 'AMERICA_INDIANA_TELL_CITY',
  /** America/Indiana/Vevay */
  AmericaIndianaVevay = 'AMERICA_INDIANA_VEVAY',
  /** America/Indiana/Vincennes */
  AmericaIndianaVincennes = 'AMERICA_INDIANA_VINCENNES',
  /** America/Indiana/Winamac */
  AmericaIndianaWinamac = 'AMERICA_INDIANA_WINAMAC',
  /** America/Inuvik */
  AmericaInuvik = 'AMERICA_INUVIK',
  /** America/Iqaluit */
  AmericaIqaluit = 'AMERICA_IQALUIT',
  /** America/Jamaica */
  AmericaJamaica = 'AMERICA_JAMAICA',
  /** America/Jujuy */
  AmericaJujuy = 'AMERICA_JUJUY',
  /** America/Juneau */
  AmericaJuneau = 'AMERICA_JUNEAU',
  /** America/Kentucky/Louisville */
  AmericaKentuckyLouisville = 'AMERICA_KENTUCKY_LOUISVILLE',
  /** America/Kentucky/Monticello */
  AmericaKentuckyMonticello = 'AMERICA_KENTUCKY_MONTICELLO',
  /** America/Knox_IN */
  AmericaKnoxIn = 'AMERICA_KNOX_IN',
  /** America/Kralendijk */
  AmericaKralendijk = 'AMERICA_KRALENDIJK',
  /** America/La_Paz */
  AmericaLaPaz = 'AMERICA_LA_PAZ',
  /** America/Lima */
  AmericaLima = 'AMERICA_LIMA',
  /** America/Los_Angeles */
  AmericaLosAngeles = 'AMERICA_LOS_ANGELES',
  /** America/Louisville */
  AmericaLouisville = 'AMERICA_LOUISVILLE',
  /** America/Lower_Princes */
  AmericaLowerPrinces = 'AMERICA_LOWER_PRINCES',
  /** America/Maceio */
  AmericaMaceio = 'AMERICA_MACEIO',
  /** America/Managua */
  AmericaManagua = 'AMERICA_MANAGUA',
  /** America/Manaus */
  AmericaManaus = 'AMERICA_MANAUS',
  /** America/Marigot */
  AmericaMarigot = 'AMERICA_MARIGOT',
  /** America/Martinique */
  AmericaMartinique = 'AMERICA_MARTINIQUE',
  /** America/Matamoros */
  AmericaMatamoros = 'AMERICA_MATAMOROS',
  /** America/Mazatlan */
  AmericaMazatlan = 'AMERICA_MAZATLAN',
  /** America/Mendoza */
  AmericaMendoza = 'AMERICA_MENDOZA',
  /** America/Menominee */
  AmericaMenominee = 'AMERICA_MENOMINEE',
  /** America/Merida */
  AmericaMerida = 'AMERICA_MERIDA',
  /** America/Metlakatla */
  AmericaMetlakatla = 'AMERICA_METLAKATLA',
  /** America/Mexico_City */
  AmericaMexicoCity = 'AMERICA_MEXICO_CITY',
  /** America/Miquelon */
  AmericaMiquelon = 'AMERICA_MIQUELON',
  /** America/Moncton */
  AmericaMoncton = 'AMERICA_MONCTON',
  /** America/Monterrey */
  AmericaMonterrey = 'AMERICA_MONTERREY',
  /** America/Montevideo */
  AmericaMontevideo = 'AMERICA_MONTEVIDEO',
  /** America/Montreal */
  AmericaMontreal = 'AMERICA_MONTREAL',
  /** America/Montserrat */
  AmericaMontserrat = 'AMERICA_MONTSERRAT',
  /** America/Nassau */
  AmericaNassau = 'AMERICA_NASSAU',
  /** America/New_York */
  AmericaNewYork = 'AMERICA_NEW_YORK',
  /** America/Nipigon */
  AmericaNipigon = 'AMERICA_NIPIGON',
  /** America/Nome */
  AmericaNome = 'AMERICA_NOME',
  /** America/Noronha */
  AmericaNoronha = 'AMERICA_NORONHA',
  /** America/North_Dakota/Beulah */
  AmericaNorthDakotaBeulah = 'AMERICA_NORTH_DAKOTA_BEULAH',
  /** America/North_Dakota/Center */
  AmericaNorthDakotaCenter = 'AMERICA_NORTH_DAKOTA_CENTER',
  /** America/North_Dakota/New_Salem */
  AmericaNorthDakotaNewSalem = 'AMERICA_NORTH_DAKOTA_NEW_SALEM',
  /** America/Nuuk */
  AmericaNuuk = 'AMERICA_NUUK',
  /** America/Ojinaga */
  AmericaOjinaga = 'AMERICA_OJINAGA',
  /** America/Panama */
  AmericaPanama = 'AMERICA_PANAMA',
  /** America/Pangnirtung */
  AmericaPangnirtung = 'AMERICA_PANGNIRTUNG',
  /** America/Paramaribo */
  AmericaParamaribo = 'AMERICA_PARAMARIBO',
  /** America/Phoenix */
  AmericaPhoenix = 'AMERICA_PHOENIX',
  /** America/Porto_Acre */
  AmericaPortoAcre = 'AMERICA_PORTO_ACRE',
  /** America/Porto_Velho */
  AmericaPortoVelho = 'AMERICA_PORTO_VELHO',
  /** America/Port-au-Prince */
  AmericaPortAuPrince = 'AMERICA_PORT_AU_PRINCE',
  /** America/Port_of_Spain */
  AmericaPortOfSpain = 'AMERICA_PORT_OF_SPAIN',
  /** America/Puerto_Rico */
  AmericaPuertoRico = 'AMERICA_PUERTO_RICO',
  /** America/Punta_Arenas */
  AmericaPuntaArenas = 'AMERICA_PUNTA_ARENAS',
  /** America/Rainy_River */
  AmericaRainyRiver = 'AMERICA_RAINY_RIVER',
  /** America/Rankin_Inlet */
  AmericaRankinInlet = 'AMERICA_RANKIN_INLET',
  /** America/Recife */
  AmericaRecife = 'AMERICA_RECIFE',
  /** America/Regina */
  AmericaRegina = 'AMERICA_REGINA',
  /** America/Resolute */
  AmericaResolute = 'AMERICA_RESOLUTE',
  /** America/Rio_Branco */
  AmericaRioBranco = 'AMERICA_RIO_BRANCO',
  /** America/Rosario */
  AmericaRosario = 'AMERICA_ROSARIO',
  /** America/Santarem */
  AmericaSantarem = 'AMERICA_SANTAREM',
  /** America/Santa_Isabel */
  AmericaSantaIsabel = 'AMERICA_SANTA_ISABEL',
  /** America/Santiago */
  AmericaSantiago = 'AMERICA_SANTIAGO',
  /** America/Santo_Domingo */
  AmericaSantoDomingo = 'AMERICA_SANTO_DOMINGO',
  /** America/Sao_Paulo */
  AmericaSaoPaulo = 'AMERICA_SAO_PAULO',
  /** America/Scoresbysund */
  AmericaScoresbysund = 'AMERICA_SCORESBYSUND',
  /** America/Shiprock */
  AmericaShiprock = 'AMERICA_SHIPROCK',
  /** America/Sitka */
  AmericaSitka = 'AMERICA_SITKA',
  /** America/St_Barthelemy */
  AmericaStBarthelemy = 'AMERICA_ST_BARTHELEMY',
  /** America/St_Johns */
  AmericaStJohns = 'AMERICA_ST_JOHNS',
  /** America/St_Kitts */
  AmericaStKitts = 'AMERICA_ST_KITTS',
  /** America/St_Lucia */
  AmericaStLucia = 'AMERICA_ST_LUCIA',
  /** America/St_Thomas */
  AmericaStThomas = 'AMERICA_ST_THOMAS',
  /** America/St_Vincent */
  AmericaStVincent = 'AMERICA_ST_VINCENT',
  /** America/Swift_Current */
  AmericaSwiftCurrent = 'AMERICA_SWIFT_CURRENT',
  /** America/Tegucigalpa */
  AmericaTegucigalpa = 'AMERICA_TEGUCIGALPA',
  /** America/Thule */
  AmericaThule = 'AMERICA_THULE',
  /** America/Thunder_Bay */
  AmericaThunderBay = 'AMERICA_THUNDER_BAY',
  /** America/Tijuana */
  AmericaTijuana = 'AMERICA_TIJUANA',
  /** America/Toronto */
  AmericaToronto = 'AMERICA_TORONTO',
  /** America/Tortola */
  AmericaTortola = 'AMERICA_TORTOLA',
  /** America/Vancouver */
  AmericaVancouver = 'AMERICA_VANCOUVER',
  /** America/Virgin */
  AmericaVirgin = 'AMERICA_VIRGIN',
  /** America/Whitehorse */
  AmericaWhitehorse = 'AMERICA_WHITEHORSE',
  /** America/Winnipeg */
  AmericaWinnipeg = 'AMERICA_WINNIPEG',
  /** America/Yakutat */
  AmericaYakutat = 'AMERICA_YAKUTAT',
  /** America/Yellowknife */
  AmericaYellowknife = 'AMERICA_YELLOWKNIFE',
  /** Antarctica/Casey */
  AntarcticaCasey = 'ANTARCTICA_CASEY',
  /** Antarctica/Davis */
  AntarcticaDavis = 'ANTARCTICA_DAVIS',
  /** Antarctica/DumontDUrville */
  AntarcticaDumontdurville = 'ANTARCTICA_DUMONTDURVILLE',
  /** Antarctica/Macquarie */
  AntarcticaMacquarie = 'ANTARCTICA_MACQUARIE',
  /** Antarctica/Mawson */
  AntarcticaMawson = 'ANTARCTICA_MAWSON',
  /** Antarctica/McMurdo */
  AntarcticaMcmurdo = 'ANTARCTICA_MCMURDO',
  /** Antarctica/Palmer */
  AntarcticaPalmer = 'ANTARCTICA_PALMER',
  /** Antarctica/Rothera */
  AntarcticaRothera = 'ANTARCTICA_ROTHERA',
  /** Antarctica/South_Pole */
  AntarcticaSouthPole = 'ANTARCTICA_SOUTH_POLE',
  /** Antarctica/Syowa */
  AntarcticaSyowa = 'ANTARCTICA_SYOWA',
  /** Antarctica/Troll */
  AntarcticaTroll = 'ANTARCTICA_TROLL',
  /** Antarctica/Vostok */
  AntarcticaVostok = 'ANTARCTICA_VOSTOK',
  /** Arctic/Longyearbyen */
  ArcticLongyearbyen = 'ARCTIC_LONGYEARBYEN',
  /** Asia/Aden */
  AsiaAden = 'ASIA_ADEN',
  /** Asia/Almaty */
  AsiaAlmaty = 'ASIA_ALMATY',
  /** Asia/Amman */
  AsiaAmman = 'ASIA_AMMAN',
  /** Asia/Anadyr */
  AsiaAnadyr = 'ASIA_ANADYR',
  /** Asia/Aqtau */
  AsiaAqtau = 'ASIA_AQTAU',
  /** Asia/Aqtobe */
  AsiaAqtobe = 'ASIA_AQTOBE',
  /** Asia/Ashgabat */
  AsiaAshgabat = 'ASIA_ASHGABAT',
  /** Asia/Ashkhabad */
  AsiaAshkhabad = 'ASIA_ASHKHABAD',
  /** Asia/Atyrau */
  AsiaAtyrau = 'ASIA_ATYRAU',
  /** Asia/Baghdad */
  AsiaBaghdad = 'ASIA_BAGHDAD',
  /** Asia/Bahrain */
  AsiaBahrain = 'ASIA_BAHRAIN',
  /** Asia/Baku */
  AsiaBaku = 'ASIA_BAKU',
  /** Asia/Bangkok */
  AsiaBangkok = 'ASIA_BANGKOK',
  /** Asia/Barnaul */
  AsiaBarnaul = 'ASIA_BARNAUL',
  /** Asia/Beirut */
  AsiaBeirut = 'ASIA_BEIRUT',
  /** Asia/Bishkek */
  AsiaBishkek = 'ASIA_BISHKEK',
  /** Asia/Brunei */
  AsiaBrunei = 'ASIA_BRUNEI',
  /** Asia/Calcutta */
  AsiaCalcutta = 'ASIA_CALCUTTA',
  /** Asia/Chita */
  AsiaChita = 'ASIA_CHITA',
  /** Asia/Choibalsan */
  AsiaChoibalsan = 'ASIA_CHOIBALSAN',
  /** Asia/Chongqing */
  AsiaChongqing = 'ASIA_CHONGQING',
  /** Asia/Chungking */
  AsiaChungking = 'ASIA_CHUNGKING',
  /** Asia/Colombo */
  AsiaColombo = 'ASIA_COLOMBO',
  /** Asia/Dacca */
  AsiaDacca = 'ASIA_DACCA',
  /** Asia/Damascus */
  AsiaDamascus = 'ASIA_DAMASCUS',
  /** Asia/Dhaka */
  AsiaDhaka = 'ASIA_DHAKA',
  /** Asia/Dili */
  AsiaDili = 'ASIA_DILI',
  /** Asia/Dubai */
  AsiaDubai = 'ASIA_DUBAI',
  /** Asia/Dushanbe */
  AsiaDushanbe = 'ASIA_DUSHANBE',
  /** Asia/Famagusta */
  AsiaFamagusta = 'ASIA_FAMAGUSTA',
  /** Asia/Gaza */
  AsiaGaza = 'ASIA_GAZA',
  /** Asia/Harbin */
  AsiaHarbin = 'ASIA_HARBIN',
  /** Asia/Hebron */
  AsiaHebron = 'ASIA_HEBRON',
  /** Asia/Hong_Kong */
  AsiaHongKong = 'ASIA_HONG_KONG',
  /** Asia/Hovd */
  AsiaHovd = 'ASIA_HOVD',
  /** Asia/Ho_Chi_Minh */
  AsiaHoChiMinh = 'ASIA_HO_CHI_MINH',
  /** Asia/Irkutsk */
  AsiaIrkutsk = 'ASIA_IRKUTSK',
  /** Asia/Istanbul */
  AsiaIstanbul = 'ASIA_ISTANBUL',
  /** Asia/Jakarta */
  AsiaJakarta = 'ASIA_JAKARTA',
  /** Asia/Jayapura */
  AsiaJayapura = 'ASIA_JAYAPURA',
  /** Asia/Jerusalem */
  AsiaJerusalem = 'ASIA_JERUSALEM',
  /** Asia/Kabul */
  AsiaKabul = 'ASIA_KABUL',
  /** Asia/Kamchatka */
  AsiaKamchatka = 'ASIA_KAMCHATKA',
  /** Asia/Karachi */
  AsiaKarachi = 'ASIA_KARACHI',
  /** Asia/Kashgar */
  AsiaKashgar = 'ASIA_KASHGAR',
  /** Asia/Kathmandu */
  AsiaKathmandu = 'ASIA_KATHMANDU',
  /** Asia/Katmandu */
  AsiaKatmandu = 'ASIA_KATMANDU',
  /** Asia/Khandyga */
  AsiaKhandyga = 'ASIA_KHANDYGA',
  /** Asia/Kolkata */
  AsiaKolkata = 'ASIA_KOLKATA',
  /** Asia/Krasnoyarsk */
  AsiaKrasnoyarsk = 'ASIA_KRASNOYARSK',
  /** Asia/Kuala_Lumpur */
  AsiaKualaLumpur = 'ASIA_KUALA_LUMPUR',
  /** Asia/Kuching */
  AsiaKuching = 'ASIA_KUCHING',
  /** Asia/Kuwait */
  AsiaKuwait = 'ASIA_KUWAIT',
  /** Asia/Macao */
  AsiaMacao = 'ASIA_MACAO',
  /** Asia/Macau */
  AsiaMacau = 'ASIA_MACAU',
  /** Asia/Magadan */
  AsiaMagadan = 'ASIA_MAGADAN',
  /** Asia/Makassar */
  AsiaMakassar = 'ASIA_MAKASSAR',
  /** Asia/Manila */
  AsiaManila = 'ASIA_MANILA',
  /** Asia/Muscat */
  AsiaMuscat = 'ASIA_MUSCAT',
  /** Asia/Nicosia */
  AsiaNicosia = 'ASIA_NICOSIA',
  /** Asia/Novokuznetsk */
  AsiaNovokuznetsk = 'ASIA_NOVOKUZNETSK',
  /** Asia/Novosibirsk */
  AsiaNovosibirsk = 'ASIA_NOVOSIBIRSK',
  /** Asia/Omsk */
  AsiaOmsk = 'ASIA_OMSK',
  /** Asia/Oral */
  AsiaOral = 'ASIA_ORAL',
  /** Asia/Phnom_Penh */
  AsiaPhnomPenh = 'ASIA_PHNOM_PENH',
  /** Asia/Pontianak */
  AsiaPontianak = 'ASIA_PONTIANAK',
  /** Asia/Pyongyang */
  AsiaPyongyang = 'ASIA_PYONGYANG',
  /** Asia/Qatar */
  AsiaQatar = 'ASIA_QATAR',
  /** Asia/Qostanay */
  AsiaQostanay = 'ASIA_QOSTANAY',
  /** Asia/Qyzylorda */
  AsiaQyzylorda = 'ASIA_QYZYLORDA',
  /** Asia/Rangoon */
  AsiaRangoon = 'ASIA_RANGOON',
  /** Asia/Riyadh */
  AsiaRiyadh = 'ASIA_RIYADH',
  /** Asia/Saigon */
  AsiaSaigon = 'ASIA_SAIGON',
  /** Asia/Sakhalin */
  AsiaSakhalin = 'ASIA_SAKHALIN',
  /** Asia/Samarkand */
  AsiaSamarkand = 'ASIA_SAMARKAND',
  /** Asia/Seoul */
  AsiaSeoul = 'ASIA_SEOUL',
  /** Asia/Shanghai */
  AsiaShanghai = 'ASIA_SHANGHAI',
  /** Asia/Singapore */
  AsiaSingapore = 'ASIA_SINGAPORE',
  /** Asia/Srednekolymsk */
  AsiaSrednekolymsk = 'ASIA_SREDNEKOLYMSK',
  /** Asia/Taipei */
  AsiaTaipei = 'ASIA_TAIPEI',
  /** Asia/Tashkent */
  AsiaTashkent = 'ASIA_TASHKENT',
  /** Asia/Tbilisi */
  AsiaTbilisi = 'ASIA_TBILISI',
  /** Asia/Tehran */
  AsiaTehran = 'ASIA_TEHRAN',
  /** Asia/Tel_Aviv */
  AsiaTelAviv = 'ASIA_TEL_AVIV',
  /** Asia/Thimbu */
  AsiaThimbu = 'ASIA_THIMBU',
  /** Asia/Thimphu */
  AsiaThimphu = 'ASIA_THIMPHU',
  /** Asia/Tokyo */
  AsiaTokyo = 'ASIA_TOKYO',
  /** Asia/Tomsk */
  AsiaTomsk = 'ASIA_TOMSK',
  /** Asia/Ujung_Pandang */
  AsiaUjungPandang = 'ASIA_UJUNG_PANDANG',
  /** Asia/Ulaanbaatar */
  AsiaUlaanbaatar = 'ASIA_ULAANBAATAR',
  /** Asia/Ulan_Bator */
  AsiaUlanBator = 'ASIA_ULAN_BATOR',
  /** Asia/Urumqi */
  AsiaUrumqi = 'ASIA_URUMQI',
  /** Asia/Ust-Nera */
  AsiaUstNera = 'ASIA_UST_NERA',
  /** Asia/Vientiane */
  AsiaVientiane = 'ASIA_VIENTIANE',
  /** Asia/Vladivostok */
  AsiaVladivostok = 'ASIA_VLADIVOSTOK',
  /** Asia/Yakutsk */
  AsiaYakutsk = 'ASIA_YAKUTSK',
  /** Asia/Yangon */
  AsiaYangon = 'ASIA_YANGON',
  /** Asia/Yekaterinburg */
  AsiaYekaterinburg = 'ASIA_YEKATERINBURG',
  /** Asia/Yerevan */
  AsiaYerevan = 'ASIA_YEREVAN',
  /** Atlantic/Azores */
  AtlanticAzores = 'ATLANTIC_AZORES',
  /** Atlantic/Bermuda */
  AtlanticBermuda = 'ATLANTIC_BERMUDA',
  /** Atlantic/Canary */
  AtlanticCanary = 'ATLANTIC_CANARY',
  /** Atlantic/Cape_Verde */
  AtlanticCapeVerde = 'ATLANTIC_CAPE_VERDE',
  /** Atlantic/Faeroe */
  AtlanticFaeroe = 'ATLANTIC_FAEROE',
  /** Atlantic/Faroe */
  AtlanticFaroe = 'ATLANTIC_FAROE',
  /** Atlantic/Jan_Mayen */
  AtlanticJanMayen = 'ATLANTIC_JAN_MAYEN',
  /** Atlantic/Madeira */
  AtlanticMadeira = 'ATLANTIC_MADEIRA',
  /** Atlantic/Reykjavik */
  AtlanticReykjavik = 'ATLANTIC_REYKJAVIK',
  /** Atlantic/South_Georgia */
  AtlanticSouthGeorgia = 'ATLANTIC_SOUTH_GEORGIA',
  /** Atlantic/Stanley */
  AtlanticStanley = 'ATLANTIC_STANLEY',
  /** Atlantic/St_Helena */
  AtlanticStHelena = 'ATLANTIC_ST_HELENA',
  /** Australia/ACT */
  AustraliaAct = 'AUSTRALIA_ACT',
  /** Australia/Adelaide */
  AustraliaAdelaide = 'AUSTRALIA_ADELAIDE',
  /** Australia/Brisbane */
  AustraliaBrisbane = 'AUSTRALIA_BRISBANE',
  /** Australia/Broken_Hill */
  AustraliaBrokenHill = 'AUSTRALIA_BROKEN_HILL',
  /** Australia/Canberra */
  AustraliaCanberra = 'AUSTRALIA_CANBERRA',
  /** Australia/Currie */
  AustraliaCurrie = 'AUSTRALIA_CURRIE',
  /** Australia/Darwin */
  AustraliaDarwin = 'AUSTRALIA_DARWIN',
  /** Australia/Eucla */
  AustraliaEucla = 'AUSTRALIA_EUCLA',
  /** Australia/Hobart */
  AustraliaHobart = 'AUSTRALIA_HOBART',
  /** Australia/LHI */
  AustraliaLhi = 'AUSTRALIA_LHI',
  /** Australia/Lindeman */
  AustraliaLindeman = 'AUSTRALIA_LINDEMAN',
  /** Australia/Lord_Howe */
  AustraliaLordHowe = 'AUSTRALIA_LORD_HOWE',
  /** Australia/Melbourne */
  AustraliaMelbourne = 'AUSTRALIA_MELBOURNE',
  /** Australia/North */
  AustraliaNorth = 'AUSTRALIA_NORTH',
  /** Australia/NSW */
  AustraliaNsw = 'AUSTRALIA_NSW',
  /** Australia/Perth */
  AustraliaPerth = 'AUSTRALIA_PERTH',
  /** Australia/Queensland */
  AustraliaQueensland = 'AUSTRALIA_QUEENSLAND',
  /** Australia/South */
  AustraliaSouth = 'AUSTRALIA_SOUTH',
  /** Australia/Sydney */
  AustraliaSydney = 'AUSTRALIA_SYDNEY',
  /** Australia/Tasmania */
  AustraliaTasmania = 'AUSTRALIA_TASMANIA',
  /** Australia/Victoria */
  AustraliaVictoria = 'AUSTRALIA_VICTORIA',
  /** Australia/West */
  AustraliaWest = 'AUSTRALIA_WEST',
  /** Australia/Yancowinna */
  AustraliaYancowinna = 'AUSTRALIA_YANCOWINNA',
  /** Brazil/Acre */
  BrazilAcre = 'BRAZIL_ACRE',
  /** Brazil/DeNoronha */
  BrazilDenoronha = 'BRAZIL_DENORONHA',
  /** Brazil/East */
  BrazilEast = 'BRAZIL_EAST',
  /** Brazil/West */
  BrazilWest = 'BRAZIL_WEST',
  /** Canada/Atlantic */
  CanadaAtlantic = 'CANADA_ATLANTIC',
  /** Canada/Central */
  CanadaCentral = 'CANADA_CENTRAL',
  /** Canada/Eastern */
  CanadaEastern = 'CANADA_EASTERN',
  /** Canada/Mountain */
  CanadaMountain = 'CANADA_MOUNTAIN',
  /** Canada/Newfoundland */
  CanadaNewfoundland = 'CANADA_NEWFOUNDLAND',
  /** Canada/Pacific */
  CanadaPacific = 'CANADA_PACIFIC',
  /** Canada/Saskatchewan */
  CanadaSaskatchewan = 'CANADA_SASKATCHEWAN',
  /** Canada/Yukon */
  CanadaYukon = 'CANADA_YUKON',
  /** Chile/Continental */
  ChileContinental = 'CHILE_CONTINENTAL',
  /** Chile/EasterIsland */
  ChileEasterisland = 'CHILE_EASTERISLAND',
  /** Europe/Amsterdam */
  EuropeAmsterdam = 'EUROPE_AMSTERDAM',
  /** Europe/Andorra */
  EuropeAndorra = 'EUROPE_ANDORRA',
  /** Europe/Astrakhan */
  EuropeAstrakhan = 'EUROPE_ASTRAKHAN',
  /** Europe/Athens */
  EuropeAthens = 'EUROPE_ATHENS',
  /** Europe/Belfast */
  EuropeBelfast = 'EUROPE_BELFAST',
  /** Europe/Belgrade */
  EuropeBelgrade = 'EUROPE_BELGRADE',
  /** Europe/Berlin */
  EuropeBerlin = 'EUROPE_BERLIN',
  /** Europe/Bratislava */
  EuropeBratislava = 'EUROPE_BRATISLAVA',
  /** Europe/Brussels */
  EuropeBrussels = 'EUROPE_BRUSSELS',
  /** Europe/Bucharest */
  EuropeBucharest = 'EUROPE_BUCHAREST',
  /** Europe/Budapest */
  EuropeBudapest = 'EUROPE_BUDAPEST',
  /** Europe/Busingen */
  EuropeBusingen = 'EUROPE_BUSINGEN',
  /** Europe/Chisinau */
  EuropeChisinau = 'EUROPE_CHISINAU',
  /** Europe/Copenhagen */
  EuropeCopenhagen = 'EUROPE_COPENHAGEN',
  /** Europe/Dublin */
  EuropeDublin = 'EUROPE_DUBLIN',
  /** Europe/Gibraltar */
  EuropeGibraltar = 'EUROPE_GIBRALTAR',
  /** Europe/Guernsey */
  EuropeGuernsey = 'EUROPE_GUERNSEY',
  /** Europe/Helsinki */
  EuropeHelsinki = 'EUROPE_HELSINKI',
  /** Europe/Isle_of_Man */
  EuropeIsleOfMan = 'EUROPE_ISLE_OF_MAN',
  /** Europe/Istanbul */
  EuropeIstanbul = 'EUROPE_ISTANBUL',
  /** Europe/Jersey */
  EuropeJersey = 'EUROPE_JERSEY',
  /** Europe/Kaliningrad */
  EuropeKaliningrad = 'EUROPE_KALININGRAD',
  /** Europe/Kiev */
  EuropeKiev = 'EUROPE_KIEV',
  /** Europe/Kirov */
  EuropeKirov = 'EUROPE_KIROV',
  /** Europe/Kyiv */
  EuropeKyiv = 'EUROPE_KYIV',
  /** Europe/Lisbon */
  EuropeLisbon = 'EUROPE_LISBON',
  /** Europe/Ljubljana */
  EuropeLjubljana = 'EUROPE_LJUBLJANA',
  /** Europe/London */
  EuropeLondon = 'EUROPE_LONDON',
  /** Europe/Luxembourg */
  EuropeLuxembourg = 'EUROPE_LUXEMBOURG',
  /** Europe/Madrid */
  EuropeMadrid = 'EUROPE_MADRID',
  /** Europe/Malta */
  EuropeMalta = 'EUROPE_MALTA',
  /** Europe/Mariehamn */
  EuropeMariehamn = 'EUROPE_MARIEHAMN',
  /** Europe/Minsk */
  EuropeMinsk = 'EUROPE_MINSK',
  /** Europe/Monaco */
  EuropeMonaco = 'EUROPE_MONACO',
  /** Europe/Moscow */
  EuropeMoscow = 'EUROPE_MOSCOW',
  /** Europe/Nicosia */
  EuropeNicosia = 'EUROPE_NICOSIA',
  /** Europe/Oslo */
  EuropeOslo = 'EUROPE_OSLO',
  /** Europe/Paris */
  EuropeParis = 'EUROPE_PARIS',
  /** Europe/Podgorica */
  EuropePodgorica = 'EUROPE_PODGORICA',
  /** Europe/Prague */
  EuropePrague = 'EUROPE_PRAGUE',
  /** Europe/Riga */
  EuropeRiga = 'EUROPE_RIGA',
  /** Europe/Rome */
  EuropeRome = 'EUROPE_ROME',
  /** Europe/Samara */
  EuropeSamara = 'EUROPE_SAMARA',
  /** Europe/San_Marino */
  EuropeSanMarino = 'EUROPE_SAN_MARINO',
  /** Europe/Sarajevo */
  EuropeSarajevo = 'EUROPE_SARAJEVO',
  /** Europe/Saratov */
  EuropeSaratov = 'EUROPE_SARATOV',
  /** Europe/Simferopol */
  EuropeSimferopol = 'EUROPE_SIMFEROPOL',
  /** Europe/Skopje */
  EuropeSkopje = 'EUROPE_SKOPJE',
  /** Europe/Sofia */
  EuropeSofia = 'EUROPE_SOFIA',
  /** Europe/Stockholm */
  EuropeStockholm = 'EUROPE_STOCKHOLM',
  /** Europe/Tallinn */
  EuropeTallinn = 'EUROPE_TALLINN',
  /** Europe/Tirane */
  EuropeTirane = 'EUROPE_TIRANE',
  /** Europe/Tiraspol */
  EuropeTiraspol = 'EUROPE_TIRASPOL',
  /** Europe/Ulyanovsk */
  EuropeUlyanovsk = 'EUROPE_ULYANOVSK',
  /** Europe/Uzhgorod */
  EuropeUzhgorod = 'EUROPE_UZHGOROD',
  /** Europe/Vaduz */
  EuropeVaduz = 'EUROPE_VADUZ',
  /** Europe/Vatican */
  EuropeVatican = 'EUROPE_VATICAN',
  /** Europe/Vienna */
  EuropeVienna = 'EUROPE_VIENNA',
  /** Europe/Vilnius */
  EuropeVilnius = 'EUROPE_VILNIUS',
  /** Europe/Volgograd */
  EuropeVolgograd = 'EUROPE_VOLGOGRAD',
  /** Europe/Warsaw */
  EuropeWarsaw = 'EUROPE_WARSAW',
  /** Europe/Zagreb */
  EuropeZagreb = 'EUROPE_ZAGREB',
  /** Europe/Zaporozhye */
  EuropeZaporozhye = 'EUROPE_ZAPOROZHYE',
  /** Europe/Zurich */
  EuropeZurich = 'EUROPE_ZURICH',
  /** Indian/Antananarivo */
  IndianAntananarivo = 'INDIAN_ANTANANARIVO',
  /** Indian/Chagos */
  IndianChagos = 'INDIAN_CHAGOS',
  /** Indian/Christmas */
  IndianChristmas = 'INDIAN_CHRISTMAS',
  /** Indian/Cocos */
  IndianCocos = 'INDIAN_COCOS',
  /** Indian/Comoro */
  IndianComoro = 'INDIAN_COMORO',
  /** Indian/Kerguelen */
  IndianKerguelen = 'INDIAN_KERGUELEN',
  /** Indian/Mahe */
  IndianMahe = 'INDIAN_MAHE',
  /** Indian/Maldives */
  IndianMaldives = 'INDIAN_MALDIVES',
  /** Indian/Mauritius */
  IndianMauritius = 'INDIAN_MAURITIUS',
  /** Indian/Mayotte */
  IndianMayotte = 'INDIAN_MAYOTTE',
  /** Indian/Reunion */
  IndianReunion = 'INDIAN_REUNION',
  /** Mexico/BajaNorte */
  MexicoBajanorte = 'MEXICO_BAJANORTE',
  /** Mexico/BajaSur */
  MexicoBajasur = 'MEXICO_BAJASUR',
  /** Mexico/General */
  MexicoGeneral = 'MEXICO_GENERAL',
  /** Pacific/Apia */
  PacificApia = 'PACIFIC_APIA',
  /** Pacific/Auckland */
  PacificAuckland = 'PACIFIC_AUCKLAND',
  /** Pacific/Bougainville */
  PacificBougainville = 'PACIFIC_BOUGAINVILLE',
  /** Pacific/Chatham */
  PacificChatham = 'PACIFIC_CHATHAM',
  /** Pacific/Chuuk */
  PacificChuuk = 'PACIFIC_CHUUK',
  /** Pacific/Easter */
  PacificEaster = 'PACIFIC_EASTER',
  /** Pacific/Efate */
  PacificEfate = 'PACIFIC_EFATE',
  /** Pacific/Enderbury */
  PacificEnderbury = 'PACIFIC_ENDERBURY',
  /** Pacific/Fakaofo */
  PacificFakaofo = 'PACIFIC_FAKAOFO',
  /** Pacific/Fiji */
  PacificFiji = 'PACIFIC_FIJI',
  /** Pacific/Funafuti */
  PacificFunafuti = 'PACIFIC_FUNAFUTI',
  /** Pacific/Galapagos */
  PacificGalapagos = 'PACIFIC_GALAPAGOS',
  /** Pacific/Gambier */
  PacificGambier = 'PACIFIC_GAMBIER',
  /** Pacific/Guadalcanal */
  PacificGuadalcanal = 'PACIFIC_GUADALCANAL',
  /** Pacific/Guam */
  PacificGuam = 'PACIFIC_GUAM',
  /** Pacific/Honolulu */
  PacificHonolulu = 'PACIFIC_HONOLULU',
  /** Pacific/Johnston */
  PacificJohnston = 'PACIFIC_JOHNSTON',
  /** Pacific/Kanton */
  PacificKanton = 'PACIFIC_KANTON',
  /** Pacific/Kiritimati */
  PacificKiritimati = 'PACIFIC_KIRITIMATI',
  /** Pacific/Kosrae */
  PacificKosrae = 'PACIFIC_KOSRAE',
  /** Pacific/Kwajalein */
  PacificKwajalein = 'PACIFIC_KWAJALEIN',
  /** Pacific/Majuro */
  PacificMajuro = 'PACIFIC_MAJURO',
  /** Pacific/Marquesas */
  PacificMarquesas = 'PACIFIC_MARQUESAS',
  /** Pacific/Midway */
  PacificMidway = 'PACIFIC_MIDWAY',
  /** Pacific/Nauru */
  PacificNauru = 'PACIFIC_NAURU',
  /** Pacific/Niue */
  PacificNiue = 'PACIFIC_NIUE',
  /** Pacific/Norfolk */
  PacificNorfolk = 'PACIFIC_NORFOLK',
  /** Pacific/Noumea */
  PacificNoumea = 'PACIFIC_NOUMEA',
  /** Pacific/Pago_Pago */
  PacificPagoPago = 'PACIFIC_PAGO_PAGO',
  /** Pacific/Palau */
  PacificPalau = 'PACIFIC_PALAU',
  /** Pacific/Pitcairn */
  PacificPitcairn = 'PACIFIC_PITCAIRN',
  /** Pacific/Pohnpei */
  PacificPohnpei = 'PACIFIC_POHNPEI',
  /** Pacific/Ponape */
  PacificPonape = 'PACIFIC_PONAPE',
  /** Pacific/Port_Moresby */
  PacificPortMoresby = 'PACIFIC_PORT_MORESBY',
  /** Pacific/Rarotonga */
  PacificRarotonga = 'PACIFIC_RAROTONGA',
  /** Pacific/Saipan */
  PacificSaipan = 'PACIFIC_SAIPAN',
  /** Pacific/Samoa */
  PacificSamoa = 'PACIFIC_SAMOA',
  /** Pacific/Tahiti */
  PacificTahiti = 'PACIFIC_TAHITI',
  /** Pacific/Tarawa */
  PacificTarawa = 'PACIFIC_TARAWA',
  /** Pacific/Tongatapu */
  PacificTongatapu = 'PACIFIC_TONGATAPU',
  /** Pacific/Truk */
  PacificTruk = 'PACIFIC_TRUK',
  /** Pacific/Wake */
  PacificWake = 'PACIFIC_WAKE',
  /** Pacific/Wallis */
  PacificWallis = 'PACIFIC_WALLIS',
  /** Pacific/Yap */
  PacificYap = 'PACIFIC_YAP',
  /** US/Alaska */
  UsAlaska = 'US_ALASKA',
  /** US/Aleutian */
  UsAleutian = 'US_ALEUTIAN',
  /** US/Arizona */
  UsArizona = 'US_ARIZONA',
  /** US/Central */
  UsCentral = 'US_CENTRAL',
  /** US/Eastern */
  UsEastern = 'US_EASTERN',
  /** US/East-Indiana */
  UsEastIndiana = 'US_EAST_INDIANA',
  /** US/Hawaii */
  UsHawaii = 'US_HAWAII',
  /** US/Indiana-Starke */
  UsIndianaStarke = 'US_INDIANA_STARKE',
  /** US/Michigan */
  UsMichigan = 'US_MICHIGAN',
  /** US/Mountain */
  UsMountain = 'US_MOUNTAIN',
  /** US/Pacific */
  UsPacific = 'US_PACIFIC',
  /** US/Samoa */
  UsSamoa = 'US_SAMOA'
}

export type TimezoneMapping = {
  __typename?: 'TimezoneMapping';
  id: Scalars['String'];
  label: Scalars['String'];
};

/** Record that the logged-in member downloaded a referral letter for the given country. */
export type TrackReferralLetterDownload = {
  __typename?: 'TrackReferralLetterDownload';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

/** A payment made with a Pliant card. */
export type Transaction = {
  __typename?: 'Transaction';
  authorizedAt?: Maybe<Scalars['DateTime']>;
  billingAmount: DineroType;
  bookedAt?: Maybe<Scalars['DateTime']>;
  canUpload: Scalars['Boolean'];
  comment: Scalars['String'];
  confirmedAt?: Maybe<Scalars['DateTime']>;
  country: Country;
  coveredTransactionAmount?: Maybe<DineroType>;
  coveredWalletAmount?: Maybe<DineroType>;
  foreignExchangeFee?: Maybe<DineroType>;
  id: Scalars['Int'];
  isMedicallyNecessaryConfirmed: Scalars['Boolean'];
  isMedicallyNecessaryRequested: Scalars['Boolean'];
  localTime?: Maybe<Scalars['DateTime']>;
  merchantName: Scalars['String'];
  pliantId: Scalars['String'];
  reconciliationStatus: Option;
  refundedAmount?: Maybe<DineroType>;
  reuploadRequest?: Maybe<TransactionReuploadRequest>;
  reversedAt?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  transactionAmount: DineroType;
  type: Scalars['String'];
  uploads: Array<Maybe<TransactionUpload>>;
  walletAmount?: Maybe<DineroType>;
};

/** A Claims Ops request for the member to upload additional documents. */
export type TransactionReuploadRequest = {
  __typename?: 'TransactionReuploadRequest';
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['Int'];
};

/** A file uploaded by a member as a proof of payment for a transaction. */
export type TransactionUpload = {
  __typename?: 'TransactionUpload';
  fileContentType: Scalars['String'];
  fileName: Scalars['String'];
  /** The file size in bytes. */
  fileSize: Scalars['Int'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
};

export type Treatment = {
  __typename?: 'Treatment';
  isCovered: Scalars['Boolean'];
  label: Scalars['String'];
  requiresAdditionalInfo: Scalars['Boolean'];
  requiresCycle: Scalars['Boolean'];
  requiresRound: Scalars['Boolean'];
  value: Scalars['ID'];
};

/** A treatment in a country on the Navigator map. */
export type TreatmentInCountryInNavigator = {
  __typename?: 'TreatmentInCountryInNavigator';
  additionalInfo: Scalars['String'];
  ageRestrictions: Scalars['String'];
  availableTo: Array<Maybe<Scalars['String']>>;
  clinicsAvailable: Scalars['Boolean'];
  costsTooltip: Scalars['String'];
  countryCode: Scalars['String'];
  countryName: Scalars['String'];
  healthInsuranceCoverage: Array<Maybe<Scalars['String']>>;
  indicativeCosts: Scalars['String'];
  isCovered: Scalars['Boolean'];
  isLegal: Scalars['Boolean'];
  legalStatus: Scalars['String'];
  province: Scalars['String'];
  treatment: TreatmentInNavigator;
};

/** A treatment in the context of coverage. */
export type TreatmentInCoverage = {
  __typename?: 'TreatmentInCoverage';
  displayName: Scalars['String'];
  id: Scalars['Int'];
  isCovered: Scalars['Boolean'];
  isLegal: Scalars['Boolean'];
  legalStatus: Scalars['String'];
  subtreatments: Array<Maybe<SubtreatmentInCoverage>>;
};

/** A treatment in the context of the Navigator. */
export type TreatmentInNavigator = {
  __typename?: 'TreatmentInNavigator';
  availableInCountries: Array<Maybe<Scalars['String']>>;
  clinicsCounterparts: Array<Maybe<Scalars['String']>>;
  description: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['Int'];
};

/** A file uploaded by a member as their treatment plan drafted by a clinic. */
export type TreatmentPlan = {
  __typename?: 'TreatmentPlan';
  amount?: Maybe<DineroType>;
  comment: Scalars['String'];
  createdAt: Scalars['DateTime'];
  fileContentType: Scalars['String'];
  fileName: Scalars['String'];
  /** The file size in bytes. */
  fileSize: Scalars['Int'];
  fileUrl: Scalars['String'];
  id: Scalars['Int'];
  isFullAmount: Scalars['Boolean'];
  status: Option;
  updatedAt: Scalars['DateTime'];
  walletAmount?: Maybe<DineroType>;
};

export type UpdateAirwallexBeneficiary = {
  __typename?: 'UpdateAirwallexBeneficiary';
  beneficiary?: Maybe<Scalars['GenericScalar']>;
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  success: Scalars['Boolean'];
};

export type UpdatePersonalInformation = {
  __typename?: 'UpdatePersonalInformation';
  errorCode?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  member?: Maybe<Member>;
  success: Scalars['Boolean'];
  validationErrors?: Maybe<Array<Maybe<ErrorType>>>;
};

/**
 * User account used to authenticate.
 * Also defines the role of the user. Optionally associated with a company.
 */
export type User = {
  __typename?: 'User';
  company: Company;
  createdAt: Scalars['DateTime'];
  email: Scalars['String'];
  /** Employee number also known as personell number: ID used within the company to identify an employee. */
  employeeNumber?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  hygraphAuthToken: Scalars['String'];
  id: Scalars['String'];
  isEmailConfirmed: Scalars['Boolean'];
  isManager?: Maybe<Scalars['Boolean']>;
  isMember?: Maybe<Scalars['Boolean']>;
  journeyCommunicationEmail: Scalars['String'];
  lastName: Scalars['String'];
  member: Member;
};

export type UserConsultationEnrollmentType = {
  __typename?: 'UserConsultationEnrollmentType';
  consultation?: Maybe<ConsultationType>;
  /** Consultation-specific data like due_date, delivery_date, etc. */
  consultationContext: Scalars['JSONString'];
  createdAt: Scalars['DateTime'];
  id: Scalars['ID'];
  /** Onboarding assessment with structured question/answer pairs */
  onboardingAssessment?: Maybe<AssessmentType>;
  onboardingCallAppointment?: Maybe<AppointmentType>;
  onboardingCallCompletedAt?: Maybe<Scalars['DateTime']>;
  onboardingStatus?: Maybe<OnboardingStatusType>;
  status: ConsultationsUserConsultationEnrollmentStatusChoices;
  updatedAt: Scalars['DateTime'];
};

export type UserProgramEnrollmentType = {
  __typename?: 'UserProgramEnrollmentType';
  createdAt: Scalars['DateTime'];
  /** Whether user has acknowledged the program disclaimer (applies to emotional well-being programs) */
  disclaimerAcknowledged: Scalars['Boolean'];
  id: Scalars['ID'];
  program: ProgramType;
  referenceDate?: Maybe<Scalars['Date']>;
  sessionStatuses?: Maybe<Array<Maybe<SessionStatusType>>>;
  /** Session IDs skipped during prebooking */
  skippedSessions: Scalars['JSONString'];
  status: ConsultationsUserProgramEnrollmentStatusChoices;
  updatedAt: Scalars['DateTime'];
};

export type Wallet = {
  __typename?: 'Wallet';
  allocatedAmount?: Maybe<DineroType>;
  availableAmount?: Maybe<DineroType>;
  canBeUnfrozen: Scalars['Boolean'];
  canRenewCard: Scalars['Boolean'];
  cardHistory: Array<Maybe<Card>>;
  currentCard?: Maybe<Card>;
  id: Scalars['Int'];
  spentAmount?: Maybe<DineroType>;
  status: Scalars['String'];
  transactions: Array<Maybe<Transaction>>;
  treatmentPlans: Array<Maybe<TreatmentPlan>>;
};

export type ConsultationsMyAppointmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationsMyAppointmentsQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', myAppointments?: Array<{ __typename?: 'AppointmentType', id: string, scheduledTime?: string | null, status: ConsultationsAppointmentStatusChoices, canReschedule?: boolean | null, canJoin?: boolean | null, meetingLink?: string | null, calcomBookingUid?: string | null, appointmentType: ConsultationsAppointmentAppointmentTypeChoices, createdAt: string, updatedAt: string, programEnrollment?: { __typename?: 'UserProgramEnrollmentType', program: { __typename?: 'ProgramType', description?: string | null, id: string, slug: string, title?: string | null, sessions?: Array<{ __typename?: 'SessionType', title?: string | null } | null> | null } } | null, consultationEnrollment?: { __typename?: 'UserConsultationEnrollmentType', consultationContext: string, id: string, consultation?: { __typename?: 'ConsultationType', id: string, slug: string, title?: string | null } | null } | null } | null> | null } };

export type ConsultationsListQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationsListQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', consultations?: Array<{ __typename?: 'ConsultationType', id: string, slug: string, title?: string | null, description?: string | null, isEnrolled?: boolean | null } | null> | null } };

export type ConsultationsDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ConsultationsDetailQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', consultation?: { __typename?: 'ConsultationType', id: string, slug: string, title?: string | null, description?: string | null, onboardingCallRequired: boolean, onboardingQuestionnaireRequired: boolean, onboardingCalcomEventType?: string | null, onboardingTitle?: string | null, onboardingDescription?: string | null, onboardingButtonText?: string | null, isEnrolled?: boolean | null, myEnrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, consultationContext: string, status: ConsultationsUserConsultationEnrollmentStatusChoices, createdAt: string, updatedAt: string, onboardingAssessment?: { __typename?: 'AssessmentType', id: string, createdAt: string, updatedAt: string, replies?: Array<{ __typename?: 'AssessmentReplyType', id: string, question: string, questionGroup: string, answer: string, createdAt: string } | null> | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingCallRequired?: boolean | null, onboardingCallCompleted?: boolean | null, onboardingQuestionnaireRequired?: boolean | null, onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null, onboardingCallAppointment?: { __typename?: 'AppointmentType', id: string, scheduledTime?: string | null, status: ConsultationsAppointmentStatusChoices, canReschedule?: boolean | null, canJoin?: boolean | null, meetingLink?: string | null, calcomBookingUid?: string | null, appointmentType: ConsultationsAppointmentAppointmentTypeChoices, createdAt: string, updatedAt: string } | null } | null } | null } };

export type ConsultationsMyEnrollmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationsMyEnrollmentsQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', myConsultationEnrollments?: Array<{ __typename?: 'UserConsultationEnrollmentType', id: string, createdAt: string, consultationContext: string, status: ConsultationsUserConsultationEnrollmentStatusChoices, onboardingAssessment?: { __typename?: 'AssessmentType', id: string, createdAt: string, updatedAt: string, replies?: Array<{ __typename?: 'AssessmentReplyType', id: string, question: string, questionGroup: string, answer: string, createdAt: string } | null> | null } | null, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingCallRequired?: boolean | null, onboardingCallCompleted?: boolean | null, onboardingQuestionnaireRequired?: boolean | null, onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null } | null> | null, myProgramEnrollments?: Array<{ __typename?: 'UserProgramEnrollmentType', id: string, createdAt: string, status: ConsultationsUserProgramEnrollmentStatusChoices, program: { __typename?: 'ProgramType', id: string, slug: string, title?: string | null, bookingStrategy: ConsultationsProgramBookingStrategyChoices }, sessionStatuses?: Array<{ __typename?: 'SessionStatusType', status?: string | null, appointment?: { __typename?: 'AppointmentType', id: string, scheduledTime?: string | null, status: ConsultationsAppointmentStatusChoices, appointmentType: ConsultationsAppointmentAppointmentTypeChoices, canReschedule?: boolean | null, canJoin?: boolean | null, calcomBookingUid?: string | null, meetingLink?: string | null, createdAt: string, updatedAt: string } | null, session?: { __typename?: 'SessionType', id: string, sessionNumber: number, title?: string | null, subtitle?: string | null, description?: string | null, required: boolean } | null } | null> | null } | null> | null } };

export type EnrollInConsultationMutationVariables = Exact<{
  consultationId: Scalars['ID'];
  consultationContext?: InputMaybe<Scalars['JSONString']>;
}>;


export type EnrollInConsultationMutation = { __typename?: 'Mutation', enrollInConsultation?: { __typename?: 'EnrollInConsultation', success?: boolean | null, message?: string | null, enrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, createdAt: string, status: ConsultationsUserConsultationEnrollmentStatusChoices } | null } | null };

export type EnrollInProgramMutationVariables = Exact<{
  programId: Scalars['ID'];
  disclaimerAcknowledged?: InputMaybe<Scalars['Boolean']>;
}>;


export type EnrollInProgramMutation = { __typename?: 'Mutation', enrollInProgram?: { __typename?: 'EnrollInProgram', success?: boolean | null, message?: string | null, enrollment?: { __typename?: 'UserProgramEnrollmentType', id: string, createdAt: string, status: ConsultationsUserProgramEnrollmentStatusChoices, disclaimerAcknowledged: boolean, program: { __typename?: 'ProgramType', id: string, slug: string, title?: string | null } } | null } | null };

export type CompleteOnboardingQuestionnaireMutationVariables = Exact<{
  consultationId: Scalars['ID'];
  responses: Scalars['JSONString'];
}>;


export type CompleteOnboardingQuestionnaireMutation = { __typename?: 'Mutation', completeOnboardingQuestionnaire?: { __typename?: 'CompleteOnboardingQuestionnaire', success?: boolean | null, message?: string | null, enrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null, onboardingAssessment?: { __typename?: 'AssessmentType', id: string, createdAt: string, updatedAt: string, replies?: Array<{ __typename?: 'AssessmentReplyType', id: string, question: string, answer: string, createdAt: string } | null> | null } | null } | null } | null };

export type SkipOnboardingQuestionnaireMutationVariables = Exact<{
  consultationId: Scalars['ID'];
}>;


export type SkipOnboardingQuestionnaireMutation = { __typename?: 'Mutation', skipOnboardingQuestionnaire?: { __typename?: 'SkipOnboardingQuestionnaire', success?: boolean | null, message?: string | null, enrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null } | null } | null };

export type ConsultationsProgramsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationsProgramsQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', programs?: Array<{ __typename?: 'ProgramType', id: string, slug: string, title?: string | null, description?: string | null, previewDescription?: string | null, bookingStrategy: ConsultationsProgramBookingStrategyChoices, isEnrolled?: boolean | null, requireEnrollment: boolean, consultation?: { __typename?: 'ConsultationType', id: string, slug: string, title?: string | null, description?: string | null, onboardingTitle?: string | null, onboardingDescription?: string | null, onboardingButtonText?: string | null, onboardingCallRequired: boolean, onboardingQuestionnaireRequired: boolean, canEnrollInPrograms?: boolean | null, myEnrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingCallRequired?: boolean | null, onboardingCallCompleted?: boolean | null, onboardingQuestionnaireRequired?: boolean | null, onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null } | null } | null, sessions?: Array<{ __typename?: 'SessionType', id: string, sessionNumber: number, repeatable: boolean, required: boolean } | null> | null } | null> | null } };

export type ConsultationsProgramDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
}>;


export type ConsultationsProgramDetailQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', program?: { __typename?: 'ProgramType', id: string, slug: string, title?: string | null, description?: string | null, previewDescription?: string | null, bookingStrategy: ConsultationsProgramBookingStrategyChoices, enableLearnMoreContent: boolean, isEnrolled?: boolean | null, consultation?: { __typename?: 'ConsultationType', id: string, slug: string, title?: string | null, description?: string | null, onboardingTitle?: string | null, onboardingDescription?: string | null, onboardingButtonText?: string | null, onboardingCallRequired: boolean, onboardingQuestionnaireRequired: boolean, canEnrollInPrograms?: boolean | null, myEnrollment?: { __typename?: 'UserConsultationEnrollmentType', id: string, onboardingStatus?: { __typename?: 'OnboardingStatusType', onboardingCallRequired?: boolean | null, onboardingCallCompleted?: boolean | null, onboardingQuestionnaireRequired?: boolean | null, onboardingQuestionnaireCompleted?: boolean | null, onboardingQuestionnaireSkipped?: boolean | null } | null } | null } | null, sessions?: Array<{ __typename?: 'SessionType', id: string, sessionNumber: number, calcomEventType?: string | null, title?: string | null, subtitle?: string | null, description?: string | null, sessionDetail?: string | null, bookingDescription?: string | null, repeatable: boolean, required: boolean } | null> | null } | null, myProgramEnrollments?: Array<{ __typename?: 'UserProgramEnrollmentType', id: string, createdAt: string, status: ConsultationsUserProgramEnrollmentStatusChoices, program: { __typename?: 'ProgramType', id: string }, sessionStatuses?: Array<{ __typename?: 'SessionStatusType', status?: string | null, appointment?: { __typename?: 'AppointmentType', id: string, scheduledTime?: string | null, status: ConsultationsAppointmentStatusChoices, appointmentType: ConsultationsAppointmentAppointmentTypeChoices, canReschedule?: boolean | null, canJoin?: boolean | null, calcomBookingUid?: string | null, meetingLink?: string | null, createdAt: string, updatedAt: string } | null, session?: { __typename?: 'SessionType', id: string, sessionNumber: number, title?: string | null, subtitle?: string | null, description?: string | null, required: boolean } | null } | null> | null } | null> | null } };

export type ConsultationsProgramSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ConsultationsProgramSessionsQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', programs?: Array<{ __typename?: 'ProgramType', id: string, slug: string, title?: string | null } | null> | null } };

export type ConsultationsSessionBookingWindowQueryVariables = Exact<{
  sessionId: Scalars['ID'];
}>;


export type ConsultationsSessionBookingWindowQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', session?: { __typename?: 'SessionType', id: string, sessionNumber: number, calcomEventType?: string | null, title?: string | null, bookingDescription?: string | null, required: boolean, program: { __typename?: 'ProgramType', id: string, slug: string }, bookingWindow?: { __typename?: 'BookingWindowStatusType', isBookable?: boolean | null, windowStatus?: string | null, startDate?: string | null, endDate?: string | null, message?: string | null } | null } | null } };

export type SessionBookingParamsQueryVariables = Exact<{
  sessionId: Scalars['Int'];
}>;


export type SessionBookingParamsQuery = { __typename?: 'Query', consultations: { __typename?: 'Consultations', sessionBookingParams?: { __typename?: 'SessionBookingParamsType', metadata?: string | null, routedTeamMemberIds?: Array<number | null> | null, language?: string | null, languageLocked?: boolean | null } | null } };

export type SetSessionSkippedMutationVariables = Exact<{
  programEnrollmentId: Scalars['ID'];
  sessionId: Scalars['ID'];
  skipped: Scalars['Boolean'];
}>;


export type SetSessionSkippedMutation = { __typename?: 'Mutation', setSessionSkipped?: { __typename?: 'SetSessionSkipped', success?: boolean | null, message?: string | null, sessionStatus?: { __typename?: 'SessionStatusType', status?: string | null, session?: { __typename?: 'SessionType', id: string, sessionNumber: number } | null } | null } | null };

export type ActivateWalletMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ActivateWalletMutation = { __typename?: 'Mutation', activateWallet?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type FreezeWalletMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type FreezeWalletMutation = { __typename?: 'Mutation', freezeWallet?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RenewCardMutationVariables = Exact<{
  wallet: Scalars['Int'];
}>;


export type RenewCardMutation = { __typename?: 'Mutation', renewCard?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RetryClaimPayoutMutationVariables = Exact<{
  claimId: Scalars['ID'];
}>;


export type RetryClaimPayoutMutation = { __typename?: 'Mutation', retryClaimPayout?: { __typename?: 'RetryClaimPayout', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UnFreezeWalletMutationVariables = Exact<{
  id: Scalars['Int'];
}>;


export type UnFreezeWalletMutation = { __typename?: 'Mutation', unfreezeWallet?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AddPartnerMutationVariables = Exact<{
  memberCity: Scalars['String'];
  memberCountry: Scalars['String'];
  memberPostcode: Scalars['String'];
  memberStreetAddress: Scalars['String'];
  partnerDateOfBirth: Scalars['Date'];
  partnerEmail: Scalars['String'];
  partnerFirstName: Scalars['String'];
  partnerLastName: Scalars['String'];
  sameEmployer: Scalars['Boolean'];
  sameHousehold: Scalars['Boolean'];
  partnerEmployeeNumber?: InputMaybe<Scalars['String']>;
  partnerCity?: InputMaybe<Scalars['String']>;
  partnerCountry?: InputMaybe<Scalars['String']>;
  partnerPostcode?: InputMaybe<Scalars['String']>;
  partnerStreetAddress?: InputMaybe<Scalars['String']>;
}>;


export type AddPartnerMutation = { __typename?: 'Mutation', addPartner?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type AddFilesMutationVariables = Exact<{
  transaction: Scalars['Int'];
  files: Array<InputMaybe<Scalars['Upload']>> | InputMaybe<Scalars['Upload']>;
  isMedicallyNecessaryTreatment?: InputMaybe<Scalars['Boolean']>;
}>;


export type AddFilesMutation = { __typename?: 'Mutation', addTransactionUploads?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UploadPlanMutationVariables = Exact<{
  wallet: Scalars['Int'];
  file: Scalars['Upload'];
}>;


export type UploadPlanMutation = { __typename?: 'Mutation', addTreatmentPlan?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type AddWalletPhoneNumberMutationVariables = Exact<{
  phoneNumber: Scalars['String'];
}>;


export type AddWalletPhoneNumberMutation = { __typename?: 'Mutation', changePhoneNumber?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ChangeLanguageMutationVariables = Exact<{
  language: Scalars['String'];
}>;


export type ChangeLanguageMutation = { __typename?: 'Mutation', changeLanguage?: { __typename?: 'ChangeLanguage', success: boolean, errorCode?: string | null } | null };

export type ChangeNationalityMutationVariables = Exact<{
  nationality: Scalars['String'];
}>;


export type ChangeNationalityMutation = { __typename?: 'Mutation', changeNationality?: { __typename?: 'MutationResult', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ChangePasswordMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword?: { __typename?: 'StatusMessage', code: number, message?: string | null, errors?: Array<string | null> | null } | null };

export type ConfirmUserEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmUserEmailMutation = { __typename?: 'Mutation', confirmUserEmail?: { __typename?: 'StatusMessage', code: number, message?: string | null, errors?: Array<string | null> | null } | null };

export type ConfirmPrivateEmailMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ConfirmPrivateEmailMutation = { __typename?: 'Mutation', confirmPrivateEmail?: { __typename?: 'ConfirmPrivateEmail', success: boolean, errorCode?: string | null } | null };

export type CreateAccountMutationVariables = Exact<{
  acceptPrivacyStatement?: InputMaybe<Scalars['Boolean']>;
  acceptTermsConditions?: InputMaybe<Scalars['Boolean']>;
  birthDate?: InputMaybe<Scalars['String']>;
  privateEmail?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  preferredGivenName?: InputMaybe<Scalars['String']>;
  preferredSurname?: InputMaybe<Scalars['String']>;
  memberJourney?: InputMaybe<Scalars['String']>;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount?: { __typename?: 'CreateAccount', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CreateAirwallexBeneficiaryMutationVariables = Exact<{
  payload: Scalars['GenericScalar'];
}>;


export type CreateAirwallexBeneficiaryMutation = { __typename?: 'Mutation', createAirwallexBeneficiary?: { __typename?: 'CreateAirwallexBeneficiary', success: boolean, errorCode?: string | null, beneficiaryId?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CreateReimbursementClaimMutationVariables = Exact<{
  treatment: Scalars['ID'];
  treatmentCadence?: InputMaybe<Scalars['Int']>;
  treatmentAdditionalInfo?: InputMaybe<Scalars['String']>;
  documents: Array<InputMaybe<RequestReimbursementPayload>> | InputMaybe<RequestReimbursementPayload>;
  claimant: Scalars['String'];
  accountHolderName?: InputMaybe<Scalars['String']>;
  accountNumber?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  bankName?: InputMaybe<Scalars['String']>;
  swiftCode?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['String']>;
  isMedicallyNecessaryTreatment?: InputMaybe<Scalars['Boolean']>;
  accountType?: InputMaybe<Scalars['String']>;
  localFields?: InputMaybe<Scalars['JSONString']>;
  id?: InputMaybe<Scalars['ID']>;
  existingDocumentIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type CreateReimbursementClaimMutation = { __typename?: 'Mutation', createReimbursementClaim?: { __typename?: 'CreateReimbursementClaim', claimId?: string | null, errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CustomSupportRequestMutationVariables = Exact<{
  privateEmail: Scalars['String'];
  body: Scalars['String'];
  copySelf?: InputMaybe<Scalars['Boolean']>;
}>;


export type CustomSupportRequestMutation = { __typename?: 'Mutation', customSupportRequest?: { __typename?: 'CustomSupportRequest', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type DisableRedesignNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableRedesignNotificationMutation = { __typename?: 'Mutation', disableRedesignNotification?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type DisableNewClaimsFlowNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DisableNewClaimsFlowNotificationMutation = { __typename?: 'Mutation', disableNewClaimsFlowNotification?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type DisablePartnerConsentNotificationMutationVariables = Exact<{ [key: string]: never; }>;


export type DisablePartnerConsentNotificationMutation = { __typename?: 'Mutation', disablePartnerConsentNotification?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type LoginMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'AuthStatus', username: string, code?: number | null, message?: string | null, loggedInBy?: string | null, isEmailConfirmed?: boolean | null, showMemberPromotion?: boolean | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'StatusMessage', code: number, message?: string | null, errors?: Array<string | null> | null } | null };

export type RegisterMutationVariables = Exact<{
  token: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RequestResetPasswordMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestResetPasswordMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename?: 'StatusMessage', code: number, errors?: Array<string | null> | null, message?: string | null } | null };

export type RequestUserEmailConfirmationMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type RequestUserEmailConfirmationMutation = { __typename?: 'Mutation', requestUserEmailConfirmation?: { __typename?: 'StatusMessage', errors?: Array<string | null> | null, code: number, message?: string | null } | null };

export type ResendPartnerConsentMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendPartnerConsentMutation = { __typename?: 'Mutation', resendPartnerConsentEmail?: { __typename?: 'ResendPartnerConsentEmail', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type ResendPrivateEmailConfirmationMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendPrivateEmailConfirmationMutation = { __typename?: 'Mutation', resendPrivateEmailConfirmation?: { __typename?: 'ResendPrivateEmailConfirmation', success: boolean, errorCode?: string | null } | null };

export type ResetPasswordMutationVariables = Exact<{
  newPassword: Scalars['String'];
  token: Scalars['String'];
  uid: Scalars['String'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'StatusMessage', code: number, errors?: Array<string | null> | null, message?: string | null } | null };

export type SendConfirmRegistrationEmailMutationVariables = Exact<{
  email: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
  alternativeAuth?: InputMaybe<Scalars['String']>;
}>;


export type SendConfirmRegistrationEmailMutation = { __typename?: 'Mutation', sendConfirmRegistrationEmail?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SetupMenopauseProfileMutationVariables = Exact<{
  lastMenstrualPeriod?: InputMaybe<Scalars['String']>;
  menopauseSymptoms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  menstrualPeriodStatus?: InputMaybe<Scalars['String']>;
  otherSymptomsDescription?: InputMaybe<Scalars['String']>;
}>;


export type SetupMenopauseProfileMutation = { __typename?: 'Mutation', setupMenopauseProfile?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SetupPregnancyPostpartumProfileMutationVariables = Exact<{
  deliveryDate?: InputMaybe<Scalars['Date']>;
  dueDate?: InputMaybe<Scalars['Date']>;
  pregnancyPostpartumStatus?: InputMaybe<Scalars['String']>;
}>;


export type SetupPregnancyPostpartumProfileMutation = { __typename?: 'Mutation', setupPregnancyPostpartumProfile?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SetupProfileMutationVariables = Exact<{
  birthAssignedSex?: InputMaybe<Scalars['String']>;
  familyFormingJourney?: InputMaybe<Scalars['String']>;
  genderIdentity?: InputMaybe<Scalars['String']>;
  relationshipDynamic?: InputMaybe<Scalars['String']>;
}>;


export type SetupProfileMutation = { __typename?: 'Mutation', setupProfile?: { __typename?: 'SetupProfile', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SignupMemberMutationVariables = Exact<{
  email: Scalars['String'];
  password: Scalars['String'];
  language?: InputMaybe<Scalars['String']>;
}>;


export type SignupMemberMutation = { __typename?: 'Mutation', signupMember?: { __typename?: 'StatusMessage', code: number, message?: string | null, errors?: Array<string | null> | null } | null };

export type SubmitFreshdeskTicketMutationVariables = Exact<{
  subject: Scalars['String'];
  body: Scalars['String'];
}>;


export type SubmitFreshdeskTicketMutation = { __typename?: 'Mutation', submitFreshdeskTicket?: { __typename?: 'SubmitFreshdeskTicket', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SubmitFreshdeskTicketAnonymouslyMutationVariables = Exact<{
  email: Scalars['String'];
  body: Scalars['String'];
}>;


export type SubmitFreshdeskTicketAnonymouslyMutation = { __typename?: 'Mutation', submitFreshdeskTicketAnonymously?: { __typename?: 'SubmitFreshdeskTicketAnonymously', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type RequestSupportMutationVariables = Exact<{
  body: Scalars['String'];
  copySelf?: InputMaybe<Scalars['Boolean']>;
  subject: Scalars['String'];
}>;


export type RequestSupportMutation = { __typename?: 'Mutation', supportRequest?: { __typename?: 'SupportRequest', success: boolean, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type TrackReferralLetterDownloadMutationVariables = Exact<{
  country: Scalars['String'];
}>;


export type TrackReferralLetterDownloadMutation = { __typename?: 'Mutation', trackReferralLetterDownload?: { __typename?: 'TrackReferralLetterDownload', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UpdateAirwallexBeneficiaryMutationVariables = Exact<{
  beneficiaryId: Scalars['String'];
  payload: Scalars['GenericScalar'];
}>;


export type UpdateAirwallexBeneficiaryMutation = { __typename?: 'Mutation', updateAirwallexBeneficiary?: { __typename?: 'UpdateAirwallexBeneficiary', success: boolean, errorCode?: string | null, beneficiary?: any | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UpdatePaymentInformationMutationVariables = Exact<{
  accountHolderName: Scalars['String'];
  accountNumber: Scalars['String'];
  bankName: Scalars['String'];
  country: Scalars['String'];
  swiftCode: Scalars['String'];
  accountType: Scalars['String'];
  localFields?: InputMaybe<Scalars['JSONString']>;
}>;


export type UpdatePaymentInformationMutation = { __typename?: 'Mutation', updatePaymentInformation?: { __typename?: 'MutationResult', errorCode?: string | null, success: boolean, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type UpdateMemberJourneyMutationVariables = Exact<{
  memberJourney: Scalars['String'];
  endCurrentJourney?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateMemberJourneyMutation = { __typename?: 'Mutation', updateMemberJourney?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UpdatePersonaInformationMutationVariables = Exact<{
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostcode?: InputMaybe<Scalars['String']>;
  addressStreetAddress?: InputMaybe<Scalars['String']>;
  preferredGivenName?: InputMaybe<Scalars['String']>;
  preferredSurname?: InputMaybe<Scalars['String']>;
  birthDate?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  privateEmail?: InputMaybe<Scalars['String']>;
  pronouns?: InputMaybe<Scalars['String']>;
  docType?: InputMaybe<Scalars['String']>;
  idDoc?: InputMaybe<Scalars['Upload']>;
}>;


export type UpdatePersonaInformationMutation = { __typename?: 'Mutation', updatePersonalInformation?: { __typename?: 'UpdatePersonalInformation', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type VerifyRegistrationTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type VerifyRegistrationTokenMutation = { __typename?: 'Mutation', verifyRegistrationToken?: { __typename?: 'MutationResult', success: boolean, errorCode?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ReimbursementRequestQueryVariables = Exact<{
  claimId?: InputMaybe<Scalars['ID']>;
}>;


export type ReimbursementRequestQuery = { __typename?: 'Query', reimbursementRequest?: { __typename?: 'ReimbursementRequest', id: string, files: number, stage: number, status: string, receivedAt: string, submissionDate?: string | null, isEditable: boolean, remainingEditableSeconds: number, treatmentName?: string | null, treatmentCadence?: number | null, treatmentAdditionalInfo?: string | null, claimant: string, documents: Array<{ __typename?: 'ReimbursementRequestDocument', id: string, reference: string, documentType: string, filename: string, invoiceAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null }>, requestedDocuments: Array<{ __typename?: 'MissingDocumentRequest', id: string, notProvidedReason?: string | null, documentType: string, explanation?: string | null }>, requestedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, awardedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, claimDocuments: Array<{ __typename?: 'ReimbursementClaimDocument', id: string, fileUrl: string, fileName: string, description: string, documentType: string, updatedAtDate: string }>, bankDetails?: { __typename?: 'BankAccountDetailsType', id: string, accountHolderName: string, bankName: string, accountNumber: string, swiftCode?: string | null, accountType?: CoreBankAccountDetailsAccountTypeChoices | null, localFields?: string | null, country: { __typename?: 'GeographicCountry', code: string, name: string } } | null, activeRfi?: { __typename?: 'RequestForInformationObject', accountId: string, status: string, expiresAt?: string | null, id: string } | null, payoutFailure?: { __typename?: 'PayoutFailure', failureAction: PayoutFailureAction, failureDescription: string } | null } | null };

export type SearchArticlesQueryVariables = Exact<{
  query: Scalars['String'];
  page: Scalars['Int'];
  perPage: Scalars['Int'];
}>;


export type SearchArticlesQuery = { __typename?: 'Query', searchArticles: { __typename?: 'PageOfArticles', count: number, numPages: number, articles: Array<{ __typename?: 'Article', slug: string, title: string, text: string, excerpt: string, squareThumbnailUrl: string, featuredImageUrl?: string | null } | null> } };

export type AirwallexAuthorizationQueryVariables = Exact<{
  scopes: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
}>;


export type AirwallexAuthorizationQuery = { __typename?: 'Query', airwallexAuthorization: { __typename?: 'AirwallexAuthorization', authorizationCode: string, clientId: string, codeVerifier: string } };

export type AirwallexRfiHostedUrlQueryVariables = Exact<{
  rfiId: Scalars['ID'];
}>;


export type AirwallexRfiHostedUrlQuery = { __typename?: 'Query', airwallexRfiHostedUrl?: string | null };

export type ArticleCategoryDetailQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['String']>;
}>;


export type ArticleCategoryDetailQuery = { __typename?: 'Query', articleCategories: Array<{ __typename?: 'ArticleCategory', name: string, slug: string, subtitle: string, description: string, imageUrl: string, articles: Array<{ __typename?: 'Article', slug: string, title: string, squareThumbnailUrl: string, rectangleThumbnailUrl: string, featuredImageUrl?: string | null, excerpt: string, text: string, isFeatured: boolean } | null> } | null> };

export type ArticleDetailsQueryVariables = Exact<{
  slug: Scalars['String'];
  preview?: InputMaybe<Scalars['String']>;
}>;


export type ArticleDetailsQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'Article', slug: string, title: string, text: string, headerImageUrl: string, isFeatured: boolean, relatedArticles: Array<{ __typename?: 'Article', slug: string, title: string, squareThumbnailUrl: string } | null>, relatedCategories: Array<{ __typename?: 'ArticleCategory', slug: string, name: string, imageUrl: string } | null> } | null> };

export type AvailableCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCountriesQuery = { __typename?: 'Query', coverage: { __typename?: 'Coverage', countries: Array<{ __typename?: 'CountryInCoverage', countryCode: string, countryName: string } | null> } };

export type BudgetBarsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetBarsQuery = { __typename?: 'Query', me?: { __typename?: 'User', member: { __typename?: 'Member', budgetProgressBar?: { __typename?: 'BudgetProgressBar', green: { __typename?: 'DineroType', amount: number, currency: string }, white: { __typename?: 'DineroType', amount: number, currency: string }, yellow: { __typename?: 'DineroType', amount: number, currency: string } } | null } } | null };

export type BudgetCountriesCoverageQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars['String']>;
}>;


export type BudgetCountriesCoverageQuery = { __typename?: 'Query', coverage: { __typename?: 'Coverage', countries: Array<{ __typename?: 'CountryInCoverage', countryCode: string, countryName: string, treatments: Array<{ __typename?: 'TreatmentInCoverage', displayName: string, id: number, isCovered: boolean, isLegal: boolean, subtreatments: Array<{ __typename?: 'SubtreatmentInCoverage', displayName: string, id: number, isLegal: boolean } | null> } | null> } | null> } };

export type BudgetCoverageSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type BudgetCoverageSettingsQuery = { __typename?: 'Query', coverage: { __typename?: 'Coverage', settings: Array<{ __typename?: 'SettingInCoverage', displayName: string, slug: string, value: boolean } | null> } };

export type ClaimDocumentTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClaimDocumentTypesQuery = { __typename?: 'Query', claimDocumentTypes?: Array<{ __typename?: 'ClaimDocumentType', id: string, typeName: string, dropdownOrder: number } | null> | null };

export type ClaimTreatmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type ClaimTreatmentsQuery = { __typename?: 'Query', claimTreatments: Array<{ __typename?: 'Treatment', value: string, label: string, requiresCycle: boolean, requiresRound: boolean, requiresAdditionalInfo: boolean, isCovered: boolean } | null> };

export type ClinicAreasQueryVariables = Exact<{
  country: Scalars['String'];
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type ClinicAreasQuery = { __typename?: 'Query', clinicAreas?: Array<{ __typename?: 'MainAreaCounts', area: string, count: number, subareas: Array<{ __typename?: 'AreaCounts', area: string, count: number }> }> | null };

export type ClinicCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClinicCountriesQuery = { __typename?: 'Query', clinicCountries: Array<{ __typename?: 'CountryType', code?: string | null, name?: string | null, province?: string | null }> };

export type ClinicsQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  specialty?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  isPartnerClinic?: InputMaybe<Scalars['Boolean']>;
}>;


export type ClinicsQuery = { __typename?: 'Query', clinics?: { __typename?: 'FertilityClinicPage', pageInfo?: { __typename?: 'PaginationInfo', hasNext: boolean, hasPrevious: boolean, total: number, numPages: number, previousPage?: number | null, nextPage?: number | null } | null, objects?: Array<{ __typename?: 'FertilityClinicType', id: string, name: string, address: string, localName: string, localAddress: string, postalCode: string, city: string, phone?: string | null, website: string, starRating?: number | null, medalRating: boolean, gradeRating?: string | null, isPartnerClinic: boolean, email?: string | null, partnerClinicDiscountText?: string | null, partnershipBenefits: Array<{ __typename?: 'PartnershipBenefit', id: string, value?: string | null, name: string } | null>, treatments: Array<{ __typename?: 'FertilityTreatment', id: string, name: string } | null>, specialties: Array<{ __typename?: 'ClinicSpecialty', id: string, name: string } | null>, socialMedia: Array<{ __typename?: 'FertilityClinicSocialMedia', service: string, handle: string } | null> } | null> | null } | null };

export type CompanyBasicInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyBasicInfoQuery = { __typename?: 'Query', me?: { __typename?: 'User', id: string, company: { __typename?: 'Company', id: string, name: string } } | null };

export type FaqSectionsQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['String']>;
}>;


export type FaqSectionsQuery = { __typename?: 'Query', faqSections: Array<{ __typename?: 'FaqSection', title: string, entries: Array<{ __typename?: 'FaqEntry', question: string, answer: string } | null> } | null> };

export type FertilityClinicCitiesQueryVariables = Exact<{
  country: Scalars['String'];
  area?: InputMaybe<Scalars['String']>;
}>;


export type FertilityClinicCitiesQuery = { __typename?: 'Query', clinicCities?: Array<{ __typename?: 'CityType', city: string, count: number }> | null };

export type FetchArticleCategoriesQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['String']>;
}>;


export type FetchArticleCategoriesQuery = { __typename?: 'Query', articleCategories: Array<{ __typename?: 'ArticleCategory', slug: string, name: string, subtitle: string, description: string, imageUrl: string, recommendationImageUrl: string, numArticles: number } | null> };

export type GetBankFieldsSchemaQueryVariables = Exact<{
  countryCode: Scalars['String'];
}>;


export type GetBankFieldsSchemaQuery = { __typename?: 'Query', bankFieldsSchema: { __typename?: 'BankFieldsSchemaType', countryCode: string, swiftRequired: boolean, fields: Array<{ __typename?: 'BankFieldSpecType', required: boolean, name: string, label: string, helpText?: string | null }> } };

export type GetBeneficiaryIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBeneficiaryIdQuery = { __typename?: 'Query', airwallexBeneficiary?: any | null, airwallexBeneficiaryId?: string | null };

export type GetLastSubmittedClaimQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLastSubmittedClaimQuery = { __typename?: 'Query', openClaim?: { __typename?: 'ReimbursementRequest', id: string, isEditable: boolean, remainingEditableSeconds: number, claimant: string, treatmentName?: string | null, treatmentCadence?: number | null, treatmentAdditionalInfo?: string | null, claimDocuments: Array<{ __typename?: 'ReimbursementClaimDocument', id: string, description: string, fileName: string, fileUrl: string, documentType: string, updatedAtDate: string }> } | null };

export type AllCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCountriesQuery = { __typename?: 'Query', allCountries: Array<{ __typename?: 'GeographicCountry', code: string, name: string } | null> };

export type MarketplaceOffersQueryVariables = Exact<{
  preview?: InputMaybe<Scalars['String']>;
}>;


export type MarketplaceOffersQuery = { __typename?: 'Query', marketplaceOffers: Array<{ __typename?: 'MarketplaceOffer', partnerName: string, slug: string, title: string, imageUrl: string, description: string, whatIsIncluded: string, discount: string, discountCode: string, discountCodeByline: string, url: string, infoForAspiringMembers: string, infoForMembers: string, infoForPartners: string, isReimbursable: boolean } | null> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', code: string, name: string } | null>, me?: { __typename?: 'User', id: string, hygraphAuthToken: string, email: string, journeyCommunicationEmail: string, employeeNumber?: string | null, firstName: string, isEmailConfirmed: boolean, isManager?: boolean | null, lastName: string, company: { __typename?: 'Company', id: string, name: string, isTestCompany: boolean }, member: { __typename?: 'Member', id: string, identityDocumentUrl?: string | null, identityDocumentFileName?: string | null, identityDocumentType?: string | null, acceptedPrivacyStatement?: string | null, partnerConsentStatus?: string | null, showPartnerConsentNotification?: boolean | null, showRedesignNotification: boolean, showNewClaimsFlowNotification: boolean, incidentId: string, acceptedTermsConditions?: string | null, birthAssignedSex: string, highlightLanguages: boolean, birthDate?: string | null, contractType?: string | null, city: string, eligibilityStart?: string | null, familyFormingJourney: string, genderIdentity: string, hadFirstConsultation: boolean, hasStartedLegacyOnboarding: boolean, hasReimbursementRequests: boolean, isAspiring: boolean, isEligible: boolean, isSsoLogin: boolean, isSubscriptionMember: boolean, language: string, newPrivateEmail: string, preferredGivenName: string, phoneNumber: string, preferredSurname: string, provinceOfResidency?: string | null, privateEmail?: string | null, privateEmailChangePending?: boolean | null, privateEmailConfirmed: boolean, pronouns: string, relationshipDynamic: string, timezone: Timezone, availableProductLines?: Array<string | null> | null, activeMemberJourney: string, previouslySelectedJourneys: Array<string>, hasOpenClaims: boolean, isMedicallyNecessaryRelevant?: boolean | null, bankAccountDetails?: { __typename?: 'BankAccountDetailsType', id: string, accountHolderName: string, bankName: string, localFields?: string | null, accountType?: CoreBankAccountDetailsAccountTypeChoices | null, accountNumber: string, swiftCode?: string | null, country: { __typename?: 'GeographicCountry', code: string, name: string } } | null, partnerDetails?: { __typename?: 'PartnerDetailsObject', firstName: string, lastName: string, email: string, birthDate?: string | null, sameHousehold: boolean, sameEmployer: boolean, employeeNumber?: string | null, docType: string, identityDocumentUrl?: string | null, fileName?: string | null, address?: { __typename?: 'AddressObject', streetAddress: string, city: string, postcode: string, country?: { __typename?: 'GeographicCountry', code: string, name: string, currency?: { __typename?: 'CurrencyObject', code: string, name: string } | null } | null } | null } | null, contract: { __typename?: 'Contract', id: string, aspiringPeriodDescription: string, reimbursementMode?: string | null, enableWallets: boolean, countryCode: string, hasBudget: boolean, budgetPerMember?: { __typename?: 'DineroType', amount: number, currency: string } | null }, countryOfEmployment: { __typename?: 'CountryOfEmployment', id: string, country: { __typename?: 'Country', code?: string | null } }, currentBudget?: { __typename?: 'DineroType', amount: number, currency: string } | null, carryoverBudget?: { __typename?: 'DineroType', amount: number, currency: string } | null, privateAddress?: { __typename?: 'Address', id: string, city: string, postcode: string, streetAddress: string, country: { __typename?: 'Country', code?: string | null, name?: string | null } } | null, subscriptions: Array<{ __typename?: 'MemberSubscription', endDate?: string | null, startDate: string }>, wallet?: { __typename?: 'Wallet', id: number, status: string, canBeUnfrozen: boolean, allocatedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, availableAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, spentAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, currentCard?: { __typename?: 'Card', id: number, expiryDate?: string | null, maskedCardNumber: string, status: string } | null, treatmentPlans: Array<{ __typename?: 'TreatmentPlan', fileName: string, fileUrl: string, id: number, fileSize: number, fileContentType: string, createdAt: string, updatedAt: string, comment: string, amount?: { __typename?: 'DineroType', amount: number, currency: string } | null, status: { __typename?: 'Option', value: string, label: string } } | null>, transactions: Array<{ __typename?: 'Transaction', id: number, pliantId: string, type: string, authorizedAt?: string | null, merchantName: string, status: string, comment: string, reconciliationStatus: { __typename?: 'Option', label: string, value: string }, refundedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, billingAmount: { __typename?: 'DineroType', amount: number, currency: string }, transactionAmount: { __typename?: 'DineroType', amount: number, currency: string }, coveredTransactionAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, foreignExchangeFee?: { __typename?: 'DineroType', amount: number, currency: string } | null, uploads: Array<{ __typename?: 'TransactionUpload', fileContentType: string, fileName: string, fileSize: number, fileUrl: string, id: number } | null>, reuploadRequest?: { __typename?: 'TransactionReuploadRequest', id: number, comment: string, createdAt: string } | null } | null> } | null, menopauseJourney?: { __typename?: 'MemberMenopauseJourney', lastMenstrualPeriod: string, menopauseSymptoms: Array<string | null>, menstrualPeriodStatus: string, otherSymptomsDescription: string } | null, pregnancyPostpartumJourney?: { __typename?: 'PregnancyPostpartumJourney', pregnancyPostpartumStatus?: string | null, dueDate?: string | null, deliveryDate?: string | null } | null } } | null };

export type MenopausePerCountryQueryVariables = Exact<{
  countryCode: Scalars['String'];
  province?: InputMaybe<Scalars['String']>;
}>;


export type MenopausePerCountryQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', menopauseInCountry?: { __typename?: 'MenopauseNavigatorInCountry', countryCode: string, countryName: string, province: string, clinicsAvailable: boolean, coverageForHrt: string } | null } };

export type MenopauseClinicAreasQueryVariables = Exact<{
  country: Scalars['String'];
}>;


export type MenopauseClinicAreasQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', clinicAreas?: Array<{ __typename?: 'AreaCounts', area: string, count: number }> | null } };

export type MenopauseClinicCitiesQueryVariables = Exact<{
  country: Scalars['String'];
  area?: InputMaybe<Scalars['String']>;
}>;


export type MenopauseClinicCitiesQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', clinicCities?: Array<{ __typename?: 'CityType', city: string, count: number }> | null } };

export type MenopauseClinicCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MenopauseClinicCountriesQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', clinicCountries: Array<{ __typename?: 'CountryType', name?: string | null, code?: string | null }> } };

export type MenopauseClinicsQueryVariables = Exact<{
  country: Scalars['String'];
  area?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
}>;


export type MenopauseClinicsQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', menopauseClinics?: { __typename?: 'MenopauseClinicPage', objects?: Array<{ __typename?: 'MenopauseClinicType', name: string, city: string, area: string, address: string, email?: string | null, id: string, phone: string, postalCode: string, website: string } | null> | null, pageInfo?: { __typename?: 'PaginationInfo', total: number, nextPage?: number | null, hasNext: boolean, hasPrevious: boolean, numPages: number, previousPage?: number | null } | null } | null } };

export type MenopauseCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type MenopauseCountriesQuery = { __typename?: 'Query', menopause: { __typename?: 'Menopause', countries: Array<{ __typename?: 'CountryType', province?: string | null, name?: string | null, code?: string | null }> } };

export type PregnancyCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type PregnancyCountriesQuery = { __typename?: 'Query', pregnancyPostpartum: { __typename?: 'PregnancyPostpartum', countries: Array<{ __typename?: 'CountryType', province?: string | null, name?: string | null, code?: string | null }> } };

export type PregnancyNavigatorQueryVariables = Exact<{
  countryCode: Scalars['String'];
  province?: InputMaybe<Scalars['String']>;
}>;


export type PregnancyNavigatorQuery = { __typename?: 'Query', pregnancyPostpartum: { __typename?: 'PregnancyPostpartum', pregnancyPostpartumInCountry?: { __typename?: 'PregnancyPostpartumNavigatorInCountry', maternityLeaveDuration: string, maternityLeavePayee: string, parentalLeaveDuration: string, paternityLeaveDuration: string, paternityLeavePayee: string, jobSecurity: string } | null } };

export type ProductConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductConfigQuery = { __typename?: 'Query', productConfig: Array<{ __typename?: 'ProductConfig', dataType: CoreApplicationConfigEntryDataTypeChoices, id: string, slug: string, value: string }> };

export type PronounsQueryVariables = Exact<{ [key: string]: never; }>;


export type PronounsQuery = { __typename?: 'Query', pronouns: Array<{ __typename?: 'Pronoun', label: string, value: string }> };

export type RatingSpecQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']>;
}>;


export type RatingSpecQuery = { __typename?: 'Query', ratingSpec?: { __typename?: 'RatingSpecification', name: string, type: string, link?: string | null, maxStars?: number | null } | null };

export type RecommendedArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type RecommendedArticlesQuery = { __typename?: 'Query', recommendedArticles: Array<{ __typename?: 'ArticleOrCategory', article?: { __typename?: 'Article', slug: string, title: string, rectangleThumbnailUrl: string } | null, category?: { __typename?: 'ArticleCategory', slug: string, name: string, recommendationImageUrl: string } | null } | null> };

export type ReimbursementHistoryQueryVariables = Exact<{
  page?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
}>;


export type ReimbursementHistoryQuery = { __typename?: 'Query', reimbursementHistory: { __typename?: 'ReimbursementHistoryPage', pageInfo?: { __typename?: 'PaginationInfo', total: number, numPages: number, nextPage?: number | null, previousPage?: number | null, hasNext: boolean, hasPrevious: boolean } | null, objects: Array<{ __typename?: 'ReimbursementRequest', id: string, files: number, status: string, stage: number, remainingEditableSeconds: number, isEditable: boolean, receivedAt: string, submissionDate?: string | null, treatmentName?: string | null, treatmentCadence?: number | null, treatmentAdditionalInfo?: string | null, claimant: string, documents: Array<{ __typename?: 'ReimbursementRequestDocument', id: string, reference: string, documentType: string, invoiceAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null }>, requestedDocuments: Array<{ __typename?: 'MissingDocumentRequest', id: string, notProvidedReason?: string | null, documentType: string, explanation?: string | null }>, requestedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, awardedAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, claimDocuments: Array<{ __typename?: 'ReimbursementClaimDocument', id: string, fileUrl: string, fileName: string, description: string, documentType: string, updatedAtDate: string }> }> } };

export type SpecialtiesQueryVariables = Exact<{
  country?: InputMaybe<Scalars['String']>;
  area?: InputMaybe<Scalars['String']>;
  treatments?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type SpecialtiesQuery = { __typename?: 'Query', specialties?: Array<{ __typename?: 'ClinicSpecialtyCounts', specialty: string, count: number } | null> | null };

export type TreatmentsQueryVariables = Exact<{
  country: Scalars['String'];
  area?: InputMaybe<Scalars['String']>;
  specialty?: InputMaybe<Scalars['String']>;
}>;


export type TreatmentsQuery = { __typename?: 'Query', treatments: Array<{ __typename?: 'FertilityTreatmentCounts', treatment: string, count: number }> };

export type TreatmentsInCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type TreatmentsInCountriesQuery = { __typename?: 'Query', navigator: { __typename?: 'Navigator', treatments: Array<{ __typename?: 'TreatmentInNavigator', id: number, displayName: string, availableInCountries: Array<string | null>, description: string, clinicsCounterparts: Array<string | null> } | null> } };

export type TreatmentsPerCountryQueryVariables = Exact<{
  treatmentId: Scalars['Int'];
  countryCode: Scalars['String'];
  province: Scalars['String'];
}>;


export type TreatmentsPerCountryQuery = { __typename?: 'Query', navigator: { __typename?: 'Navigator', treatmentInCountry?: { __typename?: 'TreatmentInCountryInNavigator', countryCode: string, countryName: string, province: string, isLegal: boolean, isCovered: boolean, clinicsAvailable: boolean, healthInsuranceCoverage: Array<string | null>, availableTo: Array<string | null>, ageRestrictions: string, indicativeCosts: string, costsTooltip: string, additionalInfo: string, treatment: { __typename?: 'TreatmentInNavigator', id: number, displayName: string, description: string, clinicsCounterparts: Array<string | null>, availableInCountries: Array<string | null> } } | null } };

export type ValidatePasswordTokenQueryVariables = Exact<{
  uid: Scalars['String'];
  token: Scalars['String'];
}>;


export type ValidatePasswordTokenQuery = { __typename?: 'Query', validatePasswordToken?: { __typename?: 'PasswordResetTokenValidationResult', isValid: boolean, errorCode?: string | null } | null };

export type WalletTransactionsQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletTransactionsQuery = { __typename?: 'Query', me?: { __typename?: 'User', member: { __typename?: 'Member', wallet?: { __typename?: 'Wallet', transactions: Array<{ __typename?: 'Transaction', id: number, pliantId: string, type: string, authorizedAt?: string | null, merchantName: string, status: string, comment: string, reconciliationStatus: { __typename?: 'Option', label: string, value: string }, billingAmount: { __typename?: 'DineroType', amount: number, currency: string }, transactionAmount: { __typename?: 'DineroType', amount: number, currency: string }, coveredTransactionAmount?: { __typename?: 'DineroType', amount: number, currency: string } | null, foreignExchangeFee?: { __typename?: 'DineroType', amount: number, currency: string } | null, uploads: Array<{ __typename?: 'TransactionUpload', fileContentType: string, fileName: string, fileSize: number, fileUrl: string, id: number } | null> } | null> } | null } } | null };

export type WalletWidgetQueryVariables = Exact<{ [key: string]: never; }>;


export type WalletWidgetQuery = { __typename?: 'Query', me?: { __typename?: 'User', member: { __typename?: 'Member', id: string, wallet?: { __typename?: 'Wallet', id: number, status: string, currentCard?: { __typename?: 'Card', widgetUrl: string } | null } | null } } | null };


export const ConsultationsMyAppointmentsDocument = gql`
    query ConsultationsMyAppointments {
  consultations {
    myAppointments {
      id
      scheduledTime
      status
      canReschedule
      canJoin
      meetingLink
      calcomBookingUid
      appointmentType
      createdAt
      updatedAt
      programEnrollment {
        program {
          description
          sessions {
            title
          }
          id
          slug
          title
        }
      }
      consultationEnrollment {
        consultation {
          id
          slug
          title
        }
        consultationContext
        id
      }
    }
  }
}
    `;

/**
 * __useConsultationsMyAppointmentsQuery__
 *
 * To run a query within a React component, call `useConsultationsMyAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsMyAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsMyAppointmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultationsMyAppointmentsQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsMyAppointmentsQuery, ConsultationsMyAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsMyAppointmentsQuery, ConsultationsMyAppointmentsQueryVariables>(ConsultationsMyAppointmentsDocument, options);
      }
export function useConsultationsMyAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsMyAppointmentsQuery, ConsultationsMyAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsMyAppointmentsQuery, ConsultationsMyAppointmentsQueryVariables>(ConsultationsMyAppointmentsDocument, options);
        }
export type ConsultationsMyAppointmentsQueryHookResult = ReturnType<typeof useConsultationsMyAppointmentsQuery>;
export type ConsultationsMyAppointmentsLazyQueryHookResult = ReturnType<typeof useConsultationsMyAppointmentsLazyQuery>;
export type ConsultationsMyAppointmentsQueryResult = Apollo.QueryResult<ConsultationsMyAppointmentsQuery, ConsultationsMyAppointmentsQueryVariables>;
export const ConsultationsListDocument = gql`
    query ConsultationsList {
  consultations {
    consultations {
      id
      slug
      title
      description
      isEnrolled
    }
  }
}
    `;

/**
 * __useConsultationsListQuery__
 *
 * To run a query within a React component, call `useConsultationsListQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsListQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultationsListQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsListQuery, ConsultationsListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsListQuery, ConsultationsListQueryVariables>(ConsultationsListDocument, options);
      }
export function useConsultationsListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsListQuery, ConsultationsListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsListQuery, ConsultationsListQueryVariables>(ConsultationsListDocument, options);
        }
export type ConsultationsListQueryHookResult = ReturnType<typeof useConsultationsListQuery>;
export type ConsultationsListLazyQueryHookResult = ReturnType<typeof useConsultationsListLazyQuery>;
export type ConsultationsListQueryResult = Apollo.QueryResult<ConsultationsListQuery, ConsultationsListQueryVariables>;
export const ConsultationsDetailDocument = gql`
    query ConsultationsDetail($id: ID, $slug: String) {
  consultations {
    consultation(id: $id, slug: $slug) {
      id
      slug
      title
      description
      onboardingCallRequired
      onboardingQuestionnaireRequired
      onboardingCalcomEventType
      onboardingTitle
      onboardingDescription
      onboardingButtonText
      isEnrolled
      myEnrollment {
        id
        consultationContext
        status
        createdAt
        updatedAt
        onboardingAssessment {
          id
          createdAt
          updatedAt
          replies {
            id
            question
            questionGroup
            answer
            createdAt
          }
        }
        onboardingStatus {
          onboardingCallRequired
          onboardingCallCompleted
          onboardingQuestionnaireRequired
          onboardingQuestionnaireCompleted
          onboardingQuestionnaireSkipped
        }
        onboardingCallAppointment {
          id
          scheduledTime
          status
          canReschedule
          canJoin
          meetingLink
          calcomBookingUid
          appointmentType
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useConsultationsDetailQuery__
 *
 * To run a query within a React component, call `useConsultationsDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useConsultationsDetailQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsDetailQuery, ConsultationsDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsDetailQuery, ConsultationsDetailQueryVariables>(ConsultationsDetailDocument, options);
      }
export function useConsultationsDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsDetailQuery, ConsultationsDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsDetailQuery, ConsultationsDetailQueryVariables>(ConsultationsDetailDocument, options);
        }
export type ConsultationsDetailQueryHookResult = ReturnType<typeof useConsultationsDetailQuery>;
export type ConsultationsDetailLazyQueryHookResult = ReturnType<typeof useConsultationsDetailLazyQuery>;
export type ConsultationsDetailQueryResult = Apollo.QueryResult<ConsultationsDetailQuery, ConsultationsDetailQueryVariables>;
export const ConsultationsMyEnrollmentsDocument = gql`
    query ConsultationsMyEnrollments {
  consultations {
    myConsultationEnrollments {
      id
      createdAt
      consultationContext
      status
      onboardingAssessment {
        id
        createdAt
        updatedAt
        replies {
          id
          question
          questionGroup
          answer
          createdAt
        }
      }
      onboardingStatus {
        onboardingCallRequired
        onboardingCallCompleted
        onboardingQuestionnaireRequired
        onboardingQuestionnaireCompleted
        onboardingQuestionnaireSkipped
      }
    }
    myProgramEnrollments {
      id
      createdAt
      status
      program {
        id
        slug
        title
        bookingStrategy
      }
      sessionStatuses {
        status
        appointment {
          id
          scheduledTime
          status
          appointmentType
          canReschedule
          canJoin
          calcomBookingUid
          meetingLink
          createdAt
          updatedAt
        }
        session {
          id
          sessionNumber
          title
          subtitle
          description
          required
        }
      }
    }
  }
}
    `;

/**
 * __useConsultationsMyEnrollmentsQuery__
 *
 * To run a query within a React component, call `useConsultationsMyEnrollmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsMyEnrollmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsMyEnrollmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultationsMyEnrollmentsQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsMyEnrollmentsQuery, ConsultationsMyEnrollmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsMyEnrollmentsQuery, ConsultationsMyEnrollmentsQueryVariables>(ConsultationsMyEnrollmentsDocument, options);
      }
export function useConsultationsMyEnrollmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsMyEnrollmentsQuery, ConsultationsMyEnrollmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsMyEnrollmentsQuery, ConsultationsMyEnrollmentsQueryVariables>(ConsultationsMyEnrollmentsDocument, options);
        }
export type ConsultationsMyEnrollmentsQueryHookResult = ReturnType<typeof useConsultationsMyEnrollmentsQuery>;
export type ConsultationsMyEnrollmentsLazyQueryHookResult = ReturnType<typeof useConsultationsMyEnrollmentsLazyQuery>;
export type ConsultationsMyEnrollmentsQueryResult = Apollo.QueryResult<ConsultationsMyEnrollmentsQuery, ConsultationsMyEnrollmentsQueryVariables>;
export const EnrollInConsultationDocument = gql`
    mutation EnrollInConsultation($consultationId: ID!, $consultationContext: JSONString) {
  enrollInConsultation(
    consultationId: $consultationId
    consultationContext: $consultationContext
  ) {
    enrollment {
      id
      createdAt
      status
    }
    success
    message
  }
}
    `;
export type EnrollInConsultationMutationFn = Apollo.MutationFunction<EnrollInConsultationMutation, EnrollInConsultationMutationVariables>;

/**
 * __useEnrollInConsultationMutation__
 *
 * To run a mutation, you first call `useEnrollInConsultationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollInConsultationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollInConsultationMutation, { data, loading, error }] = useEnrollInConsultationMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      consultationContext: // value for 'consultationContext'
 *   },
 * });
 */
export function useEnrollInConsultationMutation(baseOptions?: Apollo.MutationHookOptions<EnrollInConsultationMutation, EnrollInConsultationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollInConsultationMutation, EnrollInConsultationMutationVariables>(EnrollInConsultationDocument, options);
      }
export type EnrollInConsultationMutationHookResult = ReturnType<typeof useEnrollInConsultationMutation>;
export type EnrollInConsultationMutationResult = Apollo.MutationResult<EnrollInConsultationMutation>;
export type EnrollInConsultationMutationOptions = Apollo.BaseMutationOptions<EnrollInConsultationMutation, EnrollInConsultationMutationVariables>;
export const EnrollInProgramDocument = gql`
    mutation EnrollInProgram($programId: ID!, $disclaimerAcknowledged: Boolean) {
  enrollInProgram(
    programId: $programId
    disclaimerAcknowledged: $disclaimerAcknowledged
  ) {
    enrollment {
      id
      createdAt
      status
      disclaimerAcknowledged
      program {
        id
        slug
        title
      }
    }
    success
    message
  }
}
    `;
export type EnrollInProgramMutationFn = Apollo.MutationFunction<EnrollInProgramMutation, EnrollInProgramMutationVariables>;

/**
 * __useEnrollInProgramMutation__
 *
 * To run a mutation, you first call `useEnrollInProgramMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollInProgramMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollInProgramMutation, { data, loading, error }] = useEnrollInProgramMutation({
 *   variables: {
 *      programId: // value for 'programId'
 *      disclaimerAcknowledged: // value for 'disclaimerAcknowledged'
 *   },
 * });
 */
export function useEnrollInProgramMutation(baseOptions?: Apollo.MutationHookOptions<EnrollInProgramMutation, EnrollInProgramMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnrollInProgramMutation, EnrollInProgramMutationVariables>(EnrollInProgramDocument, options);
      }
export type EnrollInProgramMutationHookResult = ReturnType<typeof useEnrollInProgramMutation>;
export type EnrollInProgramMutationResult = Apollo.MutationResult<EnrollInProgramMutation>;
export type EnrollInProgramMutationOptions = Apollo.BaseMutationOptions<EnrollInProgramMutation, EnrollInProgramMutationVariables>;
export const CompleteOnboardingQuestionnaireDocument = gql`
    mutation CompleteOnboardingQuestionnaire($consultationId: ID!, $responses: JSONString!) {
  completeOnboardingQuestionnaire(
    consultationId: $consultationId
    responses: $responses
  ) {
    enrollment {
      id
      onboardingStatus {
        onboardingQuestionnaireCompleted
        onboardingQuestionnaireSkipped
      }
      onboardingAssessment {
        id
        createdAt
        updatedAt
        replies {
          id
          question
          answer
          createdAt
        }
      }
    }
    success
    message
  }
}
    `;
export type CompleteOnboardingQuestionnaireMutationFn = Apollo.MutationFunction<CompleteOnboardingQuestionnaireMutation, CompleteOnboardingQuestionnaireMutationVariables>;

/**
 * __useCompleteOnboardingQuestionnaireMutation__
 *
 * To run a mutation, you first call `useCompleteOnboardingQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteOnboardingQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeOnboardingQuestionnaireMutation, { data, loading, error }] = useCompleteOnboardingQuestionnaireMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useCompleteOnboardingQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<CompleteOnboardingQuestionnaireMutation, CompleteOnboardingQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteOnboardingQuestionnaireMutation, CompleteOnboardingQuestionnaireMutationVariables>(CompleteOnboardingQuestionnaireDocument, options);
      }
export type CompleteOnboardingQuestionnaireMutationHookResult = ReturnType<typeof useCompleteOnboardingQuestionnaireMutation>;
export type CompleteOnboardingQuestionnaireMutationResult = Apollo.MutationResult<CompleteOnboardingQuestionnaireMutation>;
export type CompleteOnboardingQuestionnaireMutationOptions = Apollo.BaseMutationOptions<CompleteOnboardingQuestionnaireMutation, CompleteOnboardingQuestionnaireMutationVariables>;
export const SkipOnboardingQuestionnaireDocument = gql`
    mutation SkipOnboardingQuestionnaire($consultationId: ID!) {
  skipOnboardingQuestionnaire(consultationId: $consultationId) {
    enrollment {
      id
      onboardingStatus {
        onboardingQuestionnaireCompleted
        onboardingQuestionnaireSkipped
      }
    }
    success
    message
  }
}
    `;
export type SkipOnboardingQuestionnaireMutationFn = Apollo.MutationFunction<SkipOnboardingQuestionnaireMutation, SkipOnboardingQuestionnaireMutationVariables>;

/**
 * __useSkipOnboardingQuestionnaireMutation__
 *
 * To run a mutation, you first call `useSkipOnboardingQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipOnboardingQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipOnboardingQuestionnaireMutation, { data, loading, error }] = useSkipOnboardingQuestionnaireMutation({
 *   variables: {
 *      consultationId: // value for 'consultationId'
 *   },
 * });
 */
export function useSkipOnboardingQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<SkipOnboardingQuestionnaireMutation, SkipOnboardingQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SkipOnboardingQuestionnaireMutation, SkipOnboardingQuestionnaireMutationVariables>(SkipOnboardingQuestionnaireDocument, options);
      }
export type SkipOnboardingQuestionnaireMutationHookResult = ReturnType<typeof useSkipOnboardingQuestionnaireMutation>;
export type SkipOnboardingQuestionnaireMutationResult = Apollo.MutationResult<SkipOnboardingQuestionnaireMutation>;
export type SkipOnboardingQuestionnaireMutationOptions = Apollo.BaseMutationOptions<SkipOnboardingQuestionnaireMutation, SkipOnboardingQuestionnaireMutationVariables>;
export const ConsultationsProgramsDocument = gql`
    query ConsultationsPrograms {
  consultations {
    programs {
      id
      slug
      title
      description
      previewDescription
      bookingStrategy
      isEnrolled
      requireEnrollment
      consultation {
        id
        slug
        title
        description
        onboardingTitle
        onboardingDescription
        onboardingButtonText
        onboardingCallRequired
        onboardingQuestionnaireRequired
        canEnrollInPrograms
        myEnrollment {
          id
          onboardingStatus {
            onboardingCallRequired
            onboardingCallCompleted
            onboardingQuestionnaireRequired
            onboardingQuestionnaireCompleted
            onboardingQuestionnaireSkipped
          }
        }
      }
      sessions {
        id
        sessionNumber
        repeatable
        required
      }
    }
  }
}
    `;

/**
 * __useConsultationsProgramsQuery__
 *
 * To run a query within a React component, call `useConsultationsProgramsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsProgramsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsProgramsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultationsProgramsQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsProgramsQuery, ConsultationsProgramsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsProgramsQuery, ConsultationsProgramsQueryVariables>(ConsultationsProgramsDocument, options);
      }
export function useConsultationsProgramsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsProgramsQuery, ConsultationsProgramsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsProgramsQuery, ConsultationsProgramsQueryVariables>(ConsultationsProgramsDocument, options);
        }
export type ConsultationsProgramsQueryHookResult = ReturnType<typeof useConsultationsProgramsQuery>;
export type ConsultationsProgramsLazyQueryHookResult = ReturnType<typeof useConsultationsProgramsLazyQuery>;
export type ConsultationsProgramsQueryResult = Apollo.QueryResult<ConsultationsProgramsQuery, ConsultationsProgramsQueryVariables>;
export const ConsultationsProgramDetailDocument = gql`
    query ConsultationsProgramDetail($id: ID, $slug: String) {
  consultations {
    program(id: $id, slug: $slug) {
      id
      slug
      title
      description
      previewDescription
      bookingStrategy
      enableLearnMoreContent
      isEnrolled
      consultation {
        id
        slug
        title
        description
        onboardingTitle
        onboardingDescription
        onboardingButtonText
        onboardingCallRequired
        onboardingQuestionnaireRequired
        canEnrollInPrograms
        myEnrollment {
          id
          onboardingStatus {
            onboardingCallRequired
            onboardingCallCompleted
            onboardingQuestionnaireRequired
            onboardingQuestionnaireCompleted
            onboardingQuestionnaireSkipped
          }
        }
      }
      sessions {
        id
        sessionNumber
        calcomEventType
        title
        subtitle
        description
        sessionDetail
        bookingDescription
        repeatable
        required
      }
    }
    myProgramEnrollments {
      id
      program {
        id
      }
      createdAt
      status
      sessionStatuses {
        status
        appointment {
          id
          scheduledTime
          status
          appointmentType
          canReschedule
          canJoin
          calcomBookingUid
          meetingLink
          createdAt
          updatedAt
        }
        session {
          id
          sessionNumber
          title
          subtitle
          description
          required
        }
      }
    }
  }
}
    `;

/**
 * __useConsultationsProgramDetailQuery__
 *
 * To run a query within a React component, call `useConsultationsProgramDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsProgramDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsProgramDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useConsultationsProgramDetailQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsProgramDetailQuery, ConsultationsProgramDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsProgramDetailQuery, ConsultationsProgramDetailQueryVariables>(ConsultationsProgramDetailDocument, options);
      }
export function useConsultationsProgramDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsProgramDetailQuery, ConsultationsProgramDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsProgramDetailQuery, ConsultationsProgramDetailQueryVariables>(ConsultationsProgramDetailDocument, options);
        }
export type ConsultationsProgramDetailQueryHookResult = ReturnType<typeof useConsultationsProgramDetailQuery>;
export type ConsultationsProgramDetailLazyQueryHookResult = ReturnType<typeof useConsultationsProgramDetailLazyQuery>;
export type ConsultationsProgramDetailQueryResult = Apollo.QueryResult<ConsultationsProgramDetailQuery, ConsultationsProgramDetailQueryVariables>;
export const ConsultationsProgramSessionsDocument = gql`
    query ConsultationsProgramSessions {
  consultations {
    programs {
      id
      slug
      title
    }
  }
}
    `;

/**
 * __useConsultationsProgramSessionsQuery__
 *
 * To run a query within a React component, call `useConsultationsProgramSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsProgramSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsProgramSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useConsultationsProgramSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ConsultationsProgramSessionsQuery, ConsultationsProgramSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsProgramSessionsQuery, ConsultationsProgramSessionsQueryVariables>(ConsultationsProgramSessionsDocument, options);
      }
export function useConsultationsProgramSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsProgramSessionsQuery, ConsultationsProgramSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsProgramSessionsQuery, ConsultationsProgramSessionsQueryVariables>(ConsultationsProgramSessionsDocument, options);
        }
export type ConsultationsProgramSessionsQueryHookResult = ReturnType<typeof useConsultationsProgramSessionsQuery>;
export type ConsultationsProgramSessionsLazyQueryHookResult = ReturnType<typeof useConsultationsProgramSessionsLazyQuery>;
export type ConsultationsProgramSessionsQueryResult = Apollo.QueryResult<ConsultationsProgramSessionsQuery, ConsultationsProgramSessionsQueryVariables>;
export const ConsultationsSessionBookingWindowDocument = gql`
    query ConsultationsSessionBookingWindow($sessionId: ID!) {
  consultations {
    session(id: $sessionId) {
      id
      sessionNumber
      calcomEventType
      title
      bookingDescription
      required
      program {
        id
        slug
      }
      bookingWindow {
        isBookable
        windowStatus
        startDate
        endDate
        message
      }
    }
  }
}
    `;

/**
 * __useConsultationsSessionBookingWindowQuery__
 *
 * To run a query within a React component, call `useConsultationsSessionBookingWindowQuery` and pass it any options that fit your needs.
 * When your component renders, `useConsultationsSessionBookingWindowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConsultationsSessionBookingWindowQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useConsultationsSessionBookingWindowQuery(baseOptions: Apollo.QueryHookOptions<ConsultationsSessionBookingWindowQuery, ConsultationsSessionBookingWindowQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConsultationsSessionBookingWindowQuery, ConsultationsSessionBookingWindowQueryVariables>(ConsultationsSessionBookingWindowDocument, options);
      }
export function useConsultationsSessionBookingWindowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConsultationsSessionBookingWindowQuery, ConsultationsSessionBookingWindowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConsultationsSessionBookingWindowQuery, ConsultationsSessionBookingWindowQueryVariables>(ConsultationsSessionBookingWindowDocument, options);
        }
export type ConsultationsSessionBookingWindowQueryHookResult = ReturnType<typeof useConsultationsSessionBookingWindowQuery>;
export type ConsultationsSessionBookingWindowLazyQueryHookResult = ReturnType<typeof useConsultationsSessionBookingWindowLazyQuery>;
export type ConsultationsSessionBookingWindowQueryResult = Apollo.QueryResult<ConsultationsSessionBookingWindowQuery, ConsultationsSessionBookingWindowQueryVariables>;
export const SessionBookingParamsDocument = gql`
    query SessionBookingParams($sessionId: Int!) {
  consultations {
    sessionBookingParams(sessionId: $sessionId) {
      metadata
      routedTeamMemberIds
      language
      languageLocked
    }
  }
}
    `;

/**
 * __useSessionBookingParamsQuery__
 *
 * To run a query within a React component, call `useSessionBookingParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionBookingParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionBookingParamsQuery({
 *   variables: {
 *      sessionId: // value for 'sessionId'
 *   },
 * });
 */
export function useSessionBookingParamsQuery(baseOptions: Apollo.QueryHookOptions<SessionBookingParamsQuery, SessionBookingParamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionBookingParamsQuery, SessionBookingParamsQueryVariables>(SessionBookingParamsDocument, options);
      }
export function useSessionBookingParamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionBookingParamsQuery, SessionBookingParamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionBookingParamsQuery, SessionBookingParamsQueryVariables>(SessionBookingParamsDocument, options);
        }
export type SessionBookingParamsQueryHookResult = ReturnType<typeof useSessionBookingParamsQuery>;
export type SessionBookingParamsLazyQueryHookResult = ReturnType<typeof useSessionBookingParamsLazyQuery>;
export type SessionBookingParamsQueryResult = Apollo.QueryResult<SessionBookingParamsQuery, SessionBookingParamsQueryVariables>;
export const SetSessionSkippedDocument = gql`
    mutation SetSessionSkipped($programEnrollmentId: ID!, $sessionId: ID!, $skipped: Boolean!) {
  setSessionSkipped(
    programEnrollmentId: $programEnrollmentId
    sessionId: $sessionId
    skipped: $skipped
  ) {
    sessionStatus {
      status
      session {
        id
        sessionNumber
      }
    }
    success
    message
  }
}
    `;
export type SetSessionSkippedMutationFn = Apollo.MutationFunction<SetSessionSkippedMutation, SetSessionSkippedMutationVariables>;

/**
 * __useSetSessionSkippedMutation__
 *
 * To run a mutation, you first call `useSetSessionSkippedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSessionSkippedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSessionSkippedMutation, { data, loading, error }] = useSetSessionSkippedMutation({
 *   variables: {
 *      programEnrollmentId: // value for 'programEnrollmentId'
 *      sessionId: // value for 'sessionId'
 *      skipped: // value for 'skipped'
 *   },
 * });
 */
export function useSetSessionSkippedMutation(baseOptions?: Apollo.MutationHookOptions<SetSessionSkippedMutation, SetSessionSkippedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSessionSkippedMutation, SetSessionSkippedMutationVariables>(SetSessionSkippedDocument, options);
      }
export type SetSessionSkippedMutationHookResult = ReturnType<typeof useSetSessionSkippedMutation>;
export type SetSessionSkippedMutationResult = Apollo.MutationResult<SetSessionSkippedMutation>;
export type SetSessionSkippedMutationOptions = Apollo.BaseMutationOptions<SetSessionSkippedMutation, SetSessionSkippedMutationVariables>;
export const ActivateWalletDocument = gql`
    mutation ActivateWallet($id: Int!) {
  activateWallet(id: $id) {
    errorCode
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type ActivateWalletMutationFn = Apollo.MutationFunction<ActivateWalletMutation, ActivateWalletMutationVariables>;

/**
 * __useActivateWalletMutation__
 *
 * To run a mutation, you first call `useActivateWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateWalletMutation, { data, loading, error }] = useActivateWalletMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useActivateWalletMutation(baseOptions?: Apollo.MutationHookOptions<ActivateWalletMutation, ActivateWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ActivateWalletMutation, ActivateWalletMutationVariables>(ActivateWalletDocument, options);
      }
export type ActivateWalletMutationHookResult = ReturnType<typeof useActivateWalletMutation>;
export type ActivateWalletMutationResult = Apollo.MutationResult<ActivateWalletMutation>;
export type ActivateWalletMutationOptions = Apollo.BaseMutationOptions<ActivateWalletMutation, ActivateWalletMutationVariables>;
export const FreezeWalletDocument = gql`
    mutation FreezeWallet($id: Int!) {
  freezeWallet(id: $id) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type FreezeWalletMutationFn = Apollo.MutationFunction<FreezeWalletMutation, FreezeWalletMutationVariables>;

/**
 * __useFreezeWalletMutation__
 *
 * To run a mutation, you first call `useFreezeWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFreezeWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [freezeWalletMutation, { data, loading, error }] = useFreezeWalletMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useFreezeWalletMutation(baseOptions?: Apollo.MutationHookOptions<FreezeWalletMutation, FreezeWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FreezeWalletMutation, FreezeWalletMutationVariables>(FreezeWalletDocument, options);
      }
export type FreezeWalletMutationHookResult = ReturnType<typeof useFreezeWalletMutation>;
export type FreezeWalletMutationResult = Apollo.MutationResult<FreezeWalletMutation>;
export type FreezeWalletMutationOptions = Apollo.BaseMutationOptions<FreezeWalletMutation, FreezeWalletMutationVariables>;
export const RenewCardDocument = gql`
    mutation RenewCard($wallet: Int!) {
  renewCard(wallet: $wallet) {
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type RenewCardMutationFn = Apollo.MutationFunction<RenewCardMutation, RenewCardMutationVariables>;

/**
 * __useRenewCardMutation__
 *
 * To run a mutation, you first call `useRenewCardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewCardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewCardMutation, { data, loading, error }] = useRenewCardMutation({
 *   variables: {
 *      wallet: // value for 'wallet'
 *   },
 * });
 */
export function useRenewCardMutation(baseOptions?: Apollo.MutationHookOptions<RenewCardMutation, RenewCardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewCardMutation, RenewCardMutationVariables>(RenewCardDocument, options);
      }
export type RenewCardMutationHookResult = ReturnType<typeof useRenewCardMutation>;
export type RenewCardMutationResult = Apollo.MutationResult<RenewCardMutation>;
export type RenewCardMutationOptions = Apollo.BaseMutationOptions<RenewCardMutation, RenewCardMutationVariables>;
export const RetryClaimPayoutDocument = gql`
    mutation RetryClaimPayout($claimId: ID!) {
  retryClaimPayout(claimId: $claimId) {
    errors {
      field
      messages
    }
    success
    errorCode
  }
}
    `;
export type RetryClaimPayoutMutationFn = Apollo.MutationFunction<RetryClaimPayoutMutation, RetryClaimPayoutMutationVariables>;

/**
 * __useRetryClaimPayoutMutation__
 *
 * To run a mutation, you first call `useRetryClaimPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRetryClaimPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [retryClaimPayoutMutation, { data, loading, error }] = useRetryClaimPayoutMutation({
 *   variables: {
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useRetryClaimPayoutMutation(baseOptions?: Apollo.MutationHookOptions<RetryClaimPayoutMutation, RetryClaimPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RetryClaimPayoutMutation, RetryClaimPayoutMutationVariables>(RetryClaimPayoutDocument, options);
      }
export type RetryClaimPayoutMutationHookResult = ReturnType<typeof useRetryClaimPayoutMutation>;
export type RetryClaimPayoutMutationResult = Apollo.MutationResult<RetryClaimPayoutMutation>;
export type RetryClaimPayoutMutationOptions = Apollo.BaseMutationOptions<RetryClaimPayoutMutation, RetryClaimPayoutMutationVariables>;
export const UnFreezeWalletDocument = gql`
    mutation UnFreezeWallet($id: Int!) {
  unfreezeWallet(id: $id) {
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type UnFreezeWalletMutationFn = Apollo.MutationFunction<UnFreezeWalletMutation, UnFreezeWalletMutationVariables>;

/**
 * __useUnFreezeWalletMutation__
 *
 * To run a mutation, you first call `useUnFreezeWalletMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnFreezeWalletMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unFreezeWalletMutation, { data, loading, error }] = useUnFreezeWalletMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnFreezeWalletMutation(baseOptions?: Apollo.MutationHookOptions<UnFreezeWalletMutation, UnFreezeWalletMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnFreezeWalletMutation, UnFreezeWalletMutationVariables>(UnFreezeWalletDocument, options);
      }
export type UnFreezeWalletMutationHookResult = ReturnType<typeof useUnFreezeWalletMutation>;
export type UnFreezeWalletMutationResult = Apollo.MutationResult<UnFreezeWalletMutation>;
export type UnFreezeWalletMutationOptions = Apollo.BaseMutationOptions<UnFreezeWalletMutation, UnFreezeWalletMutationVariables>;
export const AddPartnerDocument = gql`
    mutation addPartner($memberCity: String!, $memberCountry: String!, $memberPostcode: String!, $memberStreetAddress: String!, $partnerDateOfBirth: Date!, $partnerEmail: String!, $partnerFirstName: String!, $partnerLastName: String!, $sameEmployer: Boolean!, $sameHousehold: Boolean!, $partnerEmployeeNumber: String, $partnerCity: String, $partnerCountry: String, $partnerPostcode: String, $partnerStreetAddress: String) {
  addPartner(
    memberCity: $memberCity
    memberCountry: $memberCountry
    memberPostcode: $memberPostcode
    memberStreetAddress: $memberStreetAddress
    partnerDateOfBirth: $partnerDateOfBirth
    partnerEmail: $partnerEmail
    partnerFirstName: $partnerFirstName
    partnerLastName: $partnerLastName
    sameEmployer: $sameEmployer
    sameHousehold: $sameHousehold
    partnerEmployeeNumber: $partnerEmployeeNumber
    partnerCity: $partnerCity
    partnerStreetAddress: $partnerStreetAddress
    partnerPostcode: $partnerPostcode
    partnerCountry: $partnerCountry
  ) {
    errorCode
    success
    errors {
      messages
      field
    }
  }
}
    `;
export type AddPartnerMutationFn = Apollo.MutationFunction<AddPartnerMutation, AddPartnerMutationVariables>;

/**
 * __useAddPartnerMutation__
 *
 * To run a mutation, you first call `useAddPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPartnerMutation, { data, loading, error }] = useAddPartnerMutation({
 *   variables: {
 *      memberCity: // value for 'memberCity'
 *      memberCountry: // value for 'memberCountry'
 *      memberPostcode: // value for 'memberPostcode'
 *      memberStreetAddress: // value for 'memberStreetAddress'
 *      partnerDateOfBirth: // value for 'partnerDateOfBirth'
 *      partnerEmail: // value for 'partnerEmail'
 *      partnerFirstName: // value for 'partnerFirstName'
 *      partnerLastName: // value for 'partnerLastName'
 *      sameEmployer: // value for 'sameEmployer'
 *      sameHousehold: // value for 'sameHousehold'
 *      partnerEmployeeNumber: // value for 'partnerEmployeeNumber'
 *      partnerCity: // value for 'partnerCity'
 *      partnerCountry: // value for 'partnerCountry'
 *      partnerPostcode: // value for 'partnerPostcode'
 *      partnerStreetAddress: // value for 'partnerStreetAddress'
 *   },
 * });
 */
export function useAddPartnerMutation(baseOptions?: Apollo.MutationHookOptions<AddPartnerMutation, AddPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPartnerMutation, AddPartnerMutationVariables>(AddPartnerDocument, options);
      }
export type AddPartnerMutationHookResult = ReturnType<typeof useAddPartnerMutation>;
export type AddPartnerMutationResult = Apollo.MutationResult<AddPartnerMutation>;
export type AddPartnerMutationOptions = Apollo.BaseMutationOptions<AddPartnerMutation, AddPartnerMutationVariables>;
export const AddFilesDocument = gql`
    mutation addFiles($transaction: Int!, $files: [Upload]!, $isMedicallyNecessaryTreatment: Boolean) {
  addTransactionUploads(
    files: $files
    transaction: $transaction
    isMedicallyNecessaryTreatment: $isMedicallyNecessaryTreatment
  ) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type AddFilesMutationFn = Apollo.MutationFunction<AddFilesMutation, AddFilesMutationVariables>;

/**
 * __useAddFilesMutation__
 *
 * To run a mutation, you first call `useAddFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFilesMutation, { data, loading, error }] = useAddFilesMutation({
 *   variables: {
 *      transaction: // value for 'transaction'
 *      files: // value for 'files'
 *      isMedicallyNecessaryTreatment: // value for 'isMedicallyNecessaryTreatment'
 *   },
 * });
 */
export function useAddFilesMutation(baseOptions?: Apollo.MutationHookOptions<AddFilesMutation, AddFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFilesMutation, AddFilesMutationVariables>(AddFilesDocument, options);
      }
export type AddFilesMutationHookResult = ReturnType<typeof useAddFilesMutation>;
export type AddFilesMutationResult = Apollo.MutationResult<AddFilesMutation>;
export type AddFilesMutationOptions = Apollo.BaseMutationOptions<AddFilesMutation, AddFilesMutationVariables>;
export const UploadPlanDocument = gql`
    mutation uploadPlan($wallet: Int!, $file: Upload!) {
  addTreatmentPlan(wallet: $wallet, file: $file) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type UploadPlanMutationFn = Apollo.MutationFunction<UploadPlanMutation, UploadPlanMutationVariables>;

/**
 * __useUploadPlanMutation__
 *
 * To run a mutation, you first call `useUploadPlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPlanMutation, { data, loading, error }] = useUploadPlanMutation({
 *   variables: {
 *      wallet: // value for 'wallet'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadPlanMutation(baseOptions?: Apollo.MutationHookOptions<UploadPlanMutation, UploadPlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPlanMutation, UploadPlanMutationVariables>(UploadPlanDocument, options);
      }
export type UploadPlanMutationHookResult = ReturnType<typeof useUploadPlanMutation>;
export type UploadPlanMutationResult = Apollo.MutationResult<UploadPlanMutation>;
export type UploadPlanMutationOptions = Apollo.BaseMutationOptions<UploadPlanMutation, UploadPlanMutationVariables>;
export const AddWalletPhoneNumberDocument = gql`
    mutation addWalletPhoneNumber($phoneNumber: String!) {
  changePhoneNumber(phoneNumber: $phoneNumber) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type AddWalletPhoneNumberMutationFn = Apollo.MutationFunction<AddWalletPhoneNumberMutation, AddWalletPhoneNumberMutationVariables>;

/**
 * __useAddWalletPhoneNumberMutation__
 *
 * To run a mutation, you first call `useAddWalletPhoneNumberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddWalletPhoneNumberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addWalletPhoneNumberMutation, { data, loading, error }] = useAddWalletPhoneNumberMutation({
 *   variables: {
 *      phoneNumber: // value for 'phoneNumber'
 *   },
 * });
 */
export function useAddWalletPhoneNumberMutation(baseOptions?: Apollo.MutationHookOptions<AddWalletPhoneNumberMutation, AddWalletPhoneNumberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddWalletPhoneNumberMutation, AddWalletPhoneNumberMutationVariables>(AddWalletPhoneNumberDocument, options);
      }
export type AddWalletPhoneNumberMutationHookResult = ReturnType<typeof useAddWalletPhoneNumberMutation>;
export type AddWalletPhoneNumberMutationResult = Apollo.MutationResult<AddWalletPhoneNumberMutation>;
export type AddWalletPhoneNumberMutationOptions = Apollo.BaseMutationOptions<AddWalletPhoneNumberMutation, AddWalletPhoneNumberMutationVariables>;
export const ChangeLanguageDocument = gql`
    mutation changeLanguage($language: String!) {
  changeLanguage(language: $language) {
    success
    errorCode
  }
}
    `;
export type ChangeLanguageMutationFn = Apollo.MutationFunction<ChangeLanguageMutation, ChangeLanguageMutationVariables>;

/**
 * __useChangeLanguageMutation__
 *
 * To run a mutation, you first call `useChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeLanguageMutation, { data, loading, error }] = useChangeLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useChangeLanguageMutation(baseOptions?: Apollo.MutationHookOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeLanguageMutation, ChangeLanguageMutationVariables>(ChangeLanguageDocument, options);
      }
export type ChangeLanguageMutationHookResult = ReturnType<typeof useChangeLanguageMutation>;
export type ChangeLanguageMutationResult = Apollo.MutationResult<ChangeLanguageMutation>;
export type ChangeLanguageMutationOptions = Apollo.BaseMutationOptions<ChangeLanguageMutation, ChangeLanguageMutationVariables>;
export const ChangeNationalityDocument = gql`
    mutation ChangeNationality($nationality: String!) {
  changeNationality(nationality: $nationality) {
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type ChangeNationalityMutationFn = Apollo.MutationFunction<ChangeNationalityMutation, ChangeNationalityMutationVariables>;

/**
 * __useChangeNationalityMutation__
 *
 * To run a mutation, you first call `useChangeNationalityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeNationalityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeNationalityMutation, { data, loading, error }] = useChangeNationalityMutation({
 *   variables: {
 *      nationality: // value for 'nationality'
 *   },
 * });
 */
export function useChangeNationalityMutation(baseOptions?: Apollo.MutationHookOptions<ChangeNationalityMutation, ChangeNationalityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeNationalityMutation, ChangeNationalityMutationVariables>(ChangeNationalityDocument, options);
      }
export type ChangeNationalityMutationHookResult = ReturnType<typeof useChangeNationalityMutation>;
export type ChangeNationalityMutationResult = Apollo.MutationResult<ChangeNationalityMutation>;
export type ChangeNationalityMutationOptions = Apollo.BaseMutationOptions<ChangeNationalityMutation, ChangeNationalityMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($currentPassword: String!, $newPassword: String!) {
  changePassword(newPassword: $newPassword, oldPassword: $currentPassword) {
    code
    message
    errors
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      currentPassword: // value for 'currentPassword'
 *      newPassword: // value for 'newPassword'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const ConfirmUserEmailDocument = gql`
    mutation confirmUserEmail($token: String!) {
  confirmUserEmail(token: $token) {
    code
    message
    errors
  }
}
    `;
export type ConfirmUserEmailMutationFn = Apollo.MutationFunction<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>;

/**
 * __useConfirmUserEmailMutation__
 *
 * To run a mutation, you first call `useConfirmUserEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmUserEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmUserEmailMutation, { data, loading, error }] = useConfirmUserEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmUserEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>(ConfirmUserEmailDocument, options);
      }
export type ConfirmUserEmailMutationHookResult = ReturnType<typeof useConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationResult = Apollo.MutationResult<ConfirmUserEmailMutation>;
export type ConfirmUserEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmUserEmailMutation, ConfirmUserEmailMutationVariables>;
export const ConfirmPrivateEmailDocument = gql`
    mutation confirmPrivateEmail($token: String!) {
  confirmPrivateEmail(token: $token) {
    success
    errorCode
  }
}
    `;
export type ConfirmPrivateEmailMutationFn = Apollo.MutationFunction<ConfirmPrivateEmailMutation, ConfirmPrivateEmailMutationVariables>;

/**
 * __useConfirmPrivateEmailMutation__
 *
 * To run a mutation, you first call `useConfirmPrivateEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmPrivateEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmPrivateEmailMutation, { data, loading, error }] = useConfirmPrivateEmailMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useConfirmPrivateEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmPrivateEmailMutation, ConfirmPrivateEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmPrivateEmailMutation, ConfirmPrivateEmailMutationVariables>(ConfirmPrivateEmailDocument, options);
      }
export type ConfirmPrivateEmailMutationHookResult = ReturnType<typeof useConfirmPrivateEmailMutation>;
export type ConfirmPrivateEmailMutationResult = Apollo.MutationResult<ConfirmPrivateEmailMutation>;
export type ConfirmPrivateEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmPrivateEmailMutation, ConfirmPrivateEmailMutationVariables>;
export const CreateAccountDocument = gql`
    mutation createAccount($acceptPrivacyStatement: Boolean, $acceptTermsConditions: Boolean, $birthDate: String, $privateEmail: String, $city: String, $pronouns: String, $preferredGivenName: String, $preferredSurname: String, $memberJourney: String) {
  createAccount(
    acceptPrivacyStatement: $acceptPrivacyStatement
    acceptTermsConditions: $acceptTermsConditions
    birthDate: $birthDate
    privateEmail: $privateEmail
    city: $city
    pronouns: $pronouns
    preferredGivenName: $preferredGivenName
    preferredSurname: $preferredSurname
    memberJourney: $memberJourney
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      acceptPrivacyStatement: // value for 'acceptPrivacyStatement'
 *      acceptTermsConditions: // value for 'acceptTermsConditions'
 *      birthDate: // value for 'birthDate'
 *      privateEmail: // value for 'privateEmail'
 *      city: // value for 'city'
 *      pronouns: // value for 'pronouns'
 *      preferredGivenName: // value for 'preferredGivenName'
 *      preferredSurname: // value for 'preferredSurname'
 *      memberJourney: // value for 'memberJourney'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const CreateAirwallexBeneficiaryDocument = gql`
    mutation createAirwallexBeneficiary($payload: GenericScalar!) {
  createAirwallexBeneficiary(payload: $payload) {
    success
    errorCode
    beneficiaryId
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateAirwallexBeneficiaryMutationFn = Apollo.MutationFunction<CreateAirwallexBeneficiaryMutation, CreateAirwallexBeneficiaryMutationVariables>;

/**
 * __useCreateAirwallexBeneficiaryMutation__
 *
 * To run a mutation, you first call `useCreateAirwallexBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAirwallexBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAirwallexBeneficiaryMutation, { data, loading, error }] = useCreateAirwallexBeneficiaryMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useCreateAirwallexBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<CreateAirwallexBeneficiaryMutation, CreateAirwallexBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAirwallexBeneficiaryMutation, CreateAirwallexBeneficiaryMutationVariables>(CreateAirwallexBeneficiaryDocument, options);
      }
export type CreateAirwallexBeneficiaryMutationHookResult = ReturnType<typeof useCreateAirwallexBeneficiaryMutation>;
export type CreateAirwallexBeneficiaryMutationResult = Apollo.MutationResult<CreateAirwallexBeneficiaryMutation>;
export type CreateAirwallexBeneficiaryMutationOptions = Apollo.BaseMutationOptions<CreateAirwallexBeneficiaryMutation, CreateAirwallexBeneficiaryMutationVariables>;
export const CreateReimbursementClaimDocument = gql`
    mutation createReimbursementClaim($treatment: ID!, $treatmentCadence: Int, $treatmentAdditionalInfo: String, $documents: [RequestReimbursementPayload]!, $claimant: String!, $accountHolderName: String, $accountNumber: String, $country: String, $bankName: String, $swiftCode: String, $createdBy: String, $isMedicallyNecessaryTreatment: Boolean, $accountType: String, $localFields: JSONString, $id: ID, $existingDocumentIds: [ID]) {
  createReimbursementClaim(
    treatment: $treatment
    treatmentCadence: $treatmentCadence
    treatmentAdditionalInfo: $treatmentAdditionalInfo
    documents: $documents
    claimant: $claimant
    accountNumber: $accountNumber
    accountHolderName: $accountHolderName
    bankName: $bankName
    country: $country
    swiftCode: $swiftCode
    createdBy: $createdBy
    isMedicallyNecessaryTreatment: $isMedicallyNecessaryTreatment
    accountType: $accountType
    localFields: $localFields
    existingDocumentIds: $existingDocumentIds
    id: $id
  ) {
    claimId
    errorCode
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type CreateReimbursementClaimMutationFn = Apollo.MutationFunction<CreateReimbursementClaimMutation, CreateReimbursementClaimMutationVariables>;

/**
 * __useCreateReimbursementClaimMutation__
 *
 * To run a mutation, you first call `useCreateReimbursementClaimMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReimbursementClaimMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReimbursementClaimMutation, { data, loading, error }] = useCreateReimbursementClaimMutation({
 *   variables: {
 *      treatment: // value for 'treatment'
 *      treatmentCadence: // value for 'treatmentCadence'
 *      treatmentAdditionalInfo: // value for 'treatmentAdditionalInfo'
 *      documents: // value for 'documents'
 *      claimant: // value for 'claimant'
 *      accountHolderName: // value for 'accountHolderName'
 *      accountNumber: // value for 'accountNumber'
 *      country: // value for 'country'
 *      bankName: // value for 'bankName'
 *      swiftCode: // value for 'swiftCode'
 *      createdBy: // value for 'createdBy'
 *      isMedicallyNecessaryTreatment: // value for 'isMedicallyNecessaryTreatment'
 *      accountType: // value for 'accountType'
 *      localFields: // value for 'localFields'
 *      id: // value for 'id'
 *      existingDocumentIds: // value for 'existingDocumentIds'
 *   },
 * });
 */
export function useCreateReimbursementClaimMutation(baseOptions?: Apollo.MutationHookOptions<CreateReimbursementClaimMutation, CreateReimbursementClaimMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReimbursementClaimMutation, CreateReimbursementClaimMutationVariables>(CreateReimbursementClaimDocument, options);
      }
export type CreateReimbursementClaimMutationHookResult = ReturnType<typeof useCreateReimbursementClaimMutation>;
export type CreateReimbursementClaimMutationResult = Apollo.MutationResult<CreateReimbursementClaimMutation>;
export type CreateReimbursementClaimMutationOptions = Apollo.BaseMutationOptions<CreateReimbursementClaimMutation, CreateReimbursementClaimMutationVariables>;
export const CustomSupportRequestDocument = gql`
    mutation customSupportRequest($privateEmail: String!, $body: String!, $copySelf: Boolean) {
  customSupportRequest(
    privateEmail: $privateEmail
    body: $body
    copySelf: $copySelf
  ) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type CustomSupportRequestMutationFn = Apollo.MutationFunction<CustomSupportRequestMutation, CustomSupportRequestMutationVariables>;

/**
 * __useCustomSupportRequestMutation__
 *
 * To run a mutation, you first call `useCustomSupportRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomSupportRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customSupportRequestMutation, { data, loading, error }] = useCustomSupportRequestMutation({
 *   variables: {
 *      privateEmail: // value for 'privateEmail'
 *      body: // value for 'body'
 *      copySelf: // value for 'copySelf'
 *   },
 * });
 */
export function useCustomSupportRequestMutation(baseOptions?: Apollo.MutationHookOptions<CustomSupportRequestMutation, CustomSupportRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CustomSupportRequestMutation, CustomSupportRequestMutationVariables>(CustomSupportRequestDocument, options);
      }
export type CustomSupportRequestMutationHookResult = ReturnType<typeof useCustomSupportRequestMutation>;
export type CustomSupportRequestMutationResult = Apollo.MutationResult<CustomSupportRequestMutation>;
export type CustomSupportRequestMutationOptions = Apollo.BaseMutationOptions<CustomSupportRequestMutation, CustomSupportRequestMutationVariables>;
export const DisableRedesignNotificationDocument = gql`
    mutation disableRedesignNotification {
  disableRedesignNotification {
    errorCode
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type DisableRedesignNotificationMutationFn = Apollo.MutationFunction<DisableRedesignNotificationMutation, DisableRedesignNotificationMutationVariables>;

/**
 * __useDisableRedesignNotificationMutation__
 *
 * To run a mutation, you first call `useDisableRedesignNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableRedesignNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableRedesignNotificationMutation, { data, loading, error }] = useDisableRedesignNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableRedesignNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DisableRedesignNotificationMutation, DisableRedesignNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableRedesignNotificationMutation, DisableRedesignNotificationMutationVariables>(DisableRedesignNotificationDocument, options);
      }
export type DisableRedesignNotificationMutationHookResult = ReturnType<typeof useDisableRedesignNotificationMutation>;
export type DisableRedesignNotificationMutationResult = Apollo.MutationResult<DisableRedesignNotificationMutation>;
export type DisableRedesignNotificationMutationOptions = Apollo.BaseMutationOptions<DisableRedesignNotificationMutation, DisableRedesignNotificationMutationVariables>;
export const DisableNewClaimsFlowNotificationDocument = gql`
    mutation disableNewClaimsFlowNotification {
  disableNewClaimsFlowNotification {
    errorCode
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type DisableNewClaimsFlowNotificationMutationFn = Apollo.MutationFunction<DisableNewClaimsFlowNotificationMutation, DisableNewClaimsFlowNotificationMutationVariables>;

/**
 * __useDisableNewClaimsFlowNotificationMutation__
 *
 * To run a mutation, you first call `useDisableNewClaimsFlowNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableNewClaimsFlowNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableNewClaimsFlowNotificationMutation, { data, loading, error }] = useDisableNewClaimsFlowNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisableNewClaimsFlowNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DisableNewClaimsFlowNotificationMutation, DisableNewClaimsFlowNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableNewClaimsFlowNotificationMutation, DisableNewClaimsFlowNotificationMutationVariables>(DisableNewClaimsFlowNotificationDocument, options);
      }
export type DisableNewClaimsFlowNotificationMutationHookResult = ReturnType<typeof useDisableNewClaimsFlowNotificationMutation>;
export type DisableNewClaimsFlowNotificationMutationResult = Apollo.MutationResult<DisableNewClaimsFlowNotificationMutation>;
export type DisableNewClaimsFlowNotificationMutationOptions = Apollo.BaseMutationOptions<DisableNewClaimsFlowNotificationMutation, DisableNewClaimsFlowNotificationMutationVariables>;
export const DisablePartnerConsentNotificationDocument = gql`
    mutation disablePartnerConsentNotification {
  disablePartnerConsentNotification {
    errorCode
    errors {
      field
      messages
    }
    success
  }
}
    `;
export type DisablePartnerConsentNotificationMutationFn = Apollo.MutationFunction<DisablePartnerConsentNotificationMutation, DisablePartnerConsentNotificationMutationVariables>;

/**
 * __useDisablePartnerConsentNotificationMutation__
 *
 * To run a mutation, you first call `useDisablePartnerConsentNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisablePartnerConsentNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disablePartnerConsentNotificationMutation, { data, loading, error }] = useDisablePartnerConsentNotificationMutation({
 *   variables: {
 *   },
 * });
 */
export function useDisablePartnerConsentNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DisablePartnerConsentNotificationMutation, DisablePartnerConsentNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisablePartnerConsentNotificationMutation, DisablePartnerConsentNotificationMutationVariables>(DisablePartnerConsentNotificationDocument, options);
      }
export type DisablePartnerConsentNotificationMutationHookResult = ReturnType<typeof useDisablePartnerConsentNotificationMutation>;
export type DisablePartnerConsentNotificationMutationResult = Apollo.MutationResult<DisablePartnerConsentNotificationMutation>;
export type DisablePartnerConsentNotificationMutationOptions = Apollo.BaseMutationOptions<DisablePartnerConsentNotificationMutation, DisablePartnerConsentNotificationMutationVariables>;
export const LoginDocument = gql`
    mutation login($email: String!, $password: String!) {
  login(input: {username: $email, password: $password, application: "MEMBER"}) {
    username
    code
    message
    loggedInBy
    errors {
      field
      messages
    }
    isEmailConfirmed
    showMemberPromotion
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const LogoutDocument = gql`
    mutation logout {
  logout {
    code
    message
    errors
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const RegisterDocument = gql`
    mutation Register($token: String!, $password: String!, $firstName: String!, $lastName: String!, $language: String) {
  register(
    token: $token
    password: $password
    firstName: $firstName
    lastName: $lastName
    language: $language
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type RegisterMutationFn = Apollo.MutationFunction<RegisterMutation, RegisterMutationVariables>;

/**
 * __useRegisterMutation__
 *
 * To run a mutation, you first call `useRegisterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerMutation, { data, loading, error }] = useRegisterMutation({
 *   variables: {
 *      token: // value for 'token'
 *      password: // value for 'password'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useRegisterMutation(baseOptions?: Apollo.MutationHookOptions<RegisterMutation, RegisterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterMutation, RegisterMutationVariables>(RegisterDocument, options);
      }
export type RegisterMutationHookResult = ReturnType<typeof useRegisterMutation>;
export type RegisterMutationResult = Apollo.MutationResult<RegisterMutation>;
export type RegisterMutationOptions = Apollo.BaseMutationOptions<RegisterMutation, RegisterMutationVariables>;
export const RequestResetPasswordDocument = gql`
    mutation requestResetPassword($email: String!) {
  requestPasswordReset(input: {email: $email}) {
    code
    errors
    message
  }
}
    `;
export type RequestResetPasswordMutationFn = Apollo.MutationFunction<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;

/**
 * __useRequestResetPasswordMutation__
 *
 * To run a mutation, you first call `useRequestResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestResetPasswordMutation, { data, loading, error }] = useRequestResetPasswordMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>(RequestResetPasswordDocument, options);
      }
export type RequestResetPasswordMutationHookResult = ReturnType<typeof useRequestResetPasswordMutation>;
export type RequestResetPasswordMutationResult = Apollo.MutationResult<RequestResetPasswordMutation>;
export type RequestResetPasswordMutationOptions = Apollo.BaseMutationOptions<RequestResetPasswordMutation, RequestResetPasswordMutationVariables>;
export const RequestUserEmailConfirmationDocument = gql`
    mutation requestUserEmailConfirmation($email: String!) {
  requestUserEmailConfirmation(email: $email) {
    errors
    code
    message
  }
}
    `;
export type RequestUserEmailConfirmationMutationFn = Apollo.MutationFunction<RequestUserEmailConfirmationMutation, RequestUserEmailConfirmationMutationVariables>;

/**
 * __useRequestUserEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useRequestUserEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestUserEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestUserEmailConfirmationMutation, { data, loading, error }] = useRequestUserEmailConfirmationMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestUserEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<RequestUserEmailConfirmationMutation, RequestUserEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestUserEmailConfirmationMutation, RequestUserEmailConfirmationMutationVariables>(RequestUserEmailConfirmationDocument, options);
      }
export type RequestUserEmailConfirmationMutationHookResult = ReturnType<typeof useRequestUserEmailConfirmationMutation>;
export type RequestUserEmailConfirmationMutationResult = Apollo.MutationResult<RequestUserEmailConfirmationMutation>;
export type RequestUserEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<RequestUserEmailConfirmationMutation, RequestUserEmailConfirmationMutationVariables>;
export const ResendPartnerConsentDocument = gql`
    mutation resendPartnerConsent {
  resendPartnerConsentEmail {
    success
    errors {
      messages
      field
    }
    errorCode
  }
}
    `;
export type ResendPartnerConsentMutationFn = Apollo.MutationFunction<ResendPartnerConsentMutation, ResendPartnerConsentMutationVariables>;

/**
 * __useResendPartnerConsentMutation__
 *
 * To run a mutation, you first call `useResendPartnerConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPartnerConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPartnerConsentMutation, { data, loading, error }] = useResendPartnerConsentMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendPartnerConsentMutation(baseOptions?: Apollo.MutationHookOptions<ResendPartnerConsentMutation, ResendPartnerConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPartnerConsentMutation, ResendPartnerConsentMutationVariables>(ResendPartnerConsentDocument, options);
      }
export type ResendPartnerConsentMutationHookResult = ReturnType<typeof useResendPartnerConsentMutation>;
export type ResendPartnerConsentMutationResult = Apollo.MutationResult<ResendPartnerConsentMutation>;
export type ResendPartnerConsentMutationOptions = Apollo.BaseMutationOptions<ResendPartnerConsentMutation, ResendPartnerConsentMutationVariables>;
export const ResendPrivateEmailConfirmationDocument = gql`
    mutation resendPrivateEmailConfirmation {
  resendPrivateEmailConfirmation {
    success
    errorCode
  }
}
    `;
export type ResendPrivateEmailConfirmationMutationFn = Apollo.MutationFunction<ResendPrivateEmailConfirmationMutation, ResendPrivateEmailConfirmationMutationVariables>;

/**
 * __useResendPrivateEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useResendPrivateEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendPrivateEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendPrivateEmailConfirmationMutation, { data, loading, error }] = useResendPrivateEmailConfirmationMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendPrivateEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<ResendPrivateEmailConfirmationMutation, ResendPrivateEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendPrivateEmailConfirmationMutation, ResendPrivateEmailConfirmationMutationVariables>(ResendPrivateEmailConfirmationDocument, options);
      }
export type ResendPrivateEmailConfirmationMutationHookResult = ReturnType<typeof useResendPrivateEmailConfirmationMutation>;
export type ResendPrivateEmailConfirmationMutationResult = Apollo.MutationResult<ResendPrivateEmailConfirmationMutation>;
export type ResendPrivateEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<ResendPrivateEmailConfirmationMutation, ResendPrivateEmailConfirmationMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation resetPassword($newPassword: String!, $token: String!, $uid: String!) {
  resetPassword(newPassword: $newPassword, token: $token, uid: $uid) {
    code
    errors
    message
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      token: // value for 'token'
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendConfirmRegistrationEmailDocument = gql`
    mutation SendConfirmRegistrationEmail($email: String!, $language: String, $alternativeAuth: String) {
  sendConfirmRegistrationEmail(
    email: $email
    language: $language
    alternativeAuth: $alternativeAuth
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type SendConfirmRegistrationEmailMutationFn = Apollo.MutationFunction<SendConfirmRegistrationEmailMutation, SendConfirmRegistrationEmailMutationVariables>;

/**
 * __useSendConfirmRegistrationEmailMutation__
 *
 * To run a mutation, you first call `useSendConfirmRegistrationEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendConfirmRegistrationEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendConfirmRegistrationEmailMutation, { data, loading, error }] = useSendConfirmRegistrationEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      language: // value for 'language'
 *      alternativeAuth: // value for 'alternativeAuth'
 *   },
 * });
 */
export function useSendConfirmRegistrationEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendConfirmRegistrationEmailMutation, SendConfirmRegistrationEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendConfirmRegistrationEmailMutation, SendConfirmRegistrationEmailMutationVariables>(SendConfirmRegistrationEmailDocument, options);
      }
export type SendConfirmRegistrationEmailMutationHookResult = ReturnType<typeof useSendConfirmRegistrationEmailMutation>;
export type SendConfirmRegistrationEmailMutationResult = Apollo.MutationResult<SendConfirmRegistrationEmailMutation>;
export type SendConfirmRegistrationEmailMutationOptions = Apollo.BaseMutationOptions<SendConfirmRegistrationEmailMutation, SendConfirmRegistrationEmailMutationVariables>;
export const SetupMenopauseProfileDocument = gql`
    mutation setupMenopauseProfile($lastMenstrualPeriod: String, $menopauseSymptoms: [String], $menstrualPeriodStatus: String, $otherSymptomsDescription: String) {
  setupMenopauseProfile(
    lastMenstrualPeriod: $lastMenstrualPeriod
    menopauseSymptoms: $menopauseSymptoms
    menstrualPeriodStatus: $menstrualPeriodStatus
    otherSymptomsDescription: $otherSymptomsDescription
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type SetupMenopauseProfileMutationFn = Apollo.MutationFunction<SetupMenopauseProfileMutation, SetupMenopauseProfileMutationVariables>;

/**
 * __useSetupMenopauseProfileMutation__
 *
 * To run a mutation, you first call `useSetupMenopauseProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupMenopauseProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupMenopauseProfileMutation, { data, loading, error }] = useSetupMenopauseProfileMutation({
 *   variables: {
 *      lastMenstrualPeriod: // value for 'lastMenstrualPeriod'
 *      menopauseSymptoms: // value for 'menopauseSymptoms'
 *      menstrualPeriodStatus: // value for 'menstrualPeriodStatus'
 *      otherSymptomsDescription: // value for 'otherSymptomsDescription'
 *   },
 * });
 */
export function useSetupMenopauseProfileMutation(baseOptions?: Apollo.MutationHookOptions<SetupMenopauseProfileMutation, SetupMenopauseProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupMenopauseProfileMutation, SetupMenopauseProfileMutationVariables>(SetupMenopauseProfileDocument, options);
      }
export type SetupMenopauseProfileMutationHookResult = ReturnType<typeof useSetupMenopauseProfileMutation>;
export type SetupMenopauseProfileMutationResult = Apollo.MutationResult<SetupMenopauseProfileMutation>;
export type SetupMenopauseProfileMutationOptions = Apollo.BaseMutationOptions<SetupMenopauseProfileMutation, SetupMenopauseProfileMutationVariables>;
export const SetupPregnancyPostpartumProfileDocument = gql`
    mutation setupPregnancyPostpartumProfile($deliveryDate: Date, $dueDate: Date, $pregnancyPostpartumStatus: String) {
  setupPregnancyPostpartumProfile(
    deliveryDate: $deliveryDate
    dueDate: $dueDate
    pregnancyPostpartumStatus: $pregnancyPostpartumStatus
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type SetupPregnancyPostpartumProfileMutationFn = Apollo.MutationFunction<SetupPregnancyPostpartumProfileMutation, SetupPregnancyPostpartumProfileMutationVariables>;

/**
 * __useSetupPregnancyPostpartumProfileMutation__
 *
 * To run a mutation, you first call `useSetupPregnancyPostpartumProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupPregnancyPostpartumProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupPregnancyPostpartumProfileMutation, { data, loading, error }] = useSetupPregnancyPostpartumProfileMutation({
 *   variables: {
 *      deliveryDate: // value for 'deliveryDate'
 *      dueDate: // value for 'dueDate'
 *      pregnancyPostpartumStatus: // value for 'pregnancyPostpartumStatus'
 *   },
 * });
 */
export function useSetupPregnancyPostpartumProfileMutation(baseOptions?: Apollo.MutationHookOptions<SetupPregnancyPostpartumProfileMutation, SetupPregnancyPostpartumProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupPregnancyPostpartumProfileMutation, SetupPregnancyPostpartumProfileMutationVariables>(SetupPregnancyPostpartumProfileDocument, options);
      }
export type SetupPregnancyPostpartumProfileMutationHookResult = ReturnType<typeof useSetupPregnancyPostpartumProfileMutation>;
export type SetupPregnancyPostpartumProfileMutationResult = Apollo.MutationResult<SetupPregnancyPostpartumProfileMutation>;
export type SetupPregnancyPostpartumProfileMutationOptions = Apollo.BaseMutationOptions<SetupPregnancyPostpartumProfileMutation, SetupPregnancyPostpartumProfileMutationVariables>;
export const SetupProfileDocument = gql`
    mutation setupProfile($birthAssignedSex: String, $familyFormingJourney: String, $genderIdentity: String, $relationshipDynamic: String) {
  setupProfile(
    birthAssignedSex: $birthAssignedSex
    familyFormingJourney: $familyFormingJourney
    genderIdentity: $genderIdentity
    relationshipDynamic: $relationshipDynamic
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type SetupProfileMutationFn = Apollo.MutationFunction<SetupProfileMutation, SetupProfileMutationVariables>;

/**
 * __useSetupProfileMutation__
 *
 * To run a mutation, you first call `useSetupProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetupProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setupProfileMutation, { data, loading, error }] = useSetupProfileMutation({
 *   variables: {
 *      birthAssignedSex: // value for 'birthAssignedSex'
 *      familyFormingJourney: // value for 'familyFormingJourney'
 *      genderIdentity: // value for 'genderIdentity'
 *      relationshipDynamic: // value for 'relationshipDynamic'
 *   },
 * });
 */
export function useSetupProfileMutation(baseOptions?: Apollo.MutationHookOptions<SetupProfileMutation, SetupProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetupProfileMutation, SetupProfileMutationVariables>(SetupProfileDocument, options);
      }
export type SetupProfileMutationHookResult = ReturnType<typeof useSetupProfileMutation>;
export type SetupProfileMutationResult = Apollo.MutationResult<SetupProfileMutation>;
export type SetupProfileMutationOptions = Apollo.BaseMutationOptions<SetupProfileMutation, SetupProfileMutationVariables>;
export const SignupMemberDocument = gql`
    mutation signupMember($email: String!, $password: String!, $language: String) {
  signupMember(email: $email, password: $password, language: $language) {
    code
    message
    errors
  }
}
    `;
export type SignupMemberMutationFn = Apollo.MutationFunction<SignupMemberMutation, SignupMemberMutationVariables>;

/**
 * __useSignupMemberMutation__
 *
 * To run a mutation, you first call `useSignupMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMemberMutation, { data, loading, error }] = useSignupMemberMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSignupMemberMutation(baseOptions?: Apollo.MutationHookOptions<SignupMemberMutation, SignupMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMemberMutation, SignupMemberMutationVariables>(SignupMemberDocument, options);
      }
export type SignupMemberMutationHookResult = ReturnType<typeof useSignupMemberMutation>;
export type SignupMemberMutationResult = Apollo.MutationResult<SignupMemberMutation>;
export type SignupMemberMutationOptions = Apollo.BaseMutationOptions<SignupMemberMutation, SignupMemberMutationVariables>;
export const SubmitFreshdeskTicketDocument = gql`
    mutation submitFreshdeskTicket($subject: String!, $body: String!) {
  submitFreshdeskTicket(subject: $subject, body: $body) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type SubmitFreshdeskTicketMutationFn = Apollo.MutationFunction<SubmitFreshdeskTicketMutation, SubmitFreshdeskTicketMutationVariables>;

/**
 * __useSubmitFreshdeskTicketMutation__
 *
 * To run a mutation, you first call `useSubmitFreshdeskTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFreshdeskTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFreshdeskTicketMutation, { data, loading, error }] = useSubmitFreshdeskTicketMutation({
 *   variables: {
 *      subject: // value for 'subject'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSubmitFreshdeskTicketMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFreshdeskTicketMutation, SubmitFreshdeskTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFreshdeskTicketMutation, SubmitFreshdeskTicketMutationVariables>(SubmitFreshdeskTicketDocument, options);
      }
export type SubmitFreshdeskTicketMutationHookResult = ReturnType<typeof useSubmitFreshdeskTicketMutation>;
export type SubmitFreshdeskTicketMutationResult = Apollo.MutationResult<SubmitFreshdeskTicketMutation>;
export type SubmitFreshdeskTicketMutationOptions = Apollo.BaseMutationOptions<SubmitFreshdeskTicketMutation, SubmitFreshdeskTicketMutationVariables>;
export const SubmitFreshdeskTicketAnonymouslyDocument = gql`
    mutation submitFreshdeskTicketAnonymously($email: String!, $body: String!) {
  submitFreshdeskTicketAnonymously(email: $email, body: $body) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type SubmitFreshdeskTicketAnonymouslyMutationFn = Apollo.MutationFunction<SubmitFreshdeskTicketAnonymouslyMutation, SubmitFreshdeskTicketAnonymouslyMutationVariables>;

/**
 * __useSubmitFreshdeskTicketAnonymouslyMutation__
 *
 * To run a mutation, you first call `useSubmitFreshdeskTicketAnonymouslyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitFreshdeskTicketAnonymouslyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitFreshdeskTicketAnonymouslyMutation, { data, loading, error }] = useSubmitFreshdeskTicketAnonymouslyMutation({
 *   variables: {
 *      email: // value for 'email'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSubmitFreshdeskTicketAnonymouslyMutation(baseOptions?: Apollo.MutationHookOptions<SubmitFreshdeskTicketAnonymouslyMutation, SubmitFreshdeskTicketAnonymouslyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitFreshdeskTicketAnonymouslyMutation, SubmitFreshdeskTicketAnonymouslyMutationVariables>(SubmitFreshdeskTicketAnonymouslyDocument, options);
      }
export type SubmitFreshdeskTicketAnonymouslyMutationHookResult = ReturnType<typeof useSubmitFreshdeskTicketAnonymouslyMutation>;
export type SubmitFreshdeskTicketAnonymouslyMutationResult = Apollo.MutationResult<SubmitFreshdeskTicketAnonymouslyMutation>;
export type SubmitFreshdeskTicketAnonymouslyMutationOptions = Apollo.BaseMutationOptions<SubmitFreshdeskTicketAnonymouslyMutation, SubmitFreshdeskTicketAnonymouslyMutationVariables>;
export const RequestSupportDocument = gql`
    mutation requestSupport($body: String!, $copySelf: Boolean, $subject: String!) {
  supportRequest(body: $body, copySelf: $copySelf, subject: $subject) {
    success
    errors {
      field
      messages
    }
  }
}
    `;
export type RequestSupportMutationFn = Apollo.MutationFunction<RequestSupportMutation, RequestSupportMutationVariables>;

/**
 * __useRequestSupportMutation__
 *
 * To run a mutation, you first call `useRequestSupportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestSupportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestSupportMutation, { data, loading, error }] = useRequestSupportMutation({
 *   variables: {
 *      body: // value for 'body'
 *      copySelf: // value for 'copySelf'
 *      subject: // value for 'subject'
 *   },
 * });
 */
export function useRequestSupportMutation(baseOptions?: Apollo.MutationHookOptions<RequestSupportMutation, RequestSupportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestSupportMutation, RequestSupportMutationVariables>(RequestSupportDocument, options);
      }
export type RequestSupportMutationHookResult = ReturnType<typeof useRequestSupportMutation>;
export type RequestSupportMutationResult = Apollo.MutationResult<RequestSupportMutation>;
export type RequestSupportMutationOptions = Apollo.BaseMutationOptions<RequestSupportMutation, RequestSupportMutationVariables>;
export const TrackReferralLetterDownloadDocument = gql`
    mutation trackReferralLetterDownload($country: String!) {
  trackReferralLetterDownload(country: $country) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type TrackReferralLetterDownloadMutationFn = Apollo.MutationFunction<TrackReferralLetterDownloadMutation, TrackReferralLetterDownloadMutationVariables>;

/**
 * __useTrackReferralLetterDownloadMutation__
 *
 * To run a mutation, you first call `useTrackReferralLetterDownloadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackReferralLetterDownloadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackReferralLetterDownloadMutation, { data, loading, error }] = useTrackReferralLetterDownloadMutation({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useTrackReferralLetterDownloadMutation(baseOptions?: Apollo.MutationHookOptions<TrackReferralLetterDownloadMutation, TrackReferralLetterDownloadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackReferralLetterDownloadMutation, TrackReferralLetterDownloadMutationVariables>(TrackReferralLetterDownloadDocument, options);
      }
export type TrackReferralLetterDownloadMutationHookResult = ReturnType<typeof useTrackReferralLetterDownloadMutation>;
export type TrackReferralLetterDownloadMutationResult = Apollo.MutationResult<TrackReferralLetterDownloadMutation>;
export type TrackReferralLetterDownloadMutationOptions = Apollo.BaseMutationOptions<TrackReferralLetterDownloadMutation, TrackReferralLetterDownloadMutationVariables>;
export const UpdateAirwallexBeneficiaryDocument = gql`
    mutation updateAirwallexBeneficiary($beneficiaryId: String!, $payload: GenericScalar!) {
  updateAirwallexBeneficiary(beneficiaryId: $beneficiaryId, payload: $payload) {
    success
    errorCode
    beneficiary
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateAirwallexBeneficiaryMutationFn = Apollo.MutationFunction<UpdateAirwallexBeneficiaryMutation, UpdateAirwallexBeneficiaryMutationVariables>;

/**
 * __useUpdateAirwallexBeneficiaryMutation__
 *
 * To run a mutation, you first call `useUpdateAirwallexBeneficiaryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAirwallexBeneficiaryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAirwallexBeneficiaryMutation, { data, loading, error }] = useUpdateAirwallexBeneficiaryMutation({
 *   variables: {
 *      beneficiaryId: // value for 'beneficiaryId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useUpdateAirwallexBeneficiaryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAirwallexBeneficiaryMutation, UpdateAirwallexBeneficiaryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAirwallexBeneficiaryMutation, UpdateAirwallexBeneficiaryMutationVariables>(UpdateAirwallexBeneficiaryDocument, options);
      }
export type UpdateAirwallexBeneficiaryMutationHookResult = ReturnType<typeof useUpdateAirwallexBeneficiaryMutation>;
export type UpdateAirwallexBeneficiaryMutationResult = Apollo.MutationResult<UpdateAirwallexBeneficiaryMutation>;
export type UpdateAirwallexBeneficiaryMutationOptions = Apollo.BaseMutationOptions<UpdateAirwallexBeneficiaryMutation, UpdateAirwallexBeneficiaryMutationVariables>;
export const UpdatePaymentInformationDocument = gql`
    mutation updatePaymentInformation($accountHolderName: String!, $accountNumber: String!, $bankName: String!, $country: String!, $swiftCode: String!, $accountType: String!, $localFields: JSONString) {
  updatePaymentInformation(
    accountHolderName: $accountHolderName
    accountNumber: $accountNumber
    bankName: $bankName
    country: $country
    swiftCode: $swiftCode
    accountType: $accountType
    localFields: $localFields
  ) {
    errorCode
    success
    errors {
      messages
      field
    }
  }
}
    `;
export type UpdatePaymentInformationMutationFn = Apollo.MutationFunction<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;

/**
 * __useUpdatePaymentInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePaymentInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePaymentInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePaymentInformationMutation, { data, loading, error }] = useUpdatePaymentInformationMutation({
 *   variables: {
 *      accountHolderName: // value for 'accountHolderName'
 *      accountNumber: // value for 'accountNumber'
 *      bankName: // value for 'bankName'
 *      country: // value for 'country'
 *      swiftCode: // value for 'swiftCode'
 *      accountType: // value for 'accountType'
 *      localFields: // value for 'localFields'
 *   },
 * });
 */
export function useUpdatePaymentInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>(UpdatePaymentInformationDocument, options);
      }
export type UpdatePaymentInformationMutationHookResult = ReturnType<typeof useUpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationResult = Apollo.MutationResult<UpdatePaymentInformationMutation>;
export type UpdatePaymentInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePaymentInformationMutation, UpdatePaymentInformationMutationVariables>;
export const UpdateMemberJourneyDocument = gql`
    mutation updateMemberJourney($memberJourney: String!, $endCurrentJourney: Boolean) {
  updateMemberJourney(
    memberJourney: $memberJourney
    endCurrentJourney: $endCurrentJourney
  ) {
    success
    errors {
      field
      messages
    }
    errorCode
  }
}
    `;
export type UpdateMemberJourneyMutationFn = Apollo.MutationFunction<UpdateMemberJourneyMutation, UpdateMemberJourneyMutationVariables>;

/**
 * __useUpdateMemberJourneyMutation__
 *
 * To run a mutation, you first call `useUpdateMemberJourneyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemberJourneyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemberJourneyMutation, { data, loading, error }] = useUpdateMemberJourneyMutation({
 *   variables: {
 *      memberJourney: // value for 'memberJourney'
 *      endCurrentJourney: // value for 'endCurrentJourney'
 *   },
 * });
 */
export function useUpdateMemberJourneyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemberJourneyMutation, UpdateMemberJourneyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemberJourneyMutation, UpdateMemberJourneyMutationVariables>(UpdateMemberJourneyDocument, options);
      }
export type UpdateMemberJourneyMutationHookResult = ReturnType<typeof useUpdateMemberJourneyMutation>;
export type UpdateMemberJourneyMutationResult = Apollo.MutationResult<UpdateMemberJourneyMutation>;
export type UpdateMemberJourneyMutationOptions = Apollo.BaseMutationOptions<UpdateMemberJourneyMutation, UpdateMemberJourneyMutationVariables>;
export const UpdatePersonaInformationDocument = gql`
    mutation updatePersonaInformation($addressCity: String, $addressCountry: String, $addressPostcode: String, $addressStreetAddress: String, $preferredGivenName: String, $preferredSurname: String, $birthDate: String, $city: String, $privateEmail: String, $pronouns: String, $docType: String, $idDoc: Upload) {
  updatePersonalInformation(
    addressCity: $addressCity
    addressCountry: $addressCountry
    addressPostcode: $addressPostcode
    addressStreetAddress: $addressStreetAddress
    preferredGivenName: $preferredGivenName
    preferredSurname: $preferredSurname
    birthDate: $birthDate
    city: $city
    privateEmail: $privateEmail
    pronouns: $pronouns
    idDoc: $idDoc
    docType: $docType
  ) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdatePersonaInformationMutationFn = Apollo.MutationFunction<UpdatePersonaInformationMutation, UpdatePersonaInformationMutationVariables>;

/**
 * __useUpdatePersonaInformationMutation__
 *
 * To run a mutation, you first call `useUpdatePersonaInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePersonaInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePersonaInformationMutation, { data, loading, error }] = useUpdatePersonaInformationMutation({
 *   variables: {
 *      addressCity: // value for 'addressCity'
 *      addressCountry: // value for 'addressCountry'
 *      addressPostcode: // value for 'addressPostcode'
 *      addressStreetAddress: // value for 'addressStreetAddress'
 *      preferredGivenName: // value for 'preferredGivenName'
 *      preferredSurname: // value for 'preferredSurname'
 *      birthDate: // value for 'birthDate'
 *      city: // value for 'city'
 *      privateEmail: // value for 'privateEmail'
 *      pronouns: // value for 'pronouns'
 *      docType: // value for 'docType'
 *      idDoc: // value for 'idDoc'
 *   },
 * });
 */
export function useUpdatePersonaInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePersonaInformationMutation, UpdatePersonaInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePersonaInformationMutation, UpdatePersonaInformationMutationVariables>(UpdatePersonaInformationDocument, options);
      }
export type UpdatePersonaInformationMutationHookResult = ReturnType<typeof useUpdatePersonaInformationMutation>;
export type UpdatePersonaInformationMutationResult = Apollo.MutationResult<UpdatePersonaInformationMutation>;
export type UpdatePersonaInformationMutationOptions = Apollo.BaseMutationOptions<UpdatePersonaInformationMutation, UpdatePersonaInformationMutationVariables>;
export const VerifyRegistrationTokenDocument = gql`
    mutation VerifyRegistrationToken($token: String!) {
  verifyRegistrationToken(token: $token) {
    success
    errorCode
    errors {
      field
      messages
    }
  }
}
    `;
export type VerifyRegistrationTokenMutationFn = Apollo.MutationFunction<VerifyRegistrationTokenMutation, VerifyRegistrationTokenMutationVariables>;

/**
 * __useVerifyRegistrationTokenMutation__
 *
 * To run a mutation, you first call `useVerifyRegistrationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyRegistrationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyRegistrationTokenMutation, { data, loading, error }] = useVerifyRegistrationTokenMutation({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useVerifyRegistrationTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyRegistrationTokenMutation, VerifyRegistrationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyRegistrationTokenMutation, VerifyRegistrationTokenMutationVariables>(VerifyRegistrationTokenDocument, options);
      }
export type VerifyRegistrationTokenMutationHookResult = ReturnType<typeof useVerifyRegistrationTokenMutation>;
export type VerifyRegistrationTokenMutationResult = Apollo.MutationResult<VerifyRegistrationTokenMutation>;
export type VerifyRegistrationTokenMutationOptions = Apollo.BaseMutationOptions<VerifyRegistrationTokenMutation, VerifyRegistrationTokenMutationVariables>;
export const ReimbursementRequestDocument = gql`
    query reimbursementRequest($claimId: ID) {
  reimbursementRequest(claimId: $claimId) {
    id
    files
    stage
    status
    documents {
      id
      reference
      documentType
      filename
      invoiceAmount {
        amount
        currency
      }
    }
    requestedDocuments {
      id
      notProvidedReason
      documentType
      explanation
    }
    receivedAt
    submissionDate
    requestedAmount {
      amount
      currency
    }
    awardedAmount {
      amount
      currency
    }
    claimDocuments {
      id
      fileUrl
      fileName
      description
      documentType
      updatedAtDate
    }
    bankDetails {
      id
      accountHolderName
      bankName
      accountNumber
      swiftCode
      accountType
      localFields
      country {
        code
        name
      }
    }
    isEditable
    activeRfi {
      accountId
      status
      expiresAt
      id
    }
    payoutFailure {
      failureAction
      failureDescription
    }
    remainingEditableSeconds
    treatmentName
    treatmentCadence
    treatmentAdditionalInfo
    claimant
  }
}
    `;

/**
 * __useReimbursementRequestQuery__
 *
 * To run a query within a React component, call `useReimbursementRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useReimbursementRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReimbursementRequestQuery({
 *   variables: {
 *      claimId: // value for 'claimId'
 *   },
 * });
 */
export function useReimbursementRequestQuery(baseOptions?: Apollo.QueryHookOptions<ReimbursementRequestQuery, ReimbursementRequestQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReimbursementRequestQuery, ReimbursementRequestQueryVariables>(ReimbursementRequestDocument, options);
      }
export function useReimbursementRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReimbursementRequestQuery, ReimbursementRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReimbursementRequestQuery, ReimbursementRequestQueryVariables>(ReimbursementRequestDocument, options);
        }
export type ReimbursementRequestQueryHookResult = ReturnType<typeof useReimbursementRequestQuery>;
export type ReimbursementRequestLazyQueryHookResult = ReturnType<typeof useReimbursementRequestLazyQuery>;
export type ReimbursementRequestQueryResult = Apollo.QueryResult<ReimbursementRequestQuery, ReimbursementRequestQueryVariables>;
export const SearchArticlesDocument = gql`
    query searchArticles($query: String!, $page: Int!, $perPage: Int!) {
  searchArticles(query: $query, page: $page, perPage: $perPage) {
    count
    numPages
    articles {
      slug
      title
      text
      excerpt
      squareThumbnailUrl
      featuredImageUrl
    }
  }
}
    `;

/**
 * __useSearchArticlesQuery__
 *
 * To run a query within a React component, call `useSearchArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArticlesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      page: // value for 'page'
 *      perPage: // value for 'perPage'
 *   },
 * });
 */
export function useSearchArticlesQuery(baseOptions: Apollo.QueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
      }
export function useSearchArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArticlesQuery, SearchArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArticlesQuery, SearchArticlesQueryVariables>(SearchArticlesDocument, options);
        }
export type SearchArticlesQueryHookResult = ReturnType<typeof useSearchArticlesQuery>;
export type SearchArticlesLazyQueryHookResult = ReturnType<typeof useSearchArticlesLazyQuery>;
export type SearchArticlesQueryResult = Apollo.QueryResult<SearchArticlesQuery, SearchArticlesQueryVariables>;
export const AirwallexAuthorizationDocument = gql`
    query airwallexAuthorization($scopes: [String]!) {
  airwallexAuthorization(scopes: $scopes) {
    authorizationCode
    clientId
    codeVerifier
  }
}
    `;

/**
 * __useAirwallexAuthorizationQuery__
 *
 * To run a query within a React component, call `useAirwallexAuthorizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirwallexAuthorizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirwallexAuthorizationQuery({
 *   variables: {
 *      scopes: // value for 'scopes'
 *   },
 * });
 */
export function useAirwallexAuthorizationQuery(baseOptions: Apollo.QueryHookOptions<AirwallexAuthorizationQuery, AirwallexAuthorizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirwallexAuthorizationQuery, AirwallexAuthorizationQueryVariables>(AirwallexAuthorizationDocument, options);
      }
export function useAirwallexAuthorizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirwallexAuthorizationQuery, AirwallexAuthorizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirwallexAuthorizationQuery, AirwallexAuthorizationQueryVariables>(AirwallexAuthorizationDocument, options);
        }
export type AirwallexAuthorizationQueryHookResult = ReturnType<typeof useAirwallexAuthorizationQuery>;
export type AirwallexAuthorizationLazyQueryHookResult = ReturnType<typeof useAirwallexAuthorizationLazyQuery>;
export type AirwallexAuthorizationQueryResult = Apollo.QueryResult<AirwallexAuthorizationQuery, AirwallexAuthorizationQueryVariables>;
export const AirwallexRfiHostedUrlDocument = gql`
    query airwallexRfiHostedUrl($rfiId: ID!) {
  airwallexRfiHostedUrl(rfiId: $rfiId)
}
    `;

/**
 * __useAirwallexRfiHostedUrlQuery__
 *
 * To run a query within a React component, call `useAirwallexRfiHostedUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useAirwallexRfiHostedUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAirwallexRfiHostedUrlQuery({
 *   variables: {
 *      rfiId: // value for 'rfiId'
 *   },
 * });
 */
export function useAirwallexRfiHostedUrlQuery(baseOptions: Apollo.QueryHookOptions<AirwallexRfiHostedUrlQuery, AirwallexRfiHostedUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AirwallexRfiHostedUrlQuery, AirwallexRfiHostedUrlQueryVariables>(AirwallexRfiHostedUrlDocument, options);
      }
export function useAirwallexRfiHostedUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AirwallexRfiHostedUrlQuery, AirwallexRfiHostedUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AirwallexRfiHostedUrlQuery, AirwallexRfiHostedUrlQueryVariables>(AirwallexRfiHostedUrlDocument, options);
        }
export type AirwallexRfiHostedUrlQueryHookResult = ReturnType<typeof useAirwallexRfiHostedUrlQuery>;
export type AirwallexRfiHostedUrlLazyQueryHookResult = ReturnType<typeof useAirwallexRfiHostedUrlLazyQuery>;
export type AirwallexRfiHostedUrlQueryResult = Apollo.QueryResult<AirwallexRfiHostedUrlQuery, AirwallexRfiHostedUrlQueryVariables>;
export const ArticleCategoryDetailDocument = gql`
    query articleCategoryDetail($slug: String!, $preview: String) {
  articleCategories(slug: $slug, preview: $preview) {
    name
    slug
    subtitle
    description
    imageUrl
    articles {
      slug
      title
      squareThumbnailUrl
      rectangleThumbnailUrl
      featuredImageUrl
      excerpt
      text
      isFeatured
    }
  }
}
    `;

/**
 * __useArticleCategoryDetailQuery__
 *
 * To run a query within a React component, call `useArticleCategoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleCategoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleCategoryDetailQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useArticleCategoryDetailQuery(baseOptions: Apollo.QueryHookOptions<ArticleCategoryDetailQuery, ArticleCategoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleCategoryDetailQuery, ArticleCategoryDetailQueryVariables>(ArticleCategoryDetailDocument, options);
      }
export function useArticleCategoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleCategoryDetailQuery, ArticleCategoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleCategoryDetailQuery, ArticleCategoryDetailQueryVariables>(ArticleCategoryDetailDocument, options);
        }
export type ArticleCategoryDetailQueryHookResult = ReturnType<typeof useArticleCategoryDetailQuery>;
export type ArticleCategoryDetailLazyQueryHookResult = ReturnType<typeof useArticleCategoryDetailLazyQuery>;
export type ArticleCategoryDetailQueryResult = Apollo.QueryResult<ArticleCategoryDetailQuery, ArticleCategoryDetailQueryVariables>;
export const ArticleDetailsDocument = gql`
    query articleDetails($slug: String!, $preview: String) {
  articles(slug: $slug, preview: $preview) {
    slug
    title
    text
    headerImageUrl
    relatedArticles {
      slug
      title
      squareThumbnailUrl
    }
    relatedCategories {
      slug
      name
      imageUrl
    }
    isFeatured
  }
}
    `;

/**
 * __useArticleDetailsQuery__
 *
 * To run a query within a React component, call `useArticleDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useArticleDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArticleDetailsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useArticleDetailsQuery(baseOptions: Apollo.QueryHookOptions<ArticleDetailsQuery, ArticleDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArticleDetailsQuery, ArticleDetailsQueryVariables>(ArticleDetailsDocument, options);
      }
export function useArticleDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArticleDetailsQuery, ArticleDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArticleDetailsQuery, ArticleDetailsQueryVariables>(ArticleDetailsDocument, options);
        }
export type ArticleDetailsQueryHookResult = ReturnType<typeof useArticleDetailsQuery>;
export type ArticleDetailsLazyQueryHookResult = ReturnType<typeof useArticleDetailsLazyQuery>;
export type ArticleDetailsQueryResult = Apollo.QueryResult<ArticleDetailsQuery, ArticleDetailsQueryVariables>;
export const AvailableCountriesDocument = gql`
    query availableCountries {
  coverage {
    countries {
      countryCode
      countryName
    }
  }
}
    `;

/**
 * __useAvailableCountriesQuery__
 *
 * To run a query within a React component, call `useAvailableCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAvailableCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAvailableCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAvailableCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AvailableCountriesQuery, AvailableCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AvailableCountriesQuery, AvailableCountriesQueryVariables>(AvailableCountriesDocument, options);
      }
export function useAvailableCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AvailableCountriesQuery, AvailableCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AvailableCountriesQuery, AvailableCountriesQueryVariables>(AvailableCountriesDocument, options);
        }
export type AvailableCountriesQueryHookResult = ReturnType<typeof useAvailableCountriesQuery>;
export type AvailableCountriesLazyQueryHookResult = ReturnType<typeof useAvailableCountriesLazyQuery>;
export type AvailableCountriesQueryResult = Apollo.QueryResult<AvailableCountriesQuery, AvailableCountriesQueryVariables>;
export const BudgetBarsDocument = gql`
    query BudgetBars {
  me {
    member {
      budgetProgressBar {
        green {
          amount
          currency
        }
        white {
          amount
          currency
        }
        yellow {
          amount
          currency
        }
      }
    }
  }
}
    `;

/**
 * __useBudgetBarsQuery__
 *
 * To run a query within a React component, call `useBudgetBarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetBarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetBarsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetBarsQuery(baseOptions?: Apollo.QueryHookOptions<BudgetBarsQuery, BudgetBarsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BudgetBarsQuery, BudgetBarsQueryVariables>(BudgetBarsDocument, options);
      }
export function useBudgetBarsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetBarsQuery, BudgetBarsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BudgetBarsQuery, BudgetBarsQueryVariables>(BudgetBarsDocument, options);
        }
export type BudgetBarsQueryHookResult = ReturnType<typeof useBudgetBarsQuery>;
export type BudgetBarsLazyQueryHookResult = ReturnType<typeof useBudgetBarsLazyQuery>;
export type BudgetBarsQueryResult = Apollo.QueryResult<BudgetBarsQuery, BudgetBarsQueryVariables>;
export const BudgetCountriesCoverageDocument = gql`
    query budgetCountriesCoverage($countryCode: String) {
  coverage {
    countries(countryCode: $countryCode) {
      countryCode
      countryName
      treatments {
        displayName
        id
        isCovered
        isLegal
        subtreatments {
          displayName
          id
          isLegal
        }
      }
    }
  }
}
    `;

/**
 * __useBudgetCountriesCoverageQuery__
 *
 * To run a query within a React component, call `useBudgetCountriesCoverageQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetCountriesCoverageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetCountriesCoverageQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useBudgetCountriesCoverageQuery(baseOptions?: Apollo.QueryHookOptions<BudgetCountriesCoverageQuery, BudgetCountriesCoverageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BudgetCountriesCoverageQuery, BudgetCountriesCoverageQueryVariables>(BudgetCountriesCoverageDocument, options);
      }
export function useBudgetCountriesCoverageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetCountriesCoverageQuery, BudgetCountriesCoverageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BudgetCountriesCoverageQuery, BudgetCountriesCoverageQueryVariables>(BudgetCountriesCoverageDocument, options);
        }
export type BudgetCountriesCoverageQueryHookResult = ReturnType<typeof useBudgetCountriesCoverageQuery>;
export type BudgetCountriesCoverageLazyQueryHookResult = ReturnType<typeof useBudgetCountriesCoverageLazyQuery>;
export type BudgetCountriesCoverageQueryResult = Apollo.QueryResult<BudgetCountriesCoverageQuery, BudgetCountriesCoverageQueryVariables>;
export const BudgetCoverageSettingsDocument = gql`
    query budgetCoverageSettings {
  coverage {
    settings {
      displayName
      slug
      value
    }
  }
}
    `;

/**
 * __useBudgetCoverageSettingsQuery__
 *
 * To run a query within a React component, call `useBudgetCoverageSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetCoverageSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetCoverageSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBudgetCoverageSettingsQuery(baseOptions?: Apollo.QueryHookOptions<BudgetCoverageSettingsQuery, BudgetCoverageSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BudgetCoverageSettingsQuery, BudgetCoverageSettingsQueryVariables>(BudgetCoverageSettingsDocument, options);
      }
export function useBudgetCoverageSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BudgetCoverageSettingsQuery, BudgetCoverageSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BudgetCoverageSettingsQuery, BudgetCoverageSettingsQueryVariables>(BudgetCoverageSettingsDocument, options);
        }
export type BudgetCoverageSettingsQueryHookResult = ReturnType<typeof useBudgetCoverageSettingsQuery>;
export type BudgetCoverageSettingsLazyQueryHookResult = ReturnType<typeof useBudgetCoverageSettingsLazyQuery>;
export type BudgetCoverageSettingsQueryResult = Apollo.QueryResult<BudgetCoverageSettingsQuery, BudgetCoverageSettingsQueryVariables>;
export const ClaimDocumentTypesDocument = gql`
    query ClaimDocumentTypes {
  claimDocumentTypes {
    id
    typeName
    dropdownOrder
  }
}
    `;

/**
 * __useClaimDocumentTypesQuery__
 *
 * To run a query within a React component, call `useClaimDocumentTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimDocumentTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimDocumentTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClaimDocumentTypesQuery(baseOptions?: Apollo.QueryHookOptions<ClaimDocumentTypesQuery, ClaimDocumentTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClaimDocumentTypesQuery, ClaimDocumentTypesQueryVariables>(ClaimDocumentTypesDocument, options);
      }
export function useClaimDocumentTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClaimDocumentTypesQuery, ClaimDocumentTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClaimDocumentTypesQuery, ClaimDocumentTypesQueryVariables>(ClaimDocumentTypesDocument, options);
        }
export type ClaimDocumentTypesQueryHookResult = ReturnType<typeof useClaimDocumentTypesQuery>;
export type ClaimDocumentTypesLazyQueryHookResult = ReturnType<typeof useClaimDocumentTypesLazyQuery>;
export type ClaimDocumentTypesQueryResult = Apollo.QueryResult<ClaimDocumentTypesQuery, ClaimDocumentTypesQueryVariables>;
export const ClaimTreatmentsDocument = gql`
    query claimTreatments {
  claimTreatments {
    value
    label
    requiresCycle
    requiresRound
    requiresAdditionalInfo
    isCovered
  }
}
    `;

/**
 * __useClaimTreatmentsQuery__
 *
 * To run a query within a React component, call `useClaimTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClaimTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClaimTreatmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useClaimTreatmentsQuery(baseOptions?: Apollo.QueryHookOptions<ClaimTreatmentsQuery, ClaimTreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClaimTreatmentsQuery, ClaimTreatmentsQueryVariables>(ClaimTreatmentsDocument, options);
      }
export function useClaimTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClaimTreatmentsQuery, ClaimTreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClaimTreatmentsQuery, ClaimTreatmentsQueryVariables>(ClaimTreatmentsDocument, options);
        }
export type ClaimTreatmentsQueryHookResult = ReturnType<typeof useClaimTreatmentsQuery>;
export type ClaimTreatmentsLazyQueryHookResult = ReturnType<typeof useClaimTreatmentsLazyQuery>;
export type ClaimTreatmentsQueryResult = Apollo.QueryResult<ClaimTreatmentsQuery, ClaimTreatmentsQueryVariables>;
export const ClinicAreasDocument = gql`
    query clinicAreas($country: String!, $treatments: [String]) {
  clinicAreas(country: $country, treatments: $treatments) {
    area
    count
    subareas {
      area
      count
    }
  }
}
    `;

/**
 * __useClinicAreasQuery__
 *
 * To run a query within a React component, call `useClinicAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicAreasQuery({
 *   variables: {
 *      country: // value for 'country'
 *      treatments: // value for 'treatments'
 *   },
 * });
 */
export function useClinicAreasQuery(baseOptions: Apollo.QueryHookOptions<ClinicAreasQuery, ClinicAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicAreasQuery, ClinicAreasQueryVariables>(ClinicAreasDocument, options);
      }
export function useClinicAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicAreasQuery, ClinicAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicAreasQuery, ClinicAreasQueryVariables>(ClinicAreasDocument, options);
        }
export type ClinicAreasQueryHookResult = ReturnType<typeof useClinicAreasQuery>;
export type ClinicAreasLazyQueryHookResult = ReturnType<typeof useClinicAreasLazyQuery>;
export type ClinicAreasQueryResult = Apollo.QueryResult<ClinicAreasQuery, ClinicAreasQueryVariables>;
export const ClinicCountriesDocument = gql`
    query clinicCountries {
  clinicCountries {
    code
    name
    province
  }
}
    `;

/**
 * __useClinicCountriesQuery__
 *
 * To run a query within a React component, call `useClinicCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useClinicCountriesQuery(baseOptions?: Apollo.QueryHookOptions<ClinicCountriesQuery, ClinicCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicCountriesQuery, ClinicCountriesQueryVariables>(ClinicCountriesDocument, options);
      }
export function useClinicCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicCountriesQuery, ClinicCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicCountriesQuery, ClinicCountriesQueryVariables>(ClinicCountriesDocument, options);
        }
export type ClinicCountriesQueryHookResult = ReturnType<typeof useClinicCountriesQuery>;
export type ClinicCountriesLazyQueryHookResult = ReturnType<typeof useClinicCountriesLazyQuery>;
export type ClinicCountriesQueryResult = Apollo.QueryResult<ClinicCountriesQuery, ClinicCountriesQueryVariables>;
export const ClinicsDocument = gql`
    query clinics($country: String, $treatments: [String], $specialty: String, $area: String, $city: String, $pageSize: Int = 5, $page: Int = 1, $isPartnerClinic: Boolean) {
  clinics(
    country: $country
    treatments: $treatments
    specialty: $specialty
    area: $area
    city: $city
    pageSize: $pageSize
    page: $page
    isPartnerClinic: $isPartnerClinic
  ) {
    pageInfo {
      hasNext
      hasPrevious
      total
      numPages
      previousPage
      nextPage
    }
    objects {
      id
      name
      address
      localName
      localAddress
      postalCode
      city
      phone
      website
      starRating
      medalRating
      gradeRating
      isPartnerClinic
      email
      partnerClinicDiscountText
      partnershipBenefits {
        id
        value
        name
      }
      treatments {
        id
        name
      }
      specialties {
        id
        name
      }
      socialMedia {
        service
        handle
      }
    }
  }
}
    `;

/**
 * __useClinicsQuery__
 *
 * To run a query within a React component, call `useClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClinicsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      treatments: // value for 'treatments'
 *      specialty: // value for 'specialty'
 *      area: // value for 'area'
 *      city: // value for 'city'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *      isPartnerClinic: // value for 'isPartnerClinic'
 *   },
 * });
 */
export function useClinicsQuery(baseOptions?: Apollo.QueryHookOptions<ClinicsQuery, ClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClinicsQuery, ClinicsQueryVariables>(ClinicsDocument, options);
      }
export function useClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClinicsQuery, ClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClinicsQuery, ClinicsQueryVariables>(ClinicsDocument, options);
        }
export type ClinicsQueryHookResult = ReturnType<typeof useClinicsQuery>;
export type ClinicsLazyQueryHookResult = ReturnType<typeof useClinicsLazyQuery>;
export type ClinicsQueryResult = Apollo.QueryResult<ClinicsQuery, ClinicsQueryVariables>;
export const CompanyBasicInfoDocument = gql`
    query companyBasicInfo {
  me {
    id
    company {
      id
      name
    }
  }
}
    `;

/**
 * __useCompanyBasicInfoQuery__
 *
 * To run a query within a React component, call `useCompanyBasicInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanyBasicInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanyBasicInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCompanyBasicInfoQuery(baseOptions?: Apollo.QueryHookOptions<CompanyBasicInfoQuery, CompanyBasicInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CompanyBasicInfoQuery, CompanyBasicInfoQueryVariables>(CompanyBasicInfoDocument, options);
      }
export function useCompanyBasicInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CompanyBasicInfoQuery, CompanyBasicInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CompanyBasicInfoQuery, CompanyBasicInfoQueryVariables>(CompanyBasicInfoDocument, options);
        }
export type CompanyBasicInfoQueryHookResult = ReturnType<typeof useCompanyBasicInfoQuery>;
export type CompanyBasicInfoLazyQueryHookResult = ReturnType<typeof useCompanyBasicInfoLazyQuery>;
export type CompanyBasicInfoQueryResult = Apollo.QueryResult<CompanyBasicInfoQuery, CompanyBasicInfoQueryVariables>;
export const FaqSectionsDocument = gql`
    query faqSections($preview: String) {
  faqSections(preview: $preview) {
    title
    entries {
      question
      answer
    }
  }
}
    `;

/**
 * __useFaqSectionsQuery__
 *
 * To run a query within a React component, call `useFaqSectionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFaqSectionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFaqSectionsQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useFaqSectionsQuery(baseOptions?: Apollo.QueryHookOptions<FaqSectionsQuery, FaqSectionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FaqSectionsQuery, FaqSectionsQueryVariables>(FaqSectionsDocument, options);
      }
export function useFaqSectionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FaqSectionsQuery, FaqSectionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FaqSectionsQuery, FaqSectionsQueryVariables>(FaqSectionsDocument, options);
        }
export type FaqSectionsQueryHookResult = ReturnType<typeof useFaqSectionsQuery>;
export type FaqSectionsLazyQueryHookResult = ReturnType<typeof useFaqSectionsLazyQuery>;
export type FaqSectionsQueryResult = Apollo.QueryResult<FaqSectionsQuery, FaqSectionsQueryVariables>;
export const FertilityClinicCitiesDocument = gql`
    query fertilityClinicCities($country: String!, $area: String) {
  clinicCities(country: $country, area: $area) {
    city
    count
  }
}
    `;

/**
 * __useFertilityClinicCitiesQuery__
 *
 * To run a query within a React component, call `useFertilityClinicCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFertilityClinicCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFertilityClinicCitiesQuery({
 *   variables: {
 *      country: // value for 'country'
 *      area: // value for 'area'
 *   },
 * });
 */
export function useFertilityClinicCitiesQuery(baseOptions: Apollo.QueryHookOptions<FertilityClinicCitiesQuery, FertilityClinicCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FertilityClinicCitiesQuery, FertilityClinicCitiesQueryVariables>(FertilityClinicCitiesDocument, options);
      }
export function useFertilityClinicCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FertilityClinicCitiesQuery, FertilityClinicCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FertilityClinicCitiesQuery, FertilityClinicCitiesQueryVariables>(FertilityClinicCitiesDocument, options);
        }
export type FertilityClinicCitiesQueryHookResult = ReturnType<typeof useFertilityClinicCitiesQuery>;
export type FertilityClinicCitiesLazyQueryHookResult = ReturnType<typeof useFertilityClinicCitiesLazyQuery>;
export type FertilityClinicCitiesQueryResult = Apollo.QueryResult<FertilityClinicCitiesQuery, FertilityClinicCitiesQueryVariables>;
export const FetchArticleCategoriesDocument = gql`
    query fetchArticleCategories($preview: String) {
  articleCategories(preview: $preview) {
    slug
    name
    subtitle
    description
    imageUrl
    recommendationImageUrl
    numArticles
  }
}
    `;

/**
 * __useFetchArticleCategoriesQuery__
 *
 * To run a query within a React component, call `useFetchArticleCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchArticleCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchArticleCategoriesQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useFetchArticleCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<FetchArticleCategoriesQuery, FetchArticleCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchArticleCategoriesQuery, FetchArticleCategoriesQueryVariables>(FetchArticleCategoriesDocument, options);
      }
export function useFetchArticleCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchArticleCategoriesQuery, FetchArticleCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchArticleCategoriesQuery, FetchArticleCategoriesQueryVariables>(FetchArticleCategoriesDocument, options);
        }
export type FetchArticleCategoriesQueryHookResult = ReturnType<typeof useFetchArticleCategoriesQuery>;
export type FetchArticleCategoriesLazyQueryHookResult = ReturnType<typeof useFetchArticleCategoriesLazyQuery>;
export type FetchArticleCategoriesQueryResult = Apollo.QueryResult<FetchArticleCategoriesQuery, FetchArticleCategoriesQueryVariables>;
export const GetBankFieldsSchemaDocument = gql`
    query getBankFieldsSchema($countryCode: String!) {
  bankFieldsSchema(countryCode: $countryCode) {
    countryCode
    fields {
      required
      name
      label
      helpText
    }
    swiftRequired
  }
}
    `;

/**
 * __useGetBankFieldsSchemaQuery__
 *
 * To run a query within a React component, call `useGetBankFieldsSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBankFieldsSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBankFieldsSchemaQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *   },
 * });
 */
export function useGetBankFieldsSchemaQuery(baseOptions: Apollo.QueryHookOptions<GetBankFieldsSchemaQuery, GetBankFieldsSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBankFieldsSchemaQuery, GetBankFieldsSchemaQueryVariables>(GetBankFieldsSchemaDocument, options);
      }
export function useGetBankFieldsSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBankFieldsSchemaQuery, GetBankFieldsSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBankFieldsSchemaQuery, GetBankFieldsSchemaQueryVariables>(GetBankFieldsSchemaDocument, options);
        }
export type GetBankFieldsSchemaQueryHookResult = ReturnType<typeof useGetBankFieldsSchemaQuery>;
export type GetBankFieldsSchemaLazyQueryHookResult = ReturnType<typeof useGetBankFieldsSchemaLazyQuery>;
export type GetBankFieldsSchemaQueryResult = Apollo.QueryResult<GetBankFieldsSchemaQuery, GetBankFieldsSchemaQueryVariables>;
export const GetBeneficiaryIdDocument = gql`
    query getBeneficiaryId {
  airwallexBeneficiary
  airwallexBeneficiaryId
}
    `;

/**
 * __useGetBeneficiaryIdQuery__
 *
 * To run a query within a React component, call `useGetBeneficiaryIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBeneficiaryIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBeneficiaryIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBeneficiaryIdQuery(baseOptions?: Apollo.QueryHookOptions<GetBeneficiaryIdQuery, GetBeneficiaryIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBeneficiaryIdQuery, GetBeneficiaryIdQueryVariables>(GetBeneficiaryIdDocument, options);
      }
export function useGetBeneficiaryIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBeneficiaryIdQuery, GetBeneficiaryIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBeneficiaryIdQuery, GetBeneficiaryIdQueryVariables>(GetBeneficiaryIdDocument, options);
        }
export type GetBeneficiaryIdQueryHookResult = ReturnType<typeof useGetBeneficiaryIdQuery>;
export type GetBeneficiaryIdLazyQueryHookResult = ReturnType<typeof useGetBeneficiaryIdLazyQuery>;
export type GetBeneficiaryIdQueryResult = Apollo.QueryResult<GetBeneficiaryIdQuery, GetBeneficiaryIdQueryVariables>;
export const GetLastSubmittedClaimDocument = gql`
    query getLastSubmittedClaim {
  openClaim {
    id
    isEditable
    remainingEditableSeconds
    claimant
    treatmentName
    treatmentCadence
    treatmentAdditionalInfo
    claimDocuments {
      id
      description
      fileName
      fileUrl
      documentType
      updatedAtDate
    }
  }
}
    `;

/**
 * __useGetLastSubmittedClaimQuery__
 *
 * To run a query within a React component, call `useGetLastSubmittedClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLastSubmittedClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLastSubmittedClaimQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLastSubmittedClaimQuery(baseOptions?: Apollo.QueryHookOptions<GetLastSubmittedClaimQuery, GetLastSubmittedClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLastSubmittedClaimQuery, GetLastSubmittedClaimQueryVariables>(GetLastSubmittedClaimDocument, options);
      }
export function useGetLastSubmittedClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLastSubmittedClaimQuery, GetLastSubmittedClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLastSubmittedClaimQuery, GetLastSubmittedClaimQueryVariables>(GetLastSubmittedClaimDocument, options);
        }
export type GetLastSubmittedClaimQueryHookResult = ReturnType<typeof useGetLastSubmittedClaimQuery>;
export type GetLastSubmittedClaimLazyQueryHookResult = ReturnType<typeof useGetLastSubmittedClaimLazyQuery>;
export type GetLastSubmittedClaimQueryResult = Apollo.QueryResult<GetLastSubmittedClaimQuery, GetLastSubmittedClaimQueryVariables>;
export const AllCountriesDocument = gql`
    query allCountries {
  allCountries {
    code
    name
  }
}
    `;

/**
 * __useAllCountriesQuery__
 *
 * To run a query within a React component, call `useAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCountriesQuery(baseOptions?: Apollo.QueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
      }
export function useAllCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCountriesQuery, AllCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCountriesQuery, AllCountriesQueryVariables>(AllCountriesDocument, options);
        }
export type AllCountriesQueryHookResult = ReturnType<typeof useAllCountriesQuery>;
export type AllCountriesLazyQueryHookResult = ReturnType<typeof useAllCountriesLazyQuery>;
export type AllCountriesQueryResult = Apollo.QueryResult<AllCountriesQuery, AllCountriesQueryVariables>;
export const MarketplaceOffersDocument = gql`
    query marketplaceOffers($preview: String) {
  marketplaceOffers(preview: $preview) {
    partnerName
    slug
    title
    imageUrl
    description
    whatIsIncluded
    discount
    discountCode
    discountCodeByline
    url
    infoForAspiringMembers
    infoForMembers
    infoForPartners
    isReimbursable
  }
}
    `;

/**
 * __useMarketplaceOffersQuery__
 *
 * To run a query within a React component, call `useMarketplaceOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMarketplaceOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMarketplaceOffersQuery({
 *   variables: {
 *      preview: // value for 'preview'
 *   },
 * });
 */
export function useMarketplaceOffersQuery(baseOptions?: Apollo.QueryHookOptions<MarketplaceOffersQuery, MarketplaceOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MarketplaceOffersQuery, MarketplaceOffersQueryVariables>(MarketplaceOffersDocument, options);
      }
export function useMarketplaceOffersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MarketplaceOffersQuery, MarketplaceOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MarketplaceOffersQuery, MarketplaceOffersQueryVariables>(MarketplaceOffersDocument, options);
        }
export type MarketplaceOffersQueryHookResult = ReturnType<typeof useMarketplaceOffersQuery>;
export type MarketplaceOffersLazyQueryHookResult = ReturnType<typeof useMarketplaceOffersLazyQuery>;
export type MarketplaceOffersQueryResult = Apollo.QueryResult<MarketplaceOffersQuery, MarketplaceOffersQueryVariables>;
export const MeDocument = gql`
    query me {
  languages {
    code
    name
  }
  me {
    id
    hygraphAuthToken
    company {
      id
      name
      isTestCompany
    }
    email
    journeyCommunicationEmail
    employeeNumber
    firstName
    isEmailConfirmed
    isManager
    lastName
    member {
      id
      identityDocumentUrl
      identityDocumentFileName
      identityDocumentType
      acceptedPrivacyStatement
      partnerConsentStatus
      showPartnerConsentNotification
      showRedesignNotification
      showNewClaimsFlowNotification
      incidentId
      acceptedTermsConditions
      birthAssignedSex
      highlightLanguages
      birthDate
      contractType
      city
      bankAccountDetails {
        id
        accountHolderName
        bankName
        country {
          code
          name
        }
        localFields
        accountType
        accountNumber
        swiftCode
      }
      partnerDetails {
        firstName
        lastName
        email
        birthDate
        sameHousehold
        sameEmployer
        employeeNumber
        docType
        identityDocumentUrl
        fileName
        address {
          streetAddress
          city
          postcode
          country {
            code
            name
            currency {
              code
              name
            }
          }
        }
      }
      contract {
        id
        aspiringPeriodDescription
        reimbursementMode
        enableWallets
        budgetPerMember {
          amount
          currency
        }
        countryCode
        hasBudget
      }
      countryOfEmployment {
        id
        country {
          code
        }
      }
      currentBudget {
        amount
        currency
      }
      carryoverBudget {
        amount
        currency
      }
      eligibilityStart
      familyFormingJourney
      genderIdentity
      hadFirstConsultation
      hasStartedLegacyOnboarding
      hasReimbursementRequests
      isAspiring
      isEligible
      isSsoLogin
      isSubscriptionMember
      language
      newPrivateEmail
      preferredGivenName
      phoneNumber
      preferredSurname
      privateAddress {
        id
        city
        country {
          code
          name
        }
        postcode
        streetAddress
      }
      provinceOfResidency
      privateEmail
      privateEmailChangePending
      privateEmailConfirmed
      pronouns
      relationshipDynamic
      subscriptions {
        endDate
        startDate
      }
      timezone
      wallet {
        id
        status
        allocatedAmount {
          amount
          currency
        }
        availableAmount {
          amount
          currency
        }
        spentAmount {
          amount
          currency
        }
        currentCard {
          id
          expiryDate
          maskedCardNumber
          status
        }
        canBeUnfrozen
        treatmentPlans {
          fileName
          fileUrl
          id
          fileSize
          fileContentType
          createdAt
          amount {
            amount
            currency
          }
          updatedAt
          status {
            value
            label
          }
          comment
        }
        transactions {
          id
          pliantId
          type
          authorizedAt
          merchantName
          status
          reconciliationStatus {
            label
            value
          }
          refundedAmount {
            amount
            currency
          }
          billingAmount {
            amount
            currency
          }
          transactionAmount {
            amount
            currency
          }
          coveredTransactionAmount {
            amount
            currency
          }
          foreignExchangeFee {
            amount
            currency
          }
          uploads {
            fileContentType
            fileName
            fileSize
            fileUrl
            id
          }
          comment
          reuploadRequest {
            id
            comment
            createdAt
          }
        }
      }
      menopauseJourney {
        lastMenstrualPeriod
        menopauseSymptoms
        menstrualPeriodStatus
        otherSymptomsDescription
      }
      pregnancyPostpartumJourney {
        pregnancyPostpartumStatus
        dueDate
        deliveryDate
      }
      availableProductLines
      activeMemberJourney
      previouslySelectedJourneys
      hasOpenClaims
      isMedicallyNecessaryRelevant
    }
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const MenopausePerCountryDocument = gql`
    query menopausePerCountry($countryCode: String!, $province: String) {
  menopause {
    menopauseInCountry(countryCode: $countryCode, province: $province) {
      countryCode
      countryName
      province
      clinicsAvailable
      coverageForHrt
    }
  }
}
    `;

/**
 * __useMenopausePerCountryQuery__
 *
 * To run a query within a React component, call `useMenopausePerCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopausePerCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopausePerCountryQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      province: // value for 'province'
 *   },
 * });
 */
export function useMenopausePerCountryQuery(baseOptions: Apollo.QueryHookOptions<MenopausePerCountryQuery, MenopausePerCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopausePerCountryQuery, MenopausePerCountryQueryVariables>(MenopausePerCountryDocument, options);
      }
export function useMenopausePerCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopausePerCountryQuery, MenopausePerCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopausePerCountryQuery, MenopausePerCountryQueryVariables>(MenopausePerCountryDocument, options);
        }
export type MenopausePerCountryQueryHookResult = ReturnType<typeof useMenopausePerCountryQuery>;
export type MenopausePerCountryLazyQueryHookResult = ReturnType<typeof useMenopausePerCountryLazyQuery>;
export type MenopausePerCountryQueryResult = Apollo.QueryResult<MenopausePerCountryQuery, MenopausePerCountryQueryVariables>;
export const MenopauseClinicAreasDocument = gql`
    query menopauseClinicAreas($country: String!) {
  menopause {
    clinicAreas(country: $country) {
      area
      count
    }
  }
}
    `;

/**
 * __useMenopauseClinicAreasQuery__
 *
 * To run a query within a React component, call `useMenopauseClinicAreasQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopauseClinicAreasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopauseClinicAreasQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useMenopauseClinicAreasQuery(baseOptions: Apollo.QueryHookOptions<MenopauseClinicAreasQuery, MenopauseClinicAreasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopauseClinicAreasQuery, MenopauseClinicAreasQueryVariables>(MenopauseClinicAreasDocument, options);
      }
export function useMenopauseClinicAreasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopauseClinicAreasQuery, MenopauseClinicAreasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopauseClinicAreasQuery, MenopauseClinicAreasQueryVariables>(MenopauseClinicAreasDocument, options);
        }
export type MenopauseClinicAreasQueryHookResult = ReturnType<typeof useMenopauseClinicAreasQuery>;
export type MenopauseClinicAreasLazyQueryHookResult = ReturnType<typeof useMenopauseClinicAreasLazyQuery>;
export type MenopauseClinicAreasQueryResult = Apollo.QueryResult<MenopauseClinicAreasQuery, MenopauseClinicAreasQueryVariables>;
export const MenopauseClinicCitiesDocument = gql`
    query menopauseClinicCities($country: String!, $area: String) {
  menopause {
    clinicCities(country: $country, area: $area) {
      city
      count
    }
  }
}
    `;

/**
 * __useMenopauseClinicCitiesQuery__
 *
 * To run a query within a React component, call `useMenopauseClinicCitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopauseClinicCitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopauseClinicCitiesQuery({
 *   variables: {
 *      country: // value for 'country'
 *      area: // value for 'area'
 *   },
 * });
 */
export function useMenopauseClinicCitiesQuery(baseOptions: Apollo.QueryHookOptions<MenopauseClinicCitiesQuery, MenopauseClinicCitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopauseClinicCitiesQuery, MenopauseClinicCitiesQueryVariables>(MenopauseClinicCitiesDocument, options);
      }
export function useMenopauseClinicCitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopauseClinicCitiesQuery, MenopauseClinicCitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopauseClinicCitiesQuery, MenopauseClinicCitiesQueryVariables>(MenopauseClinicCitiesDocument, options);
        }
export type MenopauseClinicCitiesQueryHookResult = ReturnType<typeof useMenopauseClinicCitiesQuery>;
export type MenopauseClinicCitiesLazyQueryHookResult = ReturnType<typeof useMenopauseClinicCitiesLazyQuery>;
export type MenopauseClinicCitiesQueryResult = Apollo.QueryResult<MenopauseClinicCitiesQuery, MenopauseClinicCitiesQueryVariables>;
export const MenopauseClinicCountriesDocument = gql`
    query menopauseClinicCountries {
  menopause {
    clinicCountries {
      name
      code
    }
  }
}
    `;

/**
 * __useMenopauseClinicCountriesQuery__
 *
 * To run a query within a React component, call `useMenopauseClinicCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopauseClinicCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopauseClinicCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenopauseClinicCountriesQuery(baseOptions?: Apollo.QueryHookOptions<MenopauseClinicCountriesQuery, MenopauseClinicCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopauseClinicCountriesQuery, MenopauseClinicCountriesQueryVariables>(MenopauseClinicCountriesDocument, options);
      }
export function useMenopauseClinicCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopauseClinicCountriesQuery, MenopauseClinicCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopauseClinicCountriesQuery, MenopauseClinicCountriesQueryVariables>(MenopauseClinicCountriesDocument, options);
        }
export type MenopauseClinicCountriesQueryHookResult = ReturnType<typeof useMenopauseClinicCountriesQuery>;
export type MenopauseClinicCountriesLazyQueryHookResult = ReturnType<typeof useMenopauseClinicCountriesLazyQuery>;
export type MenopauseClinicCountriesQueryResult = Apollo.QueryResult<MenopauseClinicCountriesQuery, MenopauseClinicCountriesQueryVariables>;
export const MenopauseClinicsDocument = gql`
    query menopauseClinics($country: String!, $area: String, $city: String, $pageSize: Int, $page: Int) {
  menopause {
    menopauseClinics(
      country: $country
      area: $area
      city: $city
      pageSize: $pageSize
      page: $page
    ) {
      objects {
        name
        city
        area
        address
        email
        id
        phone
        postalCode
        website
      }
      pageInfo {
        total
        nextPage
        hasNext
        hasPrevious
        numPages
        previousPage
      }
    }
  }
}
    `;

/**
 * __useMenopauseClinicsQuery__
 *
 * To run a query within a React component, call `useMenopauseClinicsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopauseClinicsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopauseClinicsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      area: // value for 'area'
 *      city: // value for 'city'
 *      pageSize: // value for 'pageSize'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMenopauseClinicsQuery(baseOptions: Apollo.QueryHookOptions<MenopauseClinicsQuery, MenopauseClinicsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopauseClinicsQuery, MenopauseClinicsQueryVariables>(MenopauseClinicsDocument, options);
      }
export function useMenopauseClinicsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopauseClinicsQuery, MenopauseClinicsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopauseClinicsQuery, MenopauseClinicsQueryVariables>(MenopauseClinicsDocument, options);
        }
export type MenopauseClinicsQueryHookResult = ReturnType<typeof useMenopauseClinicsQuery>;
export type MenopauseClinicsLazyQueryHookResult = ReturnType<typeof useMenopauseClinicsLazyQuery>;
export type MenopauseClinicsQueryResult = Apollo.QueryResult<MenopauseClinicsQuery, MenopauseClinicsQueryVariables>;
export const MenopauseCountriesDocument = gql`
    query menopauseCountries {
  menopause {
    countries {
      province
      name
      code
    }
  }
}
    `;

/**
 * __useMenopauseCountriesQuery__
 *
 * To run a query within a React component, call `useMenopauseCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMenopauseCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMenopauseCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMenopauseCountriesQuery(baseOptions?: Apollo.QueryHookOptions<MenopauseCountriesQuery, MenopauseCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MenopauseCountriesQuery, MenopauseCountriesQueryVariables>(MenopauseCountriesDocument, options);
      }
export function useMenopauseCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MenopauseCountriesQuery, MenopauseCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MenopauseCountriesQuery, MenopauseCountriesQueryVariables>(MenopauseCountriesDocument, options);
        }
export type MenopauseCountriesQueryHookResult = ReturnType<typeof useMenopauseCountriesQuery>;
export type MenopauseCountriesLazyQueryHookResult = ReturnType<typeof useMenopauseCountriesLazyQuery>;
export type MenopauseCountriesQueryResult = Apollo.QueryResult<MenopauseCountriesQuery, MenopauseCountriesQueryVariables>;
export const PregnancyCountriesDocument = gql`
    query pregnancyCountries {
  pregnancyPostpartum {
    countries {
      province
      name
      code
    }
  }
}
    `;

/**
 * __usePregnancyCountriesQuery__
 *
 * To run a query within a React component, call `usePregnancyCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePregnancyCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePregnancyCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePregnancyCountriesQuery(baseOptions?: Apollo.QueryHookOptions<PregnancyCountriesQuery, PregnancyCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PregnancyCountriesQuery, PregnancyCountriesQueryVariables>(PregnancyCountriesDocument, options);
      }
export function usePregnancyCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PregnancyCountriesQuery, PregnancyCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PregnancyCountriesQuery, PregnancyCountriesQueryVariables>(PregnancyCountriesDocument, options);
        }
export type PregnancyCountriesQueryHookResult = ReturnType<typeof usePregnancyCountriesQuery>;
export type PregnancyCountriesLazyQueryHookResult = ReturnType<typeof usePregnancyCountriesLazyQuery>;
export type PregnancyCountriesQueryResult = Apollo.QueryResult<PregnancyCountriesQuery, PregnancyCountriesQueryVariables>;
export const PregnancyNavigatorDocument = gql`
    query pregnancyNavigator($countryCode: String!, $province: String) {
  pregnancyPostpartum {
    pregnancyPostpartumInCountry(countryCode: $countryCode, province: $province) {
      maternityLeaveDuration
      maternityLeavePayee
      parentalLeaveDuration
      paternityLeaveDuration
      paternityLeavePayee
      jobSecurity
    }
  }
}
    `;

/**
 * __usePregnancyNavigatorQuery__
 *
 * To run a query within a React component, call `usePregnancyNavigatorQuery` and pass it any options that fit your needs.
 * When your component renders, `usePregnancyNavigatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePregnancyNavigatorQuery({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      province: // value for 'province'
 *   },
 * });
 */
export function usePregnancyNavigatorQuery(baseOptions: Apollo.QueryHookOptions<PregnancyNavigatorQuery, PregnancyNavigatorQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PregnancyNavigatorQuery, PregnancyNavigatorQueryVariables>(PregnancyNavigatorDocument, options);
      }
export function usePregnancyNavigatorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PregnancyNavigatorQuery, PregnancyNavigatorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PregnancyNavigatorQuery, PregnancyNavigatorQueryVariables>(PregnancyNavigatorDocument, options);
        }
export type PregnancyNavigatorQueryHookResult = ReturnType<typeof usePregnancyNavigatorQuery>;
export type PregnancyNavigatorLazyQueryHookResult = ReturnType<typeof usePregnancyNavigatorLazyQuery>;
export type PregnancyNavigatorQueryResult = Apollo.QueryResult<PregnancyNavigatorQuery, PregnancyNavigatorQueryVariables>;
export const ProductConfigDocument = gql`
    query productConfig {
  productConfig {
    dataType
    id
    slug
    value
  }
}
    `;

/**
 * __useProductConfigQuery__
 *
 * To run a query within a React component, call `useProductConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductConfigQuery(baseOptions?: Apollo.QueryHookOptions<ProductConfigQuery, ProductConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductConfigQuery, ProductConfigQueryVariables>(ProductConfigDocument, options);
      }
export function useProductConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductConfigQuery, ProductConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductConfigQuery, ProductConfigQueryVariables>(ProductConfigDocument, options);
        }
export type ProductConfigQueryHookResult = ReturnType<typeof useProductConfigQuery>;
export type ProductConfigLazyQueryHookResult = ReturnType<typeof useProductConfigLazyQuery>;
export type ProductConfigQueryResult = Apollo.QueryResult<ProductConfigQuery, ProductConfigQueryVariables>;
export const PronounsDocument = gql`
    query pronouns {
  pronouns {
    label
    value
  }
}
    `;

/**
 * __usePronounsQuery__
 *
 * To run a query within a React component, call `usePronounsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePronounsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePronounsQuery({
 *   variables: {
 *   },
 * });
 */
export function usePronounsQuery(baseOptions?: Apollo.QueryHookOptions<PronounsQuery, PronounsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PronounsQuery, PronounsQueryVariables>(PronounsDocument, options);
      }
export function usePronounsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PronounsQuery, PronounsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PronounsQuery, PronounsQueryVariables>(PronounsDocument, options);
        }
export type PronounsQueryHookResult = ReturnType<typeof usePronounsQuery>;
export type PronounsLazyQueryHookResult = ReturnType<typeof usePronounsLazyQuery>;
export type PronounsQueryResult = Apollo.QueryResult<PronounsQuery, PronounsQueryVariables>;
export const RatingSpecDocument = gql`
    query ratingSpec($country: String) {
  ratingSpec(country: $country) {
    name
    type
    link
    maxStars
  }
}
    `;

/**
 * __useRatingSpecQuery__
 *
 * To run a query within a React component, call `useRatingSpecQuery` and pass it any options that fit your needs.
 * When your component renders, `useRatingSpecQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRatingSpecQuery({
 *   variables: {
 *      country: // value for 'country'
 *   },
 * });
 */
export function useRatingSpecQuery(baseOptions?: Apollo.QueryHookOptions<RatingSpecQuery, RatingSpecQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RatingSpecQuery, RatingSpecQueryVariables>(RatingSpecDocument, options);
      }
export function useRatingSpecLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RatingSpecQuery, RatingSpecQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RatingSpecQuery, RatingSpecQueryVariables>(RatingSpecDocument, options);
        }
export type RatingSpecQueryHookResult = ReturnType<typeof useRatingSpecQuery>;
export type RatingSpecLazyQueryHookResult = ReturnType<typeof useRatingSpecLazyQuery>;
export type RatingSpecQueryResult = Apollo.QueryResult<RatingSpecQuery, RatingSpecQueryVariables>;
export const RecommendedArticlesDocument = gql`
    query recommendedArticles {
  recommendedArticles {
    article {
      slug
      title
      rectangleThumbnailUrl
    }
    category {
      slug
      name
      recommendationImageUrl
    }
  }
}
    `;

/**
 * __useRecommendedArticlesQuery__
 *
 * To run a query within a React component, call `useRecommendedArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecommendedArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecommendedArticlesQuery({
 *   variables: {
 *   },
 * });
 */
export function useRecommendedArticlesQuery(baseOptions?: Apollo.QueryHookOptions<RecommendedArticlesQuery, RecommendedArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecommendedArticlesQuery, RecommendedArticlesQueryVariables>(RecommendedArticlesDocument, options);
      }
export function useRecommendedArticlesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecommendedArticlesQuery, RecommendedArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecommendedArticlesQuery, RecommendedArticlesQueryVariables>(RecommendedArticlesDocument, options);
        }
export type RecommendedArticlesQueryHookResult = ReturnType<typeof useRecommendedArticlesQuery>;
export type RecommendedArticlesLazyQueryHookResult = ReturnType<typeof useRecommendedArticlesLazyQuery>;
export type RecommendedArticlesQueryResult = Apollo.QueryResult<RecommendedArticlesQuery, RecommendedArticlesQueryVariables>;
export const ReimbursementHistoryDocument = gql`
    query reimbursementHistory($page: Int = 1, $pageSize: Int = 5) {
  reimbursementHistory(page: $page, pageSize: $pageSize) {
    pageInfo {
      total
      numPages
      nextPage
      previousPage
      hasNext
      hasPrevious
    }
    objects {
      id
      files
      status
      stage
      remainingEditableSeconds
      isEditable
      documents {
        id
        reference
        documentType
        invoiceAmount {
          amount
          currency
        }
      }
      requestedDocuments {
        id
        notProvidedReason
        documentType
        explanation
      }
      receivedAt
      submissionDate
      requestedAmount {
        amount
        currency
      }
      awardedAmount {
        amount
        currency
      }
      claimDocuments {
        id
        fileUrl
        fileName
        description
        documentType
        updatedAtDate
      }
      treatmentName
      treatmentCadence
      treatmentAdditionalInfo
      claimant
    }
  }
}
    `;

/**
 * __useReimbursementHistoryQuery__
 *
 * To run a query within a React component, call `useReimbursementHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useReimbursementHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReimbursementHistoryQuery({
 *   variables: {
 *      page: // value for 'page'
 *      pageSize: // value for 'pageSize'
 *   },
 * });
 */
export function useReimbursementHistoryQuery(baseOptions?: Apollo.QueryHookOptions<ReimbursementHistoryQuery, ReimbursementHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReimbursementHistoryQuery, ReimbursementHistoryQueryVariables>(ReimbursementHistoryDocument, options);
      }
export function useReimbursementHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReimbursementHistoryQuery, ReimbursementHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReimbursementHistoryQuery, ReimbursementHistoryQueryVariables>(ReimbursementHistoryDocument, options);
        }
export type ReimbursementHistoryQueryHookResult = ReturnType<typeof useReimbursementHistoryQuery>;
export type ReimbursementHistoryLazyQueryHookResult = ReturnType<typeof useReimbursementHistoryLazyQuery>;
export type ReimbursementHistoryQueryResult = Apollo.QueryResult<ReimbursementHistoryQuery, ReimbursementHistoryQueryVariables>;
export const SpecialtiesDocument = gql`
    query specialties($country: String, $area: String, $treatments: [String]) {
  specialties(country: $country, area: $area, treatments: $treatments) {
    specialty
    count
  }
}
    `;

/**
 * __useSpecialtiesQuery__
 *
 * To run a query within a React component, call `useSpecialtiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecialtiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecialtiesQuery({
 *   variables: {
 *      country: // value for 'country'
 *      area: // value for 'area'
 *      treatments: // value for 'treatments'
 *   },
 * });
 */
export function useSpecialtiesQuery(baseOptions?: Apollo.QueryHookOptions<SpecialtiesQuery, SpecialtiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecialtiesQuery, SpecialtiesQueryVariables>(SpecialtiesDocument, options);
      }
export function useSpecialtiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecialtiesQuery, SpecialtiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecialtiesQuery, SpecialtiesQueryVariables>(SpecialtiesDocument, options);
        }
export type SpecialtiesQueryHookResult = ReturnType<typeof useSpecialtiesQuery>;
export type SpecialtiesLazyQueryHookResult = ReturnType<typeof useSpecialtiesLazyQuery>;
export type SpecialtiesQueryResult = Apollo.QueryResult<SpecialtiesQuery, SpecialtiesQueryVariables>;
export const TreatmentsDocument = gql`
    query treatments($country: String!, $area: String, $specialty: String) {
  treatments(country: $country, specialty: $specialty, area: $area) {
    treatment
    count
  }
}
    `;

/**
 * __useTreatmentsQuery__
 *
 * To run a query within a React component, call `useTreatmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsQuery({
 *   variables: {
 *      country: // value for 'country'
 *      area: // value for 'area'
 *      specialty: // value for 'specialty'
 *   },
 * });
 */
export function useTreatmentsQuery(baseOptions: Apollo.QueryHookOptions<TreatmentsQuery, TreatmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsQuery, TreatmentsQueryVariables>(TreatmentsDocument, options);
      }
export function useTreatmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsQuery, TreatmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsQuery, TreatmentsQueryVariables>(TreatmentsDocument, options);
        }
export type TreatmentsQueryHookResult = ReturnType<typeof useTreatmentsQuery>;
export type TreatmentsLazyQueryHookResult = ReturnType<typeof useTreatmentsLazyQuery>;
export type TreatmentsQueryResult = Apollo.QueryResult<TreatmentsQuery, TreatmentsQueryVariables>;
export const TreatmentsInCountriesDocument = gql`
    query treatmentsInCountries {
  navigator {
    treatments {
      id
      displayName
      availableInCountries
      description
      clinicsCounterparts
    }
  }
}
    `;

/**
 * __useTreatmentsInCountriesQuery__
 *
 * To run a query within a React component, call `useTreatmentsInCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsInCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsInCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useTreatmentsInCountriesQuery(baseOptions?: Apollo.QueryHookOptions<TreatmentsInCountriesQuery, TreatmentsInCountriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsInCountriesQuery, TreatmentsInCountriesQueryVariables>(TreatmentsInCountriesDocument, options);
      }
export function useTreatmentsInCountriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsInCountriesQuery, TreatmentsInCountriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsInCountriesQuery, TreatmentsInCountriesQueryVariables>(TreatmentsInCountriesDocument, options);
        }
export type TreatmentsInCountriesQueryHookResult = ReturnType<typeof useTreatmentsInCountriesQuery>;
export type TreatmentsInCountriesLazyQueryHookResult = ReturnType<typeof useTreatmentsInCountriesLazyQuery>;
export type TreatmentsInCountriesQueryResult = Apollo.QueryResult<TreatmentsInCountriesQuery, TreatmentsInCountriesQueryVariables>;
export const TreatmentsPerCountryDocument = gql`
    query treatmentsPerCountry($treatmentId: Int!, $countryCode: String!, $province: String!) {
  navigator {
    treatmentInCountry(
      treatmentId: $treatmentId
      countryCode: $countryCode
      province: $province
    ) {
      treatment {
        id
        displayName
        description
        clinicsCounterparts
        availableInCountries
      }
      countryCode
      countryName
      province
      isLegal
      isCovered
      clinicsAvailable
      healthInsuranceCoverage
      availableTo
      ageRestrictions
      indicativeCosts
      costsTooltip
      additionalInfo
    }
  }
}
    `;

/**
 * __useTreatmentsPerCountryQuery__
 *
 * To run a query within a React component, call `useTreatmentsPerCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreatmentsPerCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreatmentsPerCountryQuery({
 *   variables: {
 *      treatmentId: // value for 'treatmentId'
 *      countryCode: // value for 'countryCode'
 *      province: // value for 'province'
 *   },
 * });
 */
export function useTreatmentsPerCountryQuery(baseOptions: Apollo.QueryHookOptions<TreatmentsPerCountryQuery, TreatmentsPerCountryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TreatmentsPerCountryQuery, TreatmentsPerCountryQueryVariables>(TreatmentsPerCountryDocument, options);
      }
export function useTreatmentsPerCountryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TreatmentsPerCountryQuery, TreatmentsPerCountryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TreatmentsPerCountryQuery, TreatmentsPerCountryQueryVariables>(TreatmentsPerCountryDocument, options);
        }
export type TreatmentsPerCountryQueryHookResult = ReturnType<typeof useTreatmentsPerCountryQuery>;
export type TreatmentsPerCountryLazyQueryHookResult = ReturnType<typeof useTreatmentsPerCountryLazyQuery>;
export type TreatmentsPerCountryQueryResult = Apollo.QueryResult<TreatmentsPerCountryQuery, TreatmentsPerCountryQueryVariables>;
export const ValidatePasswordTokenDocument = gql`
    query validatePasswordToken($uid: String!, $token: String!) {
  validatePasswordToken(uid: $uid, token: $token) {
    isValid
    errorCode
  }
}
    `;

/**
 * __useValidatePasswordTokenQuery__
 *
 * To run a query within a React component, call `useValidatePasswordTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidatePasswordTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidatePasswordTokenQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *      token: // value for 'token'
 *   },
 * });
 */
export function useValidatePasswordTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidatePasswordTokenQuery, ValidatePasswordTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidatePasswordTokenQuery, ValidatePasswordTokenQueryVariables>(ValidatePasswordTokenDocument, options);
      }
export function useValidatePasswordTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidatePasswordTokenQuery, ValidatePasswordTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidatePasswordTokenQuery, ValidatePasswordTokenQueryVariables>(ValidatePasswordTokenDocument, options);
        }
export type ValidatePasswordTokenQueryHookResult = ReturnType<typeof useValidatePasswordTokenQuery>;
export type ValidatePasswordTokenLazyQueryHookResult = ReturnType<typeof useValidatePasswordTokenLazyQuery>;
export type ValidatePasswordTokenQueryResult = Apollo.QueryResult<ValidatePasswordTokenQuery, ValidatePasswordTokenQueryVariables>;
export const WalletTransactionsDocument = gql`
    query walletTransactions {
  me {
    member {
      wallet {
        transactions {
          id
          pliantId
          type
          authorizedAt
          merchantName
          status
          reconciliationStatus {
            label
            value
          }
          billingAmount {
            amount
            currency
          }
          transactionAmount {
            amount
            currency
          }
          coveredTransactionAmount {
            amount
            currency
          }
          foreignExchangeFee {
            amount
            currency
          }
          uploads {
            fileContentType
            fileName
            fileSize
            fileUrl
            id
          }
          comment
        }
      }
    }
  }
}
    `;

/**
 * __useWalletTransactionsQuery__
 *
 * To run a query within a React component, call `useWalletTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletTransactionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletTransactionsQuery(baseOptions?: Apollo.QueryHookOptions<WalletTransactionsQuery, WalletTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletTransactionsQuery, WalletTransactionsQueryVariables>(WalletTransactionsDocument, options);
      }
export function useWalletTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletTransactionsQuery, WalletTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletTransactionsQuery, WalletTransactionsQueryVariables>(WalletTransactionsDocument, options);
        }
export type WalletTransactionsQueryHookResult = ReturnType<typeof useWalletTransactionsQuery>;
export type WalletTransactionsLazyQueryHookResult = ReturnType<typeof useWalletTransactionsLazyQuery>;
export type WalletTransactionsQueryResult = Apollo.QueryResult<WalletTransactionsQuery, WalletTransactionsQueryVariables>;
export const WalletWidgetDocument = gql`
    query walletWidget {
  me {
    member {
      id
      wallet {
        id
        status
        currentCard {
          widgetUrl
        }
      }
    }
  }
}
    `;

/**
 * __useWalletWidgetQuery__
 *
 * To run a query within a React component, call `useWalletWidgetQuery` and pass it any options that fit your needs.
 * When your component renders, `useWalletWidgetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWalletWidgetQuery({
 *   variables: {
 *   },
 * });
 */
export function useWalletWidgetQuery(baseOptions?: Apollo.QueryHookOptions<WalletWidgetQuery, WalletWidgetQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WalletWidgetQuery, WalletWidgetQueryVariables>(WalletWidgetDocument, options);
      }
export function useWalletWidgetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WalletWidgetQuery, WalletWidgetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WalletWidgetQuery, WalletWidgetQueryVariables>(WalletWidgetDocument, options);
        }
export type WalletWidgetQueryHookResult = ReturnType<typeof useWalletWidgetQuery>;
export type WalletWidgetLazyQueryHookResult = ReturnType<typeof useWalletWidgetLazyQuery>;
export type WalletWidgetQueryResult = Apollo.QueryResult<WalletWidgetQuery, WalletWidgetQueryVariables>;